export const messages = {
    "cz": {
      "countryCode": "cz",
      "actionBar": {
        "bar": {
          "inProgress": "Probíhá",
          "latest": "Dokončeno"
        },
        "sideMenu": {
          "saveModifications": "Uložit změny",
          "reportOverview": "Náhled protokolu o stavu",
          "signReport": "Podepsat protokol o stavu",
          "closeReport": "Uzavřít protokol o stavu",
          "countersignReport": "Spolupodepsat protokol o stavu",
          "printReport": "Vytisknout protokol o stavu",
          "deleteReport": "Smazat probíhající protokol",
          "deleteReportOfflineWarning": "Pozor, tato položka není synchronizována!",
          "deleteModificationsNotSynchronized": "Smazat nezesynchronizované změny",
          "duplicateReport": "Duplikovat protokol o stavu",
          "confirmDeletion": "Potvrdit odstranění"
        }
      },
      "alerts": {
        "medias": {
          "failUpload": "Nahrání média se nezdařilo.",
          "failGetIdFromFileName": "Médium bylo nahráno, ale aplikace Skin-Reporter ho nemůže najít."
        },
        "permissions": {
          "camera": {
            "askForPermission": "Aplikace SKR-Condition Report potřebuje povolení k přístupu ke kameře. Toto povolení je nezbytné pro funkce skenování čárových a QR kódů. Bez tohoto povolení tyto funkce nebudou dostupné.",
            "permissionDeniedWarning": "Přístup ke kameře byl dříve aplikaci SKR-Condition Report odepřen. Funkce skenování čárových a QR kódů proto nejsou dostupné. Abyste je mohli používat, prosím povolte přístup ke kameře pro aplikaci SKR-Condition Report ručně."
          }
        },
        "workspace": {
          "unableToChangeWorkspace": "Změna pracovního prostoru se nezdařila",
          "unableToLoadWorkspace": "Načtení pracovního prostoru selhalo"
        }
      },
      "alterationDetailImagePopup": {
        "title": "Podrobné zobrazení poškození {0}"
      },
      "alterationCard": {
        "moreMenu": {
          "deleteAlteration": "Smazat poškození",
          "changeAlterationTitle": "Změnit název poškození",
          "changeAlterationType": "Změnit typ poškození",
          "titleModalHeader": "Upravit název poškození",
          "titleModalButton": "Potvrdit"
        },
        "titleAutoCompletePlaceHolder": "Název"
      },
      archiveCrEditScreenHeader: {
        materialImportance: "MISSING TRANSLATION",
        principalMediumType: "MISSING TRANSLATION",
      },
      archiveEditScreen: {
        saveAlert: {
          errorMessage: "MISSING TRANSLATION",
          successMessage: "MISSING TRANSLATION",
        },
      },
      archiveEditScreenHeader: {
        cote: "MISSING TRANSLATION",
        descriptionLevel: "MISSING TRANSLATION",
      },
      archiveSearchScreen: {
        createNewArchive: "MISSING TRANSLATION",
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Vaše přihlašovací údaje jsou nesprávné",
            "network": "Komunikace se serverem selhala"
          },
          "form": {
            "password": {
              "error": "Zadejte své uživatelské jméno",
              "label": "Heslo"
            },
            "submit": "Přihlásit se",
            "submitting": "Přihlašování...",
            "username": {
              "error": "Zadejte své heslo",
              "label": "Uživatelské jméno"
            }
          }
        },
        "renew": {
          "slowNetwork": "Zdá se, že to trvá déle než obvykle, prosím, nevypínejte aplikaci.",
          "spinner": "Znovu vás připojujeme..."
        },
        "sso": {
          "errors": {
            "authenticationFailed": "Chyba: nelze dokončit ověření."
          },
          "selectIDP": "Přihlásit se pomocí...",
          "otherIDPs": "Jiné typy účtů"
        }
      },
      "autoCompleteTextField": {
        "modal": {
          "okButton": "OK"
        }
      },
      "cameraScanner": {
        "scanCode": "Naskenovat čárový kód",
        "cancel": "Zrušit",
        "errors": {
          "cameraNotFound": "Nebyla zjištěna žádná kamera"
        }
      },
      "closeReportScreen": {
        "important": "DŮLEŽITÉ",
        "close": "Uzavřít",
        "title": "Uzavření protokolu o stavu",
        "notificationContent": "Protokol „{referenceNumber}“ byl uzavřen a stav souvisejícího objektu byl aktualizován.",
        "warningMessage": "Uzavřený protokol nelze upravovat ani odstranit.",
        "warningQuestion": "Opravdu si přejete pokračovat v uzavření protokolu o stavu?",
        "transferingFile": "Přenos souboru PDF...",
        "fileGeneration": "Generování finálního PDF dokumentu...",
        "reportClosing": "Uzavírání protokolu o stavu...",
        "errors": {
          "transitionState": "Při uzavírání protokolu došlo k chybě, ale PDF bylo úspěšně vygenerováno a přidáno k protokolu o stavu.",
          "pushingPDF": "Přidání vygenerovaného PDF k protokolu o stavu se nezdařilo. Uzavření bylo zrušeno."
        }
      },
      "counterSignatureModuleScreen": {
        "title": "Spolupodpis",
        "saveButton": "Potvrdit",
        "warnings": {
          "exit": "Pozor! Pokud opustíte tuto stránku, aktuální práce bude ztracena.",
          "okButton": "Pokračovat",
          "cancelButton": "Zrušit",
          "save": "Jakmile budou spolupodpisy uloženy, nebude je již možné později upravit!"
        }
      },
      createArchiveModal: {
        creationFailed: "MISSING TRANSLATION",
        descriptionLevel: "MISSING TRANSLATION",
        submitBtn: "MISSING TRANSLATION",
        submitting: "MISSING TRANSLATION",
        title: "MISSING TRANSLATION",
      },
      "defectTree": {
        "alteration": {
          "alterationLabel": "Typ:",
          "alterationsTitle": "Poškození:",
          "createAlterationButtonLabel": "Poškození",
          "levelTitle": "Úroveň 3",
          "precisionLabel": "Upřesnění:",
          "deleteConfirmationMessage": "Potvrdit smazání poškození a jeho obsahu?",
          "precisionPlaceholder": "Vyberte podtyp",
          "thesaurusTermWarningMessage": "Vybraný typ poškození neodpovídá výše uvedenému materiálu",
          "typeOfAlterationPlaceholder": "Vyberte typ pozorování"
        },
        "annotation": {
          "annotationsTitle": "Poznámky:",
          "commentsPlaceholder": "Upřesněte...",
          "deleteConfirmationMessage": "Potvrdit smazání?",
          "defaultImageConfirmationMessage": "Nastavit jako výchozí obrázek?"
        },
        "defect": {
          "createElementButtonLabel": "Prvek",
          "deleteConfirmationMessage": "Potvrdit smazání prvku a jeho obsahu?",
          "elementLabel": "Prvek:",
          "precisionLabel": "Upřesnění",
          "elementPlaceholder": "Název prvku",
          "precisionPlaceholder": "Upřesněte..."
        },
        "material": {
          "createMaterialButtonLabel": "Materiál",
          "deleteConfirmationMessage": "Potvrdit smazání materiálu a jeho obsahu?",
          "levelTitle": "Úroveň 2",
          "materialLabel": "Materiál:",
          "materialsTitle": "Materiály:",
          "thesaurusTermWarningMessage": "Vybraný materiál neodpovídá výše uvedenému typu pozorování"
        },
        "observation": {
          "createObservationButtonLabel": "Pozorování",
          "deleteConfirmationMessage": "Potvrdit smazání pozorování a jeho obsahu?",
          "levelTitle": "Úroveň 1",
          "observationLabel": "Typ pozorování:",
          "observationsTitle": "Pozorování:"
        },
        "submit": "Uložit změny",
        "submitError": "Strom se nepodařilo aktualizovat",
        "submitting": "Probíhá ukládání..."
      },
      "drawingEditor": {
        "title": "Podrobné poškození",
        "imageCaption": "Legenda:",
        "imageTitlePlaceholder": "Zadejte popisek obrázku",
        "alterationLabel": "{index}",
        "alterationModalTitle": "Vyberte poškození",
        "observationPlaceholder": "Zadejte pozorování",
        "validate": "Uložit",
        "errors": {
          "alteration": "Poškození",
          "missingTitleOrType": "Vyplňte název nebo typ poškození pro každé poškození.",
          "failedUploadDetailedImageDescription": "Nahrávání {0} detailních obrázků poškození {1} se nezdařilo"
        },
        "alterationLine": {
          "precisionModal": {
            "title": "Upřesnění",
            "validateButton": "Potvrdit"
          },
          "titlePlaceHoder": "Název poškození...",
          "typeOfAlterationPlaceholder": "Typ poškození..."
        }
      },
      "editItemScreen": {
        "author": "Autor",
        "confirmButton": "Potvrdit",
        "editButton": "Upravit",
        "inventoryNumber": "Inventární číslo",
        "saveNotification": {
          "errorMessage": "Při ukládání objektu došlo k chybě",
          "inventoryNumberNotUnique": "Nelze potvrdit, identifikační číslo záznamu již existuje",
          "successMessage": "Objekt byl úspěšně uložen"
        },
        "sections": {
          "creation": "Vytvoření",
          "description": "Popis",
          "identification": "Identifikace",
          "location": "Lokace",
          "notes": "Poznámky",
          "state": "Stav"
        },
        "deleteNotification": {
          "errorMessage": "Při mazání nesynchronizovaných objektů došlo k chybě",
          "successMessage": "Objekt byl úspěšně odstraněn"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Při mazání nesynchronizovaných změn došlo k chybě",
          "successMessage": "Změny byly zrušeny"
        },
        "errorMessages": {
          "inventoryNumberNotUnique": "Toto inventární číslo je již přiřazeno"
        },
        "menu": {
          "saveModifications": "Uložit změny",
          "deleteNotSynchronizedNewItem": "Odstranit nový objekt",
          "deleteModificationsNotSynchronized": "Odstranit nesynchronizované změny",
          "offlineWarning": "Změny jsou uloženy v zařízení, bude nutné je synchronizovat s databází po obnovení připojení.",
          "offlineShortWarning": "Upraveno v tomto zařízení"
        },
        "fieldDisabledOffline": "Tento údaj nelze zadat v offline režimu"
      },
      "editReportScreen": {
        "alerts": {
          "duplicateClosedReport": {
            "success": "Protokol byl úspěšně duplikován",
            "failure": "Duplikace protokolu se nezdařila",
            "warningReportNotClosed": "Protokol musí být uzavřen, aby jej bylo možné duplikovat"
          }
        },
        "reportTitlePrefix": "Protokol č. {refNumber}",
        "reportStatusInProgress": "Probíhá",
        "reportIdentifiers": {
          "accordionPanelTitle": "IDENTIFIKÁTORY PROTOKOLU",
          "referenceNumber": "Referenční číslo",
          "numberingInformation": "Ponechte prázdné pro automatické číslování při dalším uložení",
          "otherIdentifiers": "Další identifikátory",
          "reportReason": "Důvod protokolu",
          "precision": "Upřesnění",
          "reportType": "Typ protokolu",
          "reportTypePlaceholder": "Vyberte typ protokolu",
          "tabTitle": "Identifikace"
        },
        "reportContext": {
          "accordionPanelTitle": "KONTEXT PROTOKOLU O STAVU",
          "reportDate": "Datum protokolu",
          "reportDoneInThePresenceOf": "Protokol proveden v přítomnosti",
          "andOf": "A také",
          "name": "Jméno/Příjmení, Funkce",
          "role": "Funkce",
          "coordinates": "Kontaktní údaje",
          "email": "Email",
          "signer": "Podepisující",
          "reportPlace": "Místo protokolu",
          "customer": "Zákazník/Zadavatel",
          "precisions": "Upřesnění",
          "linkedProject": "Související projekt",
          "linkedMovement": "Související pohyb",
          "technicsAndMaterials": "Použité techniky a materiály",
          "comments": "Komentáře",
          "signerComponent": {
            "name": "Podepisující",
            "date": "Datum podpisu",
            "positionOfSignatory": "Funkce podepisujícího",
            "title": "Podepisující"
          },
          "counterSignatureComponent": {
            "comment": "Komentář",
            "location": "Místo",
            "reason": "Důvod",
            "date": "Datum"
          },
          "counterSignaturesComponent": {
            "title": "Protipodpisy"
          },
          "counterSignerComponent": {
            "name": "Jméno/příjmení",
            "function": "Funkce",
            "signature": "Podpis"
          },
          "counterSignersComponent": {
            "title": "Protokol proveden v přítomnosti:"
          }
        },
        "alterations": {
          "accordionPanelTitle": "POŠKOZENÍ",
          "mediasSectionTitle": "OBRÁZKY PROTOKOLU",
          "globalAlterationSectionTitle": "OBECNÁ POŠKOZENÍ",
          "createAlterationForm": {
            "createAlterationButtonTitle": "Vytvořit",
            "alterationTypeLabel": "Typ poškození",
            "precisionLabel": "Upřesnění"
          },
          "tabTitle": "Poškození",
          "viewMenu": {
            "alterationTypeView": "Zobrazení podle typu poškození",
            "imageView": "Zobrazení fotografií",
            "titleView": "Zobrazení podle názvu"
          }
        },
        "conservation": {
          "accordionPanelTitle": "KONZERVACE A MANIPULACE"
        },
        "observations": {
          "tabTitle": "Souhrn",
          "accordionPanelTitle": "REPORT A POZOROVÁNÍ",
          "commentsFieldLabel": "Komentáře",
          "countersignature": "Protipodpisy",
          "interventionToSchedule": "Plánované zásahy",
          "interventionToSchedulePlaceholder": "Vyberte zásah",
          "interventionToSchedulePrecision": "Upřesnění:",
          "stateOfConservation": "Stav předmětu",
          "stateOfConservationPlaceholder": "Vyberte stav",
          "signature": "Podpisy",
          "typeOfStateOfConservation": "Typ stavu",
          "treatmentPriority": "Priorita zásahu",
          "treatmentPriorityPlaceholder": "Vyberte prioritu"
        },
        "medias": {
          "accordionPanelTitle": "MÉDIA"
        },
        "saveAlert": {
          "errorMessage": "Při ukládání protokolu došlo k chybě",
          "inventoryNumberNotUnique": "Nelze potvrdit, identifikační číslo protokolu již existuje",
          "successMessage": "Protokol o stavu uložen"
        },
        "deleteAlert": {
          "errorMessage": "Při mazání protokolu došlo k chybě",
          "successMessage": "Protokol o stavu odstraněn"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Při mazání nesynchronizovaných změn došlo k chybě",
          "successMessage": "Změny byly zrušeny"
        },
        "fieldDisabledOffline": "Tento údaj nelze zadat v offline režimu",
        "pdf": {
          "counterSignaturePDF": {
            "startGenerating": "Generování PDF bylo spuštěno",
            "success": "Generování PDF dokončeno úspěšně",
            "failure": "Generování PDF se nezdařilo"
          }
        }
      },
      "editRecordScreen": {
        "foldAll": "Sbalit vše",
        "unfoldAll": "Rozbalit vše",
        "medias": {
          "accordionPanelTitle": "MÉDIA"
        }
      },
      "firewall": {
        "collabWarningMessage": "Váš účet nemá přiřazeného spolupracovníka, aplikace nemusí fungovat správně",
        "noGroupForUserWarningMessage": "Používání SKINreporteru vyžaduje, aby byl váš účet propojen se skupinou uživatelů"
      },
      genericEditScreen: {
        genericErrorMsg: "MISSING TRANSLATION",
        saveErrorMsg: "MISSING TRANSLATION",
        saveSuccessMsg: "MISSING TRANSLATION",
      },
      "itemCreationImagePopup": {
        "title": "Přidat obrázek",
        "addImage": "PŘIDAT OBRÁZEK",
        "ignore": "POZDĚJI, PŘESKOČIT TENTO KROK"
      },
      "itemSearchScreen": {
        "createNewItem": "VYTVOŘIT NOVÝ OBJEKT"
      },
      "listReportScreen": {
        "closed": {
          "downloadFailure": "Při stahování došlo k chybě",
          "downloadSuccess": "Dokument {docTitle} byl stažen",
          "open": "STÁHNOUT DOKUMENT",
          "title": "Dokončené protokoly o stavu"
        },
        "inProgress": {
          "edit": "UPRAVIT PROTOKOL",
          "title": "Protokoly o stavu ve fázi úprav"
        },
        "concernedItem": "Dotčený muzejní objekt",
        "nbResults": "{nbResults} výsledků",
        "noResults": "Žádný výsledek"
      },
      "locationSelector": {
        "inputPlaceholder": "Zadejte lokaci",
        "title": "Vyberte lokaci",
        "validate": "Potvrdit"
      },
      "maskFields": {
        "boolean": {
          "no": "Ne",
          "undefined": "Nedefinováno",
          "yes": "Ano"
        },
        "entitySelect": {
          "modalPlaceholder": "Klíčová slova nebo identifikátory..."
        }
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Nasazeno dne",
          "checkForUpdate": {
            "help": "Pokud je dostupná aktualizace, nainstaluje se automaticky.",
            "title": "Zkontrolovat aktualizace"
          },
          "clearCache": {
            "help": "Pokud jste offline, ztratíte přístup ke všem datům uloženým v zařízení.",
            "title": "Vyprázdnit mezipaměť"
          },
          "overrideLocale": {
            "help": "Bude použita angličtina a nastavení vašeho zařízení bude ignorováno.",
            "title": "Vynutit anglický jazyk"
          },
          "resetLocaleOverride": {
            "help": "Použitý jazyk bude odpovídat nastavení vašeho zařízení",
            "title": "Obnovit výchozí jazyk"
          },
          "serviceWorker": {
            "help": "Panel s aktualizací se zobrazuje neustále? Klikněte zde!",
            "title": "Zavřít panel aktualizace"
          },
          "title": "Skin-REPORTER",
          "version": "verze"
        },
        "logout": "Opravdu se chcete odhlásit?"
      },
      "offlineRibbon": {
        "offline": "Jste offline",
        "online": "Jste připojeni"
      },
      "pdfOverviewScreen": {
        "download": "Stáhnout",
        "progressBar": {
          "mainLabel": "Generování dokumentu ...",
          "object": "Objekt",
          "generalDigest": "Celkové hodnocení",
          "defects": "Poškození",
          "contextAndSignatures": "Kontext",
          "documentReady": "Dokument připraven!"
        },
        "title": "Náhled",
        "renderFailureAlert": "PDF nelze zobrazit, zkuste to znovu později"
      },
      "pdfDocument": {
        "mainTitlePrefix": "PROTOKOL O STAVU -",
        "objectSection": {
          "sectionTitle": "Objekt",
          "inventoryNumber": "Inventární číslo:",
          "title": "Název:",
          "author": "Umělec/Autor:",
          "creationDate": "Datum vzniku:",
          "typology": "Typologie:",
          "denomination": "Označení:",
          "materialsAndTechniques": "Materiály a techniky:",
          "dimensions": "Rozměry:",
          "institution": "Instituce:",
          "conditioning": "Balení:",
          "descriptions": "Popis(y):",
          "domains": "Obor(y):",
          "identification": "Identifikace:",
          "location": "Lokace:",
          "materials": "Materiál(y):",
          "ownerInstitutions": "Vlastnická instituce(e):",
          "techniques": "Technika(y):"
        },
        "alterationsSection": {
          "detailedAlteration": "Podrobné poškození",
          "noAnnotation": "Žádné poznámky k zobrazení",
          "observationLabel": "Pozn.",
          "sectionTitle": "Poškození"
        },
        archiveSection: {
          sectionTitle: "MISSING TRANSLATION",
          archiveType: "MISSING TRANSLATION",
          conditioning: "MISSING TRANSLATION",
          cote: "MISSING TRANSLATION",
          descriptionLevel: "MISSING TRANSLATION",
          location: "MISSING TRANSLATION",
          materialImportance: "MISSING TRANSLATION",
          parentArchive: "MISSING TRANSLATION",
          productors: "MISSING TRANSLATION",
          productionDate: "MISSING TRANSLATION",
          proprietaryInstitution: "MISSING TRANSLATION",
          supportType: "MISSING TRANSLATION",
          title: "MISSING TRANSLATION",
        },
        "detailedViewsSection": {
          "sectionTitle": "Podrobnosti poškození"
        },
        "finalObservationsSection": {
          "sectionTitle": "Závěrečná pozorování"
        },
        "conditioningSection": {
          "crateNumber": "Číslo bedny:",
          "sectionTitle": "Balení",
          "transportAccessories": "Pomůcky pro přepravu:",
          "typeOfPackaging": "Typ obalu:"
        },
        "contextSection": {
          "comments": "Komentáře:",
          "editors": "Zpracovatelé:",
          "matAndTechs": "Materiály a techniky:",
          "reportDate": "Datum protokolu:",
          "reportPlace": "Místo:",
          "reportReference": "Referenční číslo protokolu:",
          "reportType": "Typ protokolu:",
          "reportReason": "Důvod protokolu:",
          "sectionTitle": "Kontext tohoto protokolu o stavu",
          "signers": "Podepisující:"
        },
        "reportSection": {
          "counterSignaturesTitle": "Protipodpisy",
          "counterSignature": {
            "comment": "Komentář:"
          },
          "interventionsToSchedule": "Plánované zásahy:",
          "sectionTitle": "Report",
          "signatoriesTitle": "Protokol proveden v přítomnosti:",
          "stateOfConservation": "Stav předmětu:",
          "treatmentPriority": "Priorita zásahu:"
        },
        "footer": {
          "prefix": "PROTOKOL O STAVU",
          "separator": "– Strana"
        },
        "generationFailureAlert": "Generování PDF se nezdařilo, zkuste to prosím znovu později"
      },
      "proxy": {
        "error": {
          "default": "Došlo k chybě u zdroje {uri}",
          "network": "Spojení se serverem se nezdařilo",
          "notFound": "Zdroj {uri} nebyl nalezen",
          "tokenHasExpired": "Vaše relace vypršela"
        }
      },
      "search": {
        "noResults": "Žádný výsledek",
        "options": {
          "sortType": {
            "creationDate": "Datum vytvoření",
            "identifier": "Hlavní identifikátor",
            "lastModification": "Poslední úprava",
            "mainTitle": "Hlavní název",
            "referenceNumber": "Referenční číslo"
          }
        },
        "queryPlaceholder": "Klíčová slova nebo inventární číslo",
        "title": "Muzejní objekty",
        "totalCount": "{totalResults} Výsledek(y): 1 -"
      },
      "searchFeaturedCard": {
        "consultLastReport": "ZOBRAZIT POSLEDNÍ UZAVŘENÝ PROTOKOL",
        "createNewReport": "VYTVOŘIT NOVÝ PROTOKOL",
        "createNewReportFromLast": "PROTOKOL Z POSLEDNÍHO PROTOKOLU",
        "institutionLabel": "Instituce",
        "lastReportLabel": "Poslední protokol o stavu",
        "materialsAndTechniques": "Materiály / Techniky",
        "measurements": "Rozměry",
        "noLinkedItem": "K tomuto protokolu o stavu není přiřazena žádná položka"
      },
      "selectItemErrorDialog": {
        "cancel": "Zrušit objekt",
        "cancelAll": "Zrušit všechny objekty",
        "description": "Výběr {0} objektů se nezdařil.",
        "retry": "Zkusit znovu pro tento objekt",
        "retryAll": "Zkusit znovu pro všechny objekty",
        "title": "Chyba při výběru obrázků"
      },
      "serviceWorker": {
        "updateAvailable": "Byla nainstalována aktualizace. Klikněte zde pro obnovení stránky nebo restartujte aplikaci.",
        "forceServiceWorkerUpdate": {
          "modalTitle": "Řešení problému",
          "versionCorrect": "Odpovídají níže uvedené informace verzi a datu sdělenému společností SKINsoft po poslední aktualizaci?",
          "yes": "Ano",
          "no": "Ne"
        }
      },
      "signatureModuleScreen": {
        "cardTitle": "Podepisující",
        "eraseSignature": "Znovu podepsat",
        "missingSignature": "Chybějící podpis",
        "nameLabel": "Podepisující",
        "positionOfSignatory": "Funkce podepisujícího",
        "presentSignature": "Podpis přítomen",
        "saveSignature": "Uložit",
        "signatureStatus": "Stav podpisu",
        "title": "Podpisy"
      },
      "synchroModal": {
        "title": "Synchronizace",
        "lastFetch": "Poslední načtení",
        "duration": "Doba trvání",
        "status": "Stav",
        "details": "Podrobnosti",
        "lastSynchro": "Poslední synchronizace",
        "noEntityToSync": "Žádné entity k synchronizaci",
        "connectionWarningPrefix": "Pro odesílání nebo načítání dat musíte být připojeni k internetu",
        "connectWarningSend": "odeslat",
        "connectWarningRetrieve": "načíst",
        "connectionWarningSuffix": "data",
        "noDataToSync": "Momentálně nejsou žádná data k synchronizaci",
        "localIconInfoPrefix": "Ikona",
        "localIconInfoSuffix": " označuje data, která byla lokálně upravena a musí být synchronizována se vzdálenou databází.",
        "retrieveAll": "Načíst vše",
        "finishedSynchros": "Synchronizace dokončeny",
        "syncAll": "Synchronizovat vše",
        "remainsToSynchronize": "Zbývá synchronizovat",
        "cleanImageCache": "Odstranit „duchovité“ obrázky z mezipaměti",
        "cachedImagedCleaned": "„Duchovité“ obrázky byly odstraněny!",
        "cleanCacheDown": "Vyprázdnit mezipaměť",
        "cacheDownCleaned": "Mezipaměť byla vyprázdněna",
        "cleanCacheUp": "Odstranit všechny nesynchronizované změny",
        "cacheUpCleaned": "Všechny nesynchronizované změny byly odstraněny"
      },
      "entityNames": {
        "items": "Položky",
        archives: "MISSING TRANSLATION",
        "auditRecords": "Karty revize sbírek",
        "audits": "Projekty revize sbírek",
        "thesaurusTerms": "Pojmy tezauru",
        "thesaurus": "Tezaurus",
        "entityFields": "Systémová data",
        "collaborators": "Spolupracovníci",
        "authorities": "Autority",
        "aliases": "Aliasy",
        "locations": "Lokace",
        "conditionReports": "Protokoly o stavu",
        "works": "Díla",
        "expressions": "Vyjádření",
        "manifestations": "Manifestace",
        "specimens": "MISSING TRANSLATION"
      },
      "time": {
        "hours": "hodina(y)",
        "minutes": "minuta(y)",
        "seconds": "sekunda(y)"
      },
      "thesaurusTermCreateForm": {
        "formTitle": "Vytvoření pojmu",
        "openButtonTitle": "Vytvořit pojem",
        "createButton": "Potvrdit",
        "anotherTermButton": "Potvrdit a vytvořit další pojem",
        "cancelButton": "Zrušit",
        "preferedTermLabel": "Preferovaný pojem:",
        "synonymLabel": "Použit pro:",
        "genericTermPlaceholder": "Nadřazený pojem:",
        "selectSpecificLabel": "Vybrat podřízené pojmy",
        "disabledOffline": "Vytváření nového pojmu není dostupné v offline režimu aplikace"
      },
      "thesaurusTermTree": {
        "creationTabTitle": "Vytvoření",
        "errors": {
          "searchError": "Vyhledávání se nezdařilo",
          "fetchError": "Nelze načíst pojmy tezauru"
        },
        "modalSearchInputPlaceholder": "Vyhledat pojem",
        "selectionTabTitle": "Výběr",
        "thesaurusTermSelectorModalTitle": "Vybrat pojem",
        "validate": "Potvrdit"
      },
      "uploadImageFailureDialog": {
        "cancel": "Zrušit obrázek {0}",
        "cancelAll": "Zrušit všechny obrázky",
        "description": "Nahrávání {0} obrázků se nezdařilo.",
        "imageAndNumber": "Obrázek {0}",
        "retry": "Zkusit znovu pro obrázek {0}",
        "retryAll": "Zkusit znovu pro všechny obrázky",
        "title": "Nahrávání obrázků se nezdařilo"
      },
      "state": {
        "all": "Vše",
        "archived": "Archivováno",
        "canceled": "Zrušeno",
        "finalized": "Dokončeno",
        "inPreparation": "V přípravě",
        "inProgress": "Probíhá",
        "programmed": "Plánováno",
        "toValidated": "K potvrzení",
        "validated": "Potvrzeno",
        "aborted": "Přerušeno",
        "success": "Úspěšně dokončeno",
        "error": "Chyba",
        "none": "Žádná předchozí synchronizace"
      },
      "SpecimenSearchScreen": {
        "createNewSpecimen": "MISSING TRANSLATION"
      },
    },
    "en": {
      "countryCode": "gb",
      "actionBar": {
        "bar": {
          "inProgress": "Drafts",
          "latest": "Closed Reports"
        },
        "sideMenu": {
          "saveModifications": "Save Modifications",
          "reportOverview": "Condition Report Overview",
          "signReport": "Sign Condition Report",
          "closeReport": "Close Condition Report",
          "countersignReport": "Countersign the condition report",
          "printReport": "Print Condition Report",
          "deleteReport": "Delete current Condition Report",
          "deleteReportOfflineWarning": "Warning, this element is not synchronized !",
          "deleteModificationsNotSynchronized": "Delete unsynchronized modifications",
          "duplicateReport": "Duplicate the condition report",
          "confirmDeletion": "Confirm deletion"
        }
      },
      "alerts": {
        "medias": {
          "failUpload": "Failed to upload the media.",
          "failGetIdFromFileName": "The media has been uploaded, but Skin-Reporter cannot find it.",
        },
        "permissions": {
          "camera": {
            askForPermission: "SKR-Condition Report needs permission to access the camera. This permission is necessary for the barcode/QR-code scanning functionalities. Without this permission these functions cannot be provided.",
            permissionDeniedWarning: "Permission to access the camera has previously been denied to SKR-Condition Report. Barcode/QR-code scanning functionalities are therefore not available. To be able to access them, please manually authorise access to the camera for SKR-Condition Report.",
          }
        },
        "workspace": {
          "unableToChangeWorkspace": "Failed to change workspace",
          "unableToLoadWorkspace": "Failed to load workspace",
        },
      },
      alterationDetailImagePopup: {
        title: "Detailed views of alteration {0}",
      },
      "alterationCard": {
        "moreMenu": {
          "deleteAlteration": "Delete alteration",
          "changeAlterationTitle": "Change alteration title",
          "changeAlterationType": "Change alteration type",
          "titleModalHeader": "Edit alteration title",
          "titleModalButton": "Validate"
        },
        titleAutoCompletePlaceHolder: "Title",
      },
      archiveCrEditScreenHeader: {
        materialImportance: "MISSING TRANSLATION",
        principalMediumType: "MISSING TRANSLATION",
      },
      archiveEditScreen: {
        saveAlert: {
          errorMessage: "MISSING TRANSLATION",
          successMessage: "MISSING TRANSLATION",
        },
      },
      archiveEditScreenHeader: {
        cote: "MISSING TRANSLATION",
        descriptionLevel: "MISSING TRANSLATION",
      },
      archiveSearchScreen: {
        createNewArchive: "MISSING TRANSLATION",
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Username and/or password incorrect",
            "network": "Communication with server has failed"
          },
          "form": {
            "password": {
              "error": "Please enter your username",
              "label": "Password"
            },
            "submit": "Log in",
            "submitting": "Logging in",
            "username": {
              "error": "Please enter your password",
              "label": "Username"
            }
          }
        },
        "renew": {
          "slowNetwork": "This is taking more time than usual. Please do not quit the application.",
          "spinner": "Getting you back online"
        },
        sso: {
          errors: {
            authenticationFailed: "Error: unable to complete authentication."
          },
          selectIDP: "Log in with...",
          otherIDPs: "Other account types",
        }
      },
      autoCompleteTextField: {
        modal: {
          okButton: "Ok",
        },
      },
      cameraScanner: {
        scanCode: "Scan the barcode",
        cancel: "Cancel",
        errors: {
          cameraNotFound: "No camera detected",
        },
      },
      "closeReportScreen": {
        "important": "IMPORTANT",
        "close": "Close Condition Report",
        "title": "Close Condition Report",
        "notificationContent": "The condition report '{referenceNumber}' has been closed and the status of the linked object has been updated.",
        "warningMessage": "Once closed, the Condition Report cannot be modified nor deleted ",
        "warningQuestion": "Are you sure that you want to close the Condition Report?",
        "transferingFile": "Transfering PDF document...",
        "fileGeneration": "Generating final PDF document...",
        "reportClosing": "Closing the current condition report...",
        errors: {
          transitionState: "An error occurred when closing the report. The PDF was generated and added to the status report.",
          pushingPDF: "The PDF generated was not added to the status report. Closure aborted.", 
        },
      },
      counterSignatureModuleScreen: {
        title: "Countersignature",
        saveButton: "Save",
        warnings: {
          exit: 'Warning! If you leave the page, your current work will be lost.',
          okButton: 'Continue',
          cancelButton: 'Cancel',
          save: 'Once the countersignatures have been saved, they cannot be changed at a later date!',
        },
      },
      createArchiveModal: {
        creationFailed: "MISSING TRANSLATION",
        descriptionLevel: "MISSING TRANSLATION",
        submitBtn: "MISSING TRANSLATION",
        submitting: "MISSING TRANSLATION",
        title: "MISSING TRANSLATION",
      },
      "defectTree": {
        "alteration": {
          "alterationLabel": "Type of Damage: ",
          "alterationsTitle": "Damages: ",
          "createAlterationButtonLabel": "Damage",
          "levelTitle": "Level 3",
          "precisionLabel": "Detail:",
          "deleteConfirmationMessage": "Confirm deletion of damage",
          "precisionPlaceholder": "Select sub-category",
          "thesaurusTermWarningMessage": "The selected damage does not match the material",
          "typeOfAlterationPlaceholder": "Select type of Observation"
        },
        "annotation": {
          "annotationsTitle": "Annotations:",
          "commentsPlaceholder": "Precise…",
          "deleteConfirmationMessage": "Confirm deletion ?",
          "defaultImageConfirmationMessage": "Set as default image ?"
        },
        "defect": {
          "createElementButtonLabel": "Zone",
          "deleteConfirmationMessage": "Confirm deletion of zone",
          "elementLabel": "Zone:",
          "precisionLabel": "Detail",
          "elementPlaceholder": "Name of Element",
          "precisionPlaceholder": "Précisez..."
        },
        "material": {
          "createMaterialButtonLabel": "Material ",
          "deleteConfirmationMessage": "Confirm deletion of material",
          "levelTitle": "Level 2",
          "materialLabel": "Material:",
          "materialsTitle": "Materials:",
          "thesaurusTermWarningMessage": "The selected material does not match the type of observation"
        },
        "observation": {
          "createObservationButtonLabel": "Observation",
          "deleteConfirmationMessage": "Confirm deletion of observation",
          "levelTitle": "Level 1",
          "observationLabel": "Type of Observation:",
          "observationsTitle": "Observations:"
        },
        "submit": "Save modifications",
        "submitError": "Defects could not be updated",
        "submitting": "Saving…"
      },
      "drawingEditor": {
        "title": "Detailed Damage",
        "imageCaption": "Caption:",
        "imageTitlePlaceholder": "Type image caption",
        "alterationLabel": "{index}",
        "alterationModalTitle": "Select a damage",
        "observationPlaceholder": "Enter Observation",
        "validate": "Save",
        "errors": {
          alteration: "Alteration ",
          "missingTitleOrType": "A title or a type of alteration is required for every alterations.",
          failedUploadDetailedImageDescription: "The upload of {0} images of detailed views of alterations {1} has failed",
        },
        "alterationLine": {
          "precisionModal": {
            "title": "Further information",
            "validateButton": "Validate"
          },
          "titlePlaceHoder": "Alteration title...",
          "typeOfAlterationPlaceholder": "Select a type of alteration..."
        }
      },
      "editItemScreen": {
        "author": "Author",
        "confirmButton": "Save",
        "editButton": "Edit",
        "inventoryNumber": "Inventory Number",
        "saveNotification": {
          "errorMessage": "En error occured while saving the item",
          "inventoryNumberNotUnique": "Impossible validation",
          "successMessage": "Item successfully saved"
        },
        sections: {
          creation: "Creation",
          description: "Description",
          identification: "Identification",
          location: "Location",
          notes: "Notes",
          state: "Object condition",
        },
        "deleteNotification": {
          "errorMessage": "TRANSLATING IN PROGRESS",
          "successMessage": "TRANSLATING IN PROGRESS"
        },
        "deleteModificationsNotification": {
          "errorMessage": "An error occured when deleting unsynchronized modifications",
          "successMessage": "Modifications have been deleted"
        },
        "errorMessages": {
          "inventoryNumberNotUnique": "This inventory number is already attributed"
        },
        "menu": {
          "saveModifications": "Save modifications",
          "deleteNotSynchronizedNewItem": "TRANSLATING IN PROGRESS",
          "deleteModificationsNotSynchronized": "Delete unsynchronized modifications",
          "offlineWarning": "Modifications are saved on this device, you will have to synchronize them with the database when the network is back.",
          "offlineShortWarning": "Modified on this device"
        },
        "fieldDisabledOffline": "This field is not available in offline mode"
      },
      "editReportScreen": {
        "alerts": {
          duplicateClosedReport: {
            success: "The report has been successfully duplicated",
            failure: "Duplication of the report failed",
            warningReportNotClosed: "The report must be closed before it can be duplicated",
          }
        },
        "reportTitlePrefix": "Report N° {refNumber}",
        "reportStatusInProgress": "In Progress",
        "reportIdentifiers": {
          "accordionPanelTitle": "GENERAL INFORMATION",
          "referenceNumber": "Reference Number",
          "numberingInformation": "Leave this field blank to activate the automated numbering once the report has been saved",
          "otherIdentifiers": "Other Identifiers",
          "reportReason": "Reason of Condition Report",
          "precision": "Detail",
          "reportType": "Report type",
          "reportTypePlaceholder": "Select a report type",
          "tabTitle": "Identification"
        },
        "reportContext": {
          "accordionPanelTitle": "CONTEXT",
          "reportDate": "Date of report",
          "reportDoneInThePresenceOf": "Report written in the presence of",
          "andOf": "and",
          "name": "Name/Surname, Role",
          "role": "Role",
          "coordinates": "Contact info",
          "email": "Email",
          "signer": "Persons authorized to sign the report",
          "reportPlace": "Place",
          "customer": "Customer",
          "precisions": "Details",
          "linkedProject": "Related Project",
          "linkedMovement": "Related Movement",
          "technicsAndMaterials": "Techniques and Materials",
          "comments": "Comments",
          "signerComponent": {
            "name": "Signatory",
            "date": "Date of signature",
            "positionOfSignatory": "Function of signatory",
            "title": "Signatory(ies)",
          },
          counterSignatureComponent: {
            comment: "Comment",
            location: "Location",
            reason: "Reason",
            date: "Date",
          },
          counterSignaturesComponent: {
            title: "Counter-signatures",
          },
          "counterSignerComponent": {
            "name": "Surname/First name",
            "function": "Function",
            signature: 'Signature',
          },
          counterSignersComponent: {
            title: "Report made in presence of :",
          },
        },
        "alterations": {
          "accordionPanelTitle": "DAMAGES",
          "mediasSectionTitle": "REPORT's IMAGES",
          "globalAlterationSectionTitle": "GENERAL DAMAGES",
          "createAlterationForm": {
            "createAlterationButtonTitle": "Create",
            "alterationTypeLabel": "Damage type",
            "precisionLabel": "Precision"
          },
          "tabTitle": "Alterations",
          "viewMenu": {
            "alterationTypeView": "Alteration type view",
            "imageView": "Image view",
            "titleView": "Title view"
          }
        },
        "conservation": {
          "accordionPanelTitle": "CONSERVATION AND MANIPULATION"
        },
        "observations": {
          "tabTitle": "Report",
          "accordionPanelTitle": "GENERAL OBSERVATIONS & RECOMMENDATIONS",
          "commentsFieldLabel": "Comments",
          "countersignature": "Counter-signatures",
          "interventionToSchedule": "Scheduled interventions",
          "interventionToSchedulePlaceholder": "Choose an intervention",
          "interventionToSchedulePrecision": "Precision :",
          "stateOfConservation": "State of conservation",
          "stateOfConservationPlaceholder": "Choose a state",
          "signature": "Signatures",
          "typeOfStateOfConservation": "Type of state",
          "treatmentPriority": "Treatment priority",
          "treatmentPriorityPlaceholder": "Choose a priority"
        },
        "medias": {
          "accordionPanelTitle": "ATTACHED MULTIMEDIA"
        },
        "saveAlert": {
          "errorMessage": "An error occurred when saving the Condition Report",
          "inventoryNumberNotUnique": "Impossible validation",
          "successMessage": "Condition Report has been saved"
        },
        "deleteAlert": {
          "errorMessage": "An error occurred when deleting the Condition Report",
          "successMessage": "Condition Report has been deleted"
        },
        "deleteModificationsNotification": {
          "errorMessage": "An error occured when deleting unsynchronized modifications",
          "successMessage": "Modifications have been cancelled"
        },
        "fieldDisabledOffline": "This field is not available in offline mode",
        pdf: {
          counterSignaturePDF: {
            startGenerating: "PDF generation has started",
            success: "PDF generation completed successfully",
            failure: "PDF generation failed",
          }
        },
      },
      "editRecordScreen": {
        "foldAll": "Fold all",
        "unfoldAll": "Unfold all",
        "medias": {
          "accordionPanelTitle": "ATTACHED MULTIMEDIA"
        }
      },
      "firewall": {
        "collabWarningMessage": "Your account doesn't any associated collaborator, the app may be disfunctionning",
        "noGroupForUserWarningMessage": "You user account needs to be part of group of users to be able to user SKINreporter"
      },
      genericEditScreen: {
        genericErrorMsg: "MISSING TRANSLATION",
        saveErrorMsg: "MISSING TRANSLATION",
        saveSuccessMsg: "MISSING TRANSLATION",
      },
      "itemCreationImagePopup": {
        "title": "Add an image",
        "addImage": "ADD AN IMAGE",
        "ignore": "LATER, IGNORE THIS STAGE"
      },
      "itemSearchScreen": {
        "createNewItem": "CREATE NEW ITEM"
      },
      "listReportScreen": {
        "closed": {
          "downloadFailure": "An error occured during the document downloading",
          "downloadSuccess": "The document {docTitle} has been dowloaded",
          "open": "OPEN DOCUMENT",
          "title": "Completed Condition Reports"
        },
        "inProgress": {
          "edit": "EDIT CONDITION REPORT",
          "title": "Drafts"
        },
        "concernedItem": "Related Objects",
        "nbResults": "{nbResults} Results",
        "noResults": "No Results"
      },
      "locationSelector": {
        "inputPlaceholder": "Type a location",
        "title": "Select a location",
        "validate": "Validate"
      },
      "maskFields": {
        "boolean": {
          "no": "No",
          "undefined": "Undefined",
          "yes": "Yes"
        },
        "entitySelect": {
          "modalPlaceholder": "Keywords or identifiers..."
        }
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Deployment",
          "checkForUpdate": {
            "help": "If an update is available, it will be installed automatically.",
            "title": "Please check for updates"
          },
          "clearCache": {
            "help": "If you are offline, this process will remove access to all data stored on your device",
            "title": "Clear cache memory"
          },
          "overrideLocale": {
            "help": "The english langage will be used and your device’s settings will be ignored",
            "title": "Force english langage"
          },
          "resetLocaleOverride": {
            "help": "The langage will depend on your device’s settings",
            "title": "Reset the language"
          },
          "serviceWorker": {
            help: "The update banner keeps appearing? Click here!",
            title: "Close the update banner",
          },
          "title": "Skin-REPORTER",
          "version": "version",
        },
        "logout": "Are you sure that you want to log out?"
      },
      "offlineRibbon": {
        "offline": "You are now offline",
        "online": "You are now online"
      },
      "pdfOverviewScreen": {
        "download": "Download",
        "progressBar": {
          "mainLabel": "Preparing document",
          "object": "Object",
          "generalDigest": "General Observations",
          "defects": "Damages",
          "contextAndSignatures": "Context",
          "documentReady": "Document is now ready!"
        },
        "title": "Overview",
        "renderFailureAlert": "Unable to render the PDF, please try again"
      },
      "pdfDocument": {
        "mainTitlePrefix": "CONDITION REPORT - ",
        "objectSection": {
          "sectionTitle": "Object",
          "inventoryNumber": "Inventory Number: ",
          "title": "Title: ",
          "author": "Artist / Author:",
          "creationDate": "Creation date: ",
          "typology": "Typology: ",
          "denomination": "Denomination: ",
          "materialsAndTechniques": "Materials and techniques:",
          "dimensions": "Dimensions: ",
          "institution": "Institution:",
          conditioning: "Packaging:",
          descriptions: "Description(s):",
          domains: "Domain:",
          identification: "Identification:",
          location: "Location:",
          materials: "Material(s):",
          ownerInstitutions: "Owning institution(s):",
          techniques: "Technique(s):",
        },
        "alterationsSection": {
          "detailedAlteration": "Damage details",
          "noAnnotation": "No annotation to display",
          "observationLabel": "Obs.",
          "sectionTitle": "Damages"
        },
        archiveSection: {
          sectionTitle: "MISSING TRANSLATION",
          archiveType: "MISSING TRANSLATION",
          conditioning: "MISSING TRANSLATION",
          cote: "MISSING TRANSLATION",
          descriptionLevel: "MISSING TRANSLATION",
          location: "MISSING TRANSLATION",
          materialImportance: "MISSING TRANSLATION",
          parentArchive: "MISSING TRANSLATION",
          productors: "MISSING TRANSLATION",
          productionDate: "MISSING TRANSLATION",
          proprietaryInstitution: "MISSING TRANSLATION",
          supportType: "MISSING TRANSLATION",
          title: "MISSING TRANSLATION",
        },
        detailedViewsSection: {
          sectionTitle: "Damages details",
        },
        "finalObservationsSection": {
          "sectionTitle": "Final observations"
        },
        conditioningSection: {
          crateNumber: "Crate number:",
          sectionTitle: "Conditioning",
          transportAccessories: "Transport accessories:",
          typeOfPackaging: "Type of packaging:",
        },
        "contextSection": {
          "comments": "Comments:",
          "editors": "Editors:",
          "matAndTechs": "Technics and materials:",
          "reportDate": "Report date:",
          "reportPlace": "Report place:",
          "reportReference": "Report reference:",
          "reportType": "Report type: ",
          "reportReason": "Reason of condition report: ",
          "sectionTitle": "Context",
          signers: "Signatory(ies):",
        },
        "reportSection": {
          "counterSignaturesTitle": "Counter-signatures",
          counterSignature: {
            comment: 'Comment:',
          },
          "interventionsToSchedule": "Interventions to schedule : ",
          "sectionTitle": "Report",
          "signatoriesTitle": "Report made in presence of :",
          "stateOfConservation": "State of conservation : ",
          "treatmentPriority": "Treatment priority : "
        },
        "footer": {
          "prefix": "CONDITION REPORT",
          "separator": "- Page "
        },
        "generationFailureAlert": "PDF generation failed, please try again"
      },
      "proxy": {
        "error": {
          "default": "An error occured on the resource {uri}",
          "network": "Communication with the server has failed",
          "notFound": "The resource {uri} could not be found",
          "tokenHasExpired": "Your session has expired"
        }
      },
      "search": {
        "noResults": "No Results",
        "options": {
          "sortType": {
            "creationDate": "Date of Creation",
            "identifier": "Main identifier",
            "lastModification": "Last Modification",
            "mainTitle": "Main Title",
            "referenceNumber": "Reference number"
          }
        },
        "queryPlaceholder": "Search",
        "title": "Objects",
        "totalCount": "{totalResults}  Result(s) : 1 - {nbResults}"
      },
      "searchFeaturedCard": {
        "consultLastReport": "SEE THE LAST CLOSED CONDITION REPORT",
        "createNewReport": "CREATE NEW CONDITION REPORT",
        "createNewReportFromLast": "CREATE CONDITION REPORT USING THE LATEST REPORT",
        "institutionLabel": "Institution",
        "lastReportLabel": "Latest Condition Report",
        "materialsAndTechniques": "Materials / Techniques",
        "measurements": "Measurements",
        "noLinkedItem": "No item is linked to this condition report"
      },
      selectItemErrorDialog: {
        cancel: "Abandon object",
        cancelAll: "Abandon all objects",
        description: "The selection of {0} objects has failed.",
        retry: "Retry for this object",
        retryAll: "Retry for all objects",
        title: "Failed to select images",
      },
      "serviceWorker": {
        "updateAvailable": "An update has been installed. You can either click here to refresh the page or restart the application.",
        forceServiceWorkerUpdate: {
          modalTitle: "Resolution of the problem",
          versionCorrect: "Do the information below correspond to the version and date provided by SKINsoft after the last update ?",
          yes: "Yes",
          no: "No",
        },
      },
      "signatureModuleScreen": {
        "cardTitle": "Signatory ",
        "eraseSignature": "Clear Signature",
        "missingSignature": "The Condition Report has not been signed",
        "nameLabel": "Signatory",
        "positionOfSignatory": "Function of signatory",
        "presentSignature": "The Condition Report has been signed",
        "saveSignature": "Save",
        "signatureStatus": "Status of Signature",
        "title": "Signatures"
      },
      "synchroModal": {
        "title": "Synchronization",
        "lastFetch": "Last fetching",
        "duration": "Duration",
        "status": "Status",
        "details": "Details",
        "lastSynchro": "Last synchronization",
        "noEntityToSync": "No entity to synchronize",
        "connectionWarningPrefix": "You must have an internet connection to be able to",
        "connectWarningSend": "send",
        "connectWarningRetrieve": "retrive",
        "connectionWarningSuffix": "data",
        "noDataToSync": "No data to synchronize for now",
        "localIconInfoPrefix": "The icon",
        "localIconInfoSuffix": " indicates that the corresponding data has been modified localy and will need to be synchronized with the remote database.",
        "retrieveAll": "Retrieve All",
        "finishedSynchros": "Finished synchronizations",
        "syncAll": "Sychronize all",
        "remainsToSynchronize": "Remains to synchronize",
        "cleanImageCache": "Clean gohst media in cache",
        "cachedImagedCleaned": "Gohst media have been cleaned !",
        "cleanCacheDown": "Clear the cache",
        "cacheDownCleaned": "The cache has been cleared",
        "cleanCacheUp": "Delete every unsynchronized modifications",
        "cacheUpCleaned": "All unsynchronized modifications have been deleted !"
      },
      "entityNames": {
        "items": "Items",
        archives: "MISSING TRANSLATION",
        "auditRecords": "Audit records",
        "audits": "Audit campaings",
        "thesaurusTerms": "Thesaurus terms",
        "thesaurus": "Thesaurus",
        "entityFields": "System data",
        "collaborators": "Collaborators",
        "authorities": "Authorities",
        "aliases": "Aliases",
        "locations": "Locations",
        "conditionReports": "Condition reports",
        "works": "Works",
        "expressions": "Expressions",
        "manifestations": "Manifestations",
        "specimens": "Specimens"
      },
      "time": {
        "hours": "hour(s)",
        "minutes": "minute(s)",
        "seconds": "second(s)"
      },
      "thesaurusTermCreateForm": {
        "formTitle": "Create term",
        "openButtonTitle": "Create term",
        "createButton": "Confirm",
        "anotherTermButton": "Confirm and create other term",
        "cancelButton": "Cancel",
        "preferedTermLabel": "Preferred term ",
        "synonymLabel": "Used for",
        "genericTermPlaceholder": "Generic",
        "selectSpecificLabel": "Select specific terms",
        "disabledOffline": "Creating a thesaurusTerm while offline is not allowed"
      },
      "thesaurusTermTree": {
        "creationTabTitle": "Creation",
        errors: {
          searchError: "The search was unsuccessful",
          fetchError: "Unable to retrieve thesaurus terms"
        },
        "modalSearchInputPlaceholder": "Research a term",
        "selectionTabTitle": "Selection",
        "thesaurusTermSelectorModalTitle": "Select a term",
        "validate": "Validate"
      },
      uploadImageFailureDialog: {
        cancel: "Abandon image {0}",
        cancelAll: "Abandon all images",
        description: "The upload of {0} images has failed.",
        imageAndNumber: "Image {0}",
        retry: "Retry for image {0}",
        retryAll: "Retry for all images",
        title: "Image upload failure",
      },
      "state": {
        "all": "All",
        "archived": "Archived",
        "canceled": "Canceled",
        "finalized": "Finalized",
        "inPreparation": "In preparation",
        "inProgress": "In progress",
        "programmed": "Programmed",
        "toValidated": "Needs validation",
        "validated": "Validated",
        "aborted": "Aborted",
        "success": "Successfully finished",
        "error": "Error",
        "none": "No previous synchronization"
      },
      "SpecimenSearchScreen": {
        "createNewSpecimen": "CREATE NEW SPECIMEN"
      },
    },
    "en-DIOR": {
      "pdfDocument": {
        "mainTitlePrefix": "CONDITION REPORT - ",
        "objectSection": {
          "sectionTitle": "Object",
          "inventoryNumber": "Inventory number : ",
          "title": "Title : ",
          "author": "Creator : ",
          "creationDate": "Date of creation : ",
          "typology": "Type : ",
          "denomination": "TRANSLATION IN PROGRESS",
          "materialsAndTechniques": "Materials and techniques : ",
          "dimensions": "Dimensions : ",
          "institution": "Owning institution : ",
          "conditioning": "Packing : ",
          "descriptions": "Description : ",
          "domains": "Category : ",
          "identification": "Look number : ",
          "location": "Location : ",
          "materials": "Materials : ",
          "ownerInstitutions": "Owning institution : ",
          "techniques": "Techniques : "
        },
        "alterationsSection": {
          "detailedAlteration": "Detailed alteration",
          "noAnnotation": "No annotations",
          "observationLabel": "Obs.",
          "sectionTitle": "Alterations"
        },
        "detailedViewsSection": {
          "sectionTitle": "Details of alterations"
        },
        "finalObservationsSection": {
          "sectionTitle": "Final observations"
        },
        "contextSection": {
          "comments": "Comments : ",
          "editors": " Editors : ",
          "matAndTechs": "Materials and techniques : ",
          "reportDate": "Date of the report : ",
          "reportPlace": "Place : ",
          "reportReference": "Report reference : ",
          "sectionTitle": "Context of the report",
          "reportType": "Type of report : ",
          "reportReason": "Reason of the report : "
        },
        "reportSection": {
          "counterSignaturesTitle": "Countersignatures",
          "counterSignature": {
            "comment": "Comment : "
          },
          "interventionsToSchedule": "Upcoming interventions : ",
          "sectionTitle": "Report",
          "signatoriesTitle": "Inspection carried out in the presence of : ",
          "stateOfConservation": "Condition of the item : ",
          "treatmentPriority": "Treatment priority : "
        },
        "footer": {
          "prefix": "CONDITION REPORT",
          "separator": " - Page "
        },
        "generationFailureAlert": "PDF generation failed, please try again later"
      }
    },
    "en-us": {
      "countryCode": "us",
      "actionBar": {
        "bar": {
          "inProgress": "Drafts",
          "latest": "Closed Reports"
        },
        "sideMenu": {
          "saveModifications": "Save Modifications",
          "reportOverview": "Condition Report Overview",
          "signReport": "Sign Condition Report",
          "closeReport": "Close Condition Report",
          "countersignReport": "Countersign the condition report",
          "printReport": "Print Condition Report",
          "deleteReport": "Delete current Condition Report",
          "deleteReportOfflineWarning": "Warning, this element is not synchronized !",
          "deleteModificationsNotSynchronized": "Delete unsynchronized modifications",
          "duplicateReport": "Duplicate the condition report",
          "confirmDeletion": "Confirm deletion"
        }
      },
      "alerts": {
        "medias": {
          "failUpload": "Failed to upload the media.",
          "failGetIdFromFileName": "The media has been uploaded, but Skin-Reporter cannot find it.",
        },
        "permissions": {
          "camera": {
            askForPermission: "SKR-Condition Report needs permission to access the camera. This permission is necessary for the barcode/QR-code scanning functionalities. Without this permission these functions cannot be provided.",
            permissionDeniedWarning: "Permission to access the camera has previously been denied to SKR-Condition Report. Barcode/QR-code scanning functionalities are therefore not available. To be able to access them, please manually authorise access to the camera for SKR-Condition Report.",
          }
        },
        "workspace": {
          "unableToChangeWorkspace": "Failed to change workspace",
          "unableToLoadWorkspace": "Failed to load workspace",
        },
      },
      alterationDetailImagePopup: {
        title: "Detailed views of alteration {0}",
      },
      "alterationCard": {
        "moreMenu": {
          "deleteAlteration": "Delete alteration",
          "changeAlterationTitle": "Change alteration title",
          "changeAlterationType": "Change alteration type",
          "titleModalHeader": "Edit alteration title",
          "titleModalButton": "Validate"
        },
        titleAutoCompletePlaceHolder: "Title",
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Username and/or password incorrect",
            "network": "Communication with server has failed"
          },
          "form": {
            "password": {
              "error": "Please enter your username",
              "label": "Password"
            },
            "submit": "Log in",
            "submitting": "Logging in",
            "username": {
              "error": "Please enter your password",
              "label": "Username"
            }
          }
        },
        "renew": {
          "slowNetwork": "This is taking more time than usual. Please do not quit the application.",
          "spinner": "Getting you back online"
        },
        sso: {
          errors: {
            authenticationFailed: "Error: unable to complete authentication."
          },
          selectIDP: "Log in with...",
          otherIDPs: "Other account types",
        }
      },
      autoCompleteTextField: {
        modal: {
          okButton: "Ok",
        },
      },
      cameraScanner: {
        scanCode: "Scan the barcode",
        cancel: "Cancel",
        errors: {
          cameraNotFound: "No camera detected",
        },
      },
      "closeReportScreen": {
        "important": "IMPORTANT",
        "close": "Close Condition Report",
        "title": "Close Condition Report",
        "notificationContent": "The condition report '{referenceNumber}' has been closed and the status of the linked object has been updated.",
        "warningMessage": "Once closed, the Condition Report cannot be modified nor deleted ",
        "warningQuestion": "Are you sure that you want to close the Condition Report?",
        "transferingFile": "Transfering PDF document...",
        "fileGeneration": "Generating final PDF document...",
        "reportClosing": "Closing the current condition report...",
        errors: {
          transitionState: "An error occurred when closing the report. The PDF was generated and added to the status report.",
          pushingPDF: "The PDF generated was not added to the status report. Closure aborted.", 
        },
      },
      counterSignatureModuleScreen: {
        title: "Countersignature",
        saveButton: "Save",
        warnings: {
          exit: 'Warning! If you leave the page, your current work will be lost.',
          okButton: 'Continue',
          cancelButton: 'Cancel',
          save: 'Counter-signatures cannot be changed at a later date once they have been saved!',
        },
      },
      "defectTree": {
        "alteration": {
          "alterationLabel": "Type of Damage: ",
          "alterationsTitle": "Damages: ",
          "createAlterationButtonLabel": "Damage",
          "levelTitle": "Level 3",
          "precisionLabel": "Detail:",
          "deleteConfirmationMessage": "Confirm deletion of damage",
          "precisionPlaceholder": "Select sub-category",
          "thesaurusTermWarningMessage": "The selected damage does not match the material",
          "typeOfAlterationPlaceholder": "Select type of Observation"
        },
        "annotation": {
          "annotationsTitle": "Annotations:",
          "commentsPlaceholder": "Precise…",
          "deleteConfirmationMessage": "Confirm deletion ?",
          "defaultImageConfirmationMessage": "Set as default image ?"
        },
        "defect": {
          "createElementButtonLabel": "Zone",
          "deleteConfirmationMessage": "Confirm deletion of zone",
          "elementLabel": "Zone:",
          "precisionLabel": "Detail",
          "elementPlaceholder": "Name of Element",
          "precisionPlaceholder": "Précisez..."
        },
        "material": {
          "createMaterialButtonLabel": "Material ",
          "deleteConfirmationMessage": "Confirm deletion of material",
          "levelTitle": "Level 2",
          "materialLabel": "Material:",
          "materialsTitle": "Materials:",
          "thesaurusTermWarningMessage": "The selected material does not match the type of observation"
        },
        "observation": {
          "createObservationButtonLabel": "Observation",
          "deleteConfirmationMessage": "Confirm deletion of observation",
          "levelTitle": "Level 1",
          "observationLabel": "Type of Observation:",
          "observationsTitle": "Observations:"
        },
        "submit": "Save modifications",
        "submitError": "Defects could not be updated",
        "submitting": "Saving…"
      },
      "drawingEditor": {
        "title": "Detailed Damage",
        "imageCaption": "Caption:",
        "imageTitlePlaceholder": "Type image caption",
        "alterationLabel": "{index}",
        "alterationModalTitle": "Select a damage",
        "observationPlaceholder": "Enter Observation",
        "validate": "Save",
        "errors": {
          alteration: "Alteration ",
          "missingTitleOrType": "A title or a type of alteration is required for every alterations.",
          failedUploadDetailedImageDescription: "The upload of {0} images of detailed views of alterations {1} has failed",
        },
        "alterationLine": {
          "precisionModal": {
            "title": "Further information",
            "validateButton": "Validate"
          },
          "titlePlaceHoder": "Alteration title...",
          "typeOfAlterationPlaceholder": "Select a type of alteration..."
        }
      },
      "editItemScreen": {
        "author": "Author",
        "confirmButton": "Save",
        "editButton": "Edit",
        "inventoryNumber": "Inventory Number",
        "saveNotification": {
          "errorMessage": "En error occured while saving the item",
          "inventoryNumberNotUnique": "Impossible validation",
          "successMessage": "Item successfully saved"
        },
        sections: {
          creation: "Creation",
          description: "Description",
          identification: "Identification",
          location: "Location",
          notes: "Notes",
          state: "Object condition",
        },
        "deleteNotification": {
          "errorMessage": "TRANSLATING IN PROGRESS",
          "successMessage": "TRANSLATING IN PROGRESS"
        },
        "deleteModificationsNotification": {
          "errorMessage": "An error occured when deleting unsynchronized modifications",
          "successMessage": "Modifications have been deleted"
        },
        "errorMessages": {
          "inventoryNumberNotUnique": "This inventory number is already attributed"
        },
        "menu": {
          "saveModifications": "Save modifications",
          "deleteNotSynchronizedNewItem": "TRANSLATING IN PROGRESS",
          "deleteModificationsNotSynchronized": "Delete unsynchronized modifications",
          "offlineWarning": "Modifications are saved on this device, you will have to synchronize them with the database when the network is back.",
          "offlineShortWarning": "Modified on this device"
        },
        "fieldDisabledOffline": "This field is not available in offline mode"
      },
      "editReportScreen": {
        "alerts": {
          duplicateClosedReport: {
            success: "The report was successfully duplicated",
            failure: "Duplication of the report was not successful",
            warningReportNotClosed: "Report must be closed before it can be duplicated",
          }
        },
        "reportTitlePrefix": "Report N° {refNumber}",
        "reportStatusInProgress": "In Progress",
        "reportIdentifiers": {
          "accordionPanelTitle": "GENERAL INFORMATION",
          "referenceNumber": "Reference Number",
          "numberingInformation": "Leave this field blank to activate the automated numbering once the report has been saved",
          "otherIdentifiers": "Other Identifiers",
          "reportReason": "Reason of Condition Report",
          "precision": "Detail",
          "reportType": "Report type",
          "reportTypePlaceholder": "Select a report type",
          "tabTitle": "Identification"
        },
        "reportContext": {
          "accordionPanelTitle": "CONTEXT",
          "reportDate": "Date of report",
          "reportDoneInThePresenceOf": "Report written in the presence of",
          "andOf": "and",
          "name": "Name/Surname, Role",
          "role": "Role",
          "coordinates": "Contact info",
          "email": "Email",
          "signer": "Persons authorized to sign the report",
          "reportPlace": "Place",
          "customer": "Customer",
          "precisions": "Details",
          "linkedProject": "Related Project",
          "linkedMovement": "Related Movement",
          "technicsAndMaterials": "Techniques and Materials",
          "comments": "Comments",
          "signerComponent": {
            "name": "Signatory",
            "date": "Date of signature",
            "positionOfSignatory": "Function of signatory",
            "title": "Signatory(ies)",
          },
          counterSignatureComponent: {
            comment: "Comment",
            location: "Location",
            reason: "Reason",
            date: "Date",
          },
          counterSignaturesComponent: {
            title: "Counter-signatures",
          },
          "counterSignerComponent": {
            "name": "Surname/First name",
            "function": "Function",
            signature: 'Signature',
          },
          counterSignersComponent: {
            title: "Report made in presence of :",
          },
        },
        "alterations": {
          "accordionPanelTitle": "DAMAGES",
          "mediasSectionTitle": "REPORT's IMAGES",
          "globalAlterationSectionTitle": "GENERAL DAMAGES",
          "createAlterationForm": {
            "createAlterationButtonTitle": "Create",
            "alterationTypeLabel": "Damage type",
            "precisionLabel": "Precision"
          },
          "tabTitle": "Alterations",
          "viewMenu": {
            "alterationTypeView": "Alteration type view",
            "imageView": "Image view",
            "titleView": "Title view"
          }
        },
        "conservation": {
          "accordionPanelTitle": "CONSERVATION AND MANIPULATION"
        },
        "observations": {
          "tabTitle": "Report",
          "accordionPanelTitle": "GENERAL OBSERVATIONS & RECOMMENDATIONS",
          "commentsFieldLabel": "Comments",
          "countersignature": "Counter-signatures",
          "interventionToSchedule": "Scheduled interventions",
          "interventionToSchedulePlaceholder": "Choose an intervention",
          "interventionToSchedulePrecision": "Precision :",
          "stateOfConservation": "State of conservation",
          "stateOfConservationPlaceholder": "Choose a state",
          "signature": "Signatures",
          "typeOfStateOfConservation": "Type of state",
          "treatmentPriority": "Treatment priority",
          "treatmentPriorityPlaceholder": "Choose a priority"
        },
        "medias": {
          "accordionPanelTitle": "ATTACHED MULTIMEDIA"
        },
        "saveAlert": {
          "errorMessage": "An error occurred when saving the Condition Report",
          "inventoryNumberNotUnique": "Impossible validation",
          "successMessage": "Condition Report has been saved"
        },
        "deleteAlert": {
          "errorMessage": "An error occurred when deleting the Condition Report",
          "successMessage": "Condition Report has been deleted"
        },
        "deleteModificationsNotification": {
          "errorMessage": "An error occured when deleting unsynchronized modifications",
          "successMessage": "Modifications have been cancelled"
        },
        "fieldDisabledOffline": "This field is not available in offline mode",
        pdf: {
          counterSignaturePDF: {
            startGenerating: "PDF generation has started",
            success: "PDF generation completed successfully",
            failure: "PDF generation failed",
          }
        },
      },
      "editRecordScreen": {
        "foldAll": "Fold all",
        "unfoldAll": "Unfold all",
        "medias": {
          "accordionPanelTitle": "ATTACHED MULTIMEDIA"
        }
      },
      "firewall": {
        "collabWarningMessage": "Your account doesn't any associated collaborator, the app may be disfunctionning",
        "noGroupForUserWarningMessage": "You user account needs to be part of group of users to be able to user SKINreporter"
      },
      "itemCreationImagePopup": {
        "title": "Add an image",
        "addImage": "ADD AN IMAGE",
        "ignore": "LATER, IGNORE THIS STAGE"
      },
      "itemSearchScreen": {
        "createNewItem": "CREATE NEW ITEM"
      },
      "listReportScreen": {
        "closed": {
          "downloadFailure": "An error occured during the document downloading",
          "downloadSuccess": "The document {docTitle} has been dowloaded",
          "open": "OPEN DOCUMENT",
          "title": "Completed Condition Reports"
        },
        "inProgress": {
          "edit": "EDIT CONDITION REPORT",
          "title": "Drafts"
        },
        "concernedItem": "Related Objects",
        "nbResults": "{nbResults} Results",
        "noResults": "No Results"
      },
      "locationSelector": {
        "inputPlaceholder": "Type a location",
        "title": "Select a location",
        "validate": "Validate"
      },
      "maskFields": {
        "boolean": {
          "no": "No",
          "undefined": "Undefined",
          "yes": "Yes"
        },
        "entitySelect": {
          "modalPlaceholder": "Keywords or identifiers..."
        }
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Deployment",
          "checkForUpdate": {
            "help": "If an update is available, it will be installed automatically.",
            "title": "Please check for updates"
          },
          "clearCache": {
            "help": "If you are offline, this process will remove access to all data stored on your device",
            "title": "Clear cache memory"
          },
          "overrideLocale": {
            "help": "The english langage will be used and your device’s settings will be ignored",
            "title": "Force english langage"
          },
          "resetLocaleOverride": {
            "help": "The langage will depend on your device’s settings",
            "title": "Reset the language"
          },
          "serviceWorker": {
            help: "The update banner keeps appearing? Click here!",
            title: "Close the update banner",
          },
          "title": "Skin-REPORTER",
          "version": "version",
        },
        "logout": "Are you sure that you want to log out?"
      },
      "offlineRibbon": {
        "offline": "You are now offline",
        "online": "You are now online"
      },
      "pdfOverviewScreen": {
        "download": "Download",
        "progressBar": {
          "mainLabel": "Preparing document",
          "object": "Object",
          "generalDigest": "General Observations",
          "defects": "Damages",
          "contextAndSignatures": "Context",
          "documentReady": "Document is now ready!"
        },
        "title": "Overview",
        "renderFailureAlert": "Unable to render the PDF, please try again"
      },
      "pdfDocument": {
        "mainTitlePrefix": "CONDITION REPORT - ",
        "objectSection": {
          "sectionTitle": "Object",
          "inventoryNumber": "Inventory Number: ",
          "title": "Title: ",
          "author": "Artist / Author:",
          "creationDate": "Creation date: ",
          "typology": "Typology: ",
          "denomination": "Denomination: ",
          "materialsAndTechniques": "Materials and techniques:",
          "dimensions": "Dimensions: ",
          "institution": "Institution:",
          conditioning: "Packaging:",
          descriptions: "Description(s):",
          domains: "Domain:",
          identification: "Identification:",
          location: "Location:",
          materials: "Material(s):",
          ownerInstitutions: "Owning institution(s):",
          techniques: "Technique(s):",
        },
        "alterationsSection": {
          "detailedAlteration": "Damage details",
          "noAnnotation": "No annotation to display",
          "observationLabel": "Obs.",
          "sectionTitle": "Damages"
        },
        detailedViewsSection: {
          sectionTitle: "Damages details",
        },
        "finalObservationsSection": {
          "sectionTitle": "Final observations"
        },
        "contextSection": {
          "comments": "Comments:",
          "editors": "Editors:",
          "matAndTechs": "Technics and materials:",
          "reportDate": "Report date:",
          "reportPlace": "Report place:",
          "reportReference": "Report reference:",
          "reportType": "Report type: ",
          "reportReason": "Reason of condition report: ",
          "sectionTitle": "Context",
        },
        "reportSection": {
          "counterSignaturesTitle": "Counter-signatures",
          counterSignature: {
            comment: 'Comment:',
          },
          "interventionsToSchedule": "Interventions to schedule : ",
          "sectionTitle": "Report",
          "signatoriesTitle": "Report made in presence of :",
          "stateOfConservation": "State of conservation : ",
          "treatmentPriority": "Treatment priority : "
        },
        "footer": {
          "prefix": "CONDITION REPORT",
          "separator": "- Page "
        },
        "generationFailureAlert": "PDF generation failed, please try again"
      },
      "proxy": {
        "error": {
          "default": "An error occured on the resource {uri}",
          "network": "Communication with the server has failed",
          "notFound": "The resource {uri} could not be found",
          "tokenHasExpired": "Your session has expired"
        }
      },
      "search": {
        "noResults": "No Results",
        "options": {
          "sortType": {
            "creationDate": "Date of Creation",
            "identifier": "Main identifier",
            "lastModification": "Last Modification",
            "mainTitle": "Main Title",
            "referenceNumber": "Reference number"
          }
        },
        "queryPlaceholder": "Search",
        "title": "Objects",
        "totalCount": "{totalResults}  Result(s) : 1 - {nbResults}"
      },
      "searchFeaturedCard": {
        "consultLastReport": "SEE THE LAST CLOSED CONDITION REPORT",
        "createNewReport": "CREATE NEW CONDITION REPORT",
        "createNewReportFromLast": "CREATE CONDITION REPORT USING THE LATEST REPORT",
        "institutionLabel": "Institution",
        "lastReportLabel": "Latest Condition Report",
        "materialsAndTechniques": "Materials / Techniques",
        "measurements": "Measurements",
        "noLinkedItem": "No item is linked to this condition report"
      },
      selectItemErrorDialog: {
        cancel: "Abandon object",
        cancelAll: "Abandon all objects",
        description: "The selection of {0} objects has failed.",
        retry: "Retry for this object",
        retryAll: "Retry for all objects",
        title: "Failed to select images",
      },
      "serviceWorker": {
        "updateAvailable": "An update has been installed. You can either click here to refresh the page or restart the application.",
        forceServiceWorkerUpdate: {
          modalTitle: "Resolution of the problem",
          versionCorrect: "Do the information below correspond to the version and date provided by SKINsoft after the last update ?",
          yes: "Yes",
          no: "No",
        },
      },
      "signatureModuleScreen": {
        "cardTitle": "Signatory ",
        "eraseSignature": "Clear Signature",
        "missingSignature": "The Condition Report has not been signed",
        "nameLabel": "Signatory",
        "positionOfSignatory": "Function of signatory",
        "presentSignature": "The Condition Report has been signed",
        "saveSignature": "Save",
        "signatureStatus": "Status of Signature",
        "title": "Signatures"
      },
      "synchroModal": {
        "title": "Synchronization",
        "lastFetch": "Last fetching",
        "duration": "Duration",
        "status": "Status",
        "details": "Details",
        "lastSynchro": "Last synchronization",
        "noEntityToSync": "No entity to synchronize",
        "connectionWarningPrefix": "You must have an internet connection to be able to",
        "connectWarningSend": "send",
        "connectWarningRetrieve": "retrive",
        "connectionWarningSuffix": "data",
        "noDataToSync": "No data to synchronize for now",
        "localIconInfoPrefix": "The icon",
        "localIconInfoSuffix": " indicates that the corresponding data has been modified localy and will need to be synchronized with the remote database.",
        "retrieveAll": "Retrieve All",
        "finishedSynchros": "Finished synchronizations",
        "syncAll": "Sychronize all",
        "remainsToSynchronize": "Remains to synchronize",
        "cleanImageCache": "Clean gohst media in cache",
        "cachedImagedCleaned": "Gohst media have been cleaned !",
        "cleanCacheDown": "Clear the cache",
        "cacheDownCleaned": "The cache has been cleared",
        "cleanCacheUp": "Delete every unsynchronized modifications",
        "cacheUpCleaned": "All unsynchronized modifications have been deleted !"
      },
      "entityNames": {
        "items": "Items",
        "auditRecords": "Audit records",
        "audits": "Audit campaings",
        "thesaurusTerms": "Thesaurus terms",
        "thesaurus": "Thesaurus",
        "entityFields": "System data",
        "collaborators": "Collaborators",
        "authorities": "Authorities",
        "aliases": "Aliases",
        "locations": "Locations",
        "conditionReports": "Condition reports",
        "works": "Works",
        "expressions": "Expressions",
        "manifestations": "Manifestations",
        "specimens": "Specimens"
      },
      "time": {
        "hours": "hour(s)",
        "minutes": "minute(s)",
        "seconds": "second(s)"
      },
      "thesaurusTermCreateForm": {
        "formTitle": "Create term",
        "openButtonTitle": "Create term",
        "createButton": "Confirm",
        "anotherTermButton": "Confirm and create other term",
        "cancelButton": "Cancel",
        "preferedTermLabel": "Preferred term ",
        "synonymLabel": "Used for",
        "genericTermPlaceholder": "Generic",
        "selectSpecificLabel": "Select specific terms",
        "disabledOffline": "Creating a thesaurusTerm while offline is not allowed"
      },
      "thesaurusTermTree": {
        "creationTabTitle": "Creation",
        errors: {
          searchError: "The search was unsuccessful",
          fetchError: "Unable to retrieve thesaurus terms"
        },
        "modalSearchInputPlaceholder": "Research a term",
        "selectionTabTitle": "Selection",
        "thesaurusTermSelectorModalTitle": "Select a term",
        "validate": "Validate"
      },
      uploadImageFailureDialog: {
        cancel: "Abandon image {0}",
        cancelAll: "Abandon all images",
        description: "The upload of {0} images has failed.",
        imageAndNumber: "Image {0}",
        retry: "Retry for image {0}",
        retryAll: "Retry for all images",
        title: "Image upload failure",
      },
      "state": {
        "all": "All",
        "archived": "Archived",
        "canceled": "Canceled",
        "finalized": "Finalized",
        "inPreparation": "In preparation",
        "inProgress": "In progress",
        "programmed": "Programmed",
        "toValidated": "Needs validation",
        "validated": "Validated",
        "aborted": "Aborted",
        "success": "Successfully finished",
        "error": "Error",
        "none": "No previous synchronization"
      },
      "SpecimenSearchScreen": {
        "createNewSpecimen": "CREATE NEW SPECIMEN"
      },
    },
    "fr": {
      "countryCode": "fr",
      "actionBar": {
        "bar": {
          "inProgress": "En cours",
          "latest": "Terminés"
        },
        "sideMenu": {
          "saveModifications": "Sauvegarder les modifications",
          "reportOverview": "Aperçu du constat d'état",
          "signReport": "Signer le constat d'état",
          "closeReport": "Clôturer le constat d'état",
          "countersignReport": "Contre-signer le constat d'état",
          "printReport": "Imprimer le constat d'état",
          "deleteReport": "Supprimer le constat en cours",
          "deleteReportOfflineWarning": "Attention, cet élément n'est pas synchronisé !",
          "deleteModificationsNotSynchronized": "Supprimer les modifications non synchronisées",
          "duplicateReport": "Dupliquer le constat d'état",
          "confirmDeletion": "Confirmer la suppression"
        }
      },
      "alerts": {
        "medias": {
          "failUpload": "Échec du téléversement du média.",
          "failGetIdFromFileName": "Le média a été téléversé, mais Skin-Reporter ne parvient pas à le trouver.",
        },
        "permissions": {
          "camera": {
            askForPermission: "SKR-Condition Report a besoin de la permission d'accéder à la caméra. Cette permission est nécessaire pour les fonctionnalités de scan de code-barre/QR-code. Sans cette permission ces fonctionnalités ne pourront être assurées.",
            permissionDeniedWarning: "La permission d'accéder à la caméra a été refusée à SKR-Condition Report auparavant. Les fonctionnalités de scan de code-barre/QR-code ne sont donc pas disponible. Pour pouvoir y accéder, merci d'autoriser manuellement l'accès à la caméra pour SKR-Condition Report.",
          }
        },
        "workspace": {
          "unableToChangeWorkspace": "Échec du changement d'espace de travail",
          "unableToLoadWorkspace": "Le chargement de l'espace de travail a échoué",
        },
      },
      alterationDetailImagePopup: {
        title: "Vues détaillées de l'altération {0}",
      },
      alterationCard: {
        moreMenu: {
          deleteAlteration: "Supprimer l'altération",
          changeAlterationTitle: "Changer le titre de l'altération",
          changeAlterationType: "Changer le type d'altération",
          titleModalHeader: "Éditer le titre de l'altération",
          titleModalButton: 'Valider',
        },
        titleAutoCompletePlaceHolder: "Titre",
      },
      archiveCrEditScreenHeader: {
        materialImportance: "Importance matérielle",
        principalMediumType: "Type de support",
      },
      archiveEditScreen: {
        saveAlert: {
          errorMessage: "Une erreur est survenue pendant la sauvegarde de l'archive",
          successMessage: "L'archive a été sauvegardée avec succès",
        },
      },
      archiveEditScreenHeader: {
        cote: "Cote :",
        descriptionLevel: "Niveau de description :",
      },
      archiveSearchScreen: {
        createNewArchive: "CRÉER UNE NOUVELLE ARCHIVE",
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Vos identifiants sont incorrects",
            "network": "La communication avec le serveur a échoué"
          },
          "form": {
            "password": {
              "error": "Veuillez saisir votre nom d'utilisateur",
              "label": "Mot de passe"
            },
            "submit": "Se connecter",
            "submitting": "Connexion...",
            "username": {
              "error": "Veuillez saisir votre mot de passe",
              "label": "Nom d'utilisateur"
            }
          }
        },
        "renew": {
          "slowNetwork": "Cela semble mettre plus de temps que d'habitude, ne quittez pas l'application.",
          "spinner": "Nous vous reconnectons..."
        },
        sso: {
          errors: {
            authenticationFailed: "Erreur : impossible de finaliser l'authentification."
          },
          selectIDP: "S'authentifier avec...",
          otherIDPs: "Autres types de comptes",
        },
      },
      autoCompleteTextField: {
        modal: {
          okButton: "Ok",
        },
      },
      cameraScanner: {
        scanCode: "Scanner un code-barre",
        cancel: "Annuler",
        errors: {
          cameraNotFound: "Aucune caméra n'a été détectée",
        },
      },
      "closeReportScreen": {
        "important": "IMPORTANT",
        "close": "Clôturer",
        "title": "Clôture du constat d'état",
        "notificationContent": "Le constat '{referenceNumber}' a été clôturé, l'état de l'objet lié a été mis à jour.",
        "warningMessage": "Un constat clôturé ne peut être modifié ni supprimé",
        "warningQuestion": "Souhaitez-vous réellement poursuivre la clôture du constat d'état ?",
        "transferingFile": "Transfert du document PDF...",
        "fileGeneration": "Génération du document pdf final...",
        "reportClosing": "Clôture du constat d'état...",
        errors: {
          transitionState: "Une erreur est survenue lors de la clôture du constat, le PDF a bien été généré et ajouté au constat d'état.",
          pushingPDF: "L'ajout du PDF généré au constat d'état a échoué. Abandon de la clôture.", 
        },
      },
      counterSignatureModuleScreen: {
        title: "Contre-Signature",
        saveButton: "Valider",
        warnings: {
          exit: 'Attention ! Si vous quittez la page le travail actuel sera perdu',
          okButton: 'Continuer',
          cancelButton: 'Annuler',
          save: 'Une fois les contre-signatures sauvegardées, elles ne pourront plus être modifiées ultérieurement !',
        },
      },
      createArchiveModal: {
        creationFailed: "La création de l'archive a échouée",
        descriptionLevel: "Niveau de description",
        submitBtn: "Créer",
        submitting: "Création...",
        title: "Création d'une unité d'archives",
      },
      "defectTree": {
        "alteration": {
          "alterationLabel": "Type :",
          "alterationsTitle": "Altérations :",
          "createAlterationButtonLabel": "Alteration",
          "levelTitle": "Niveau 3",
          "precisionLabel": "Précision :",
          "deleteConfirmationMessage": "Confirmer la suppression de l'altération et de son contenu ?",
          "precisionPlaceholder": "Sélectionnez un sous-type",
          "thesaurusTermWarningMessage": "Le type d'altération sélectionné ne correspond pas au matériau ci-dessus",
          "typeOfAlterationPlaceholder": "Sélectionnez un type d'observation"
        },
        "annotation": {
          "annotationsTitle": "Annotations :",
          "commentsPlaceholder": "Précisez...",
          "deleteConfirmationMessage": "Confirmer la suppression ?",
          "defaultImageConfirmationMessage": "Définir comme image par défaut ?"
        },
        "defect": {
          "createElementButtonLabel": "Élément",
          "deleteConfirmationMessage": "Confirmer la suppression de l'élément et de son contenu ?",
          "elementLabel": "Elément :",
          "precisionLabel": "Précision",
          "elementPlaceholder": "Nom de l'élément",
          "precisionPlaceholder": "Précisez..."
        },
        "material": {
          "createMaterialButtonLabel": "Matériau",
          "deleteConfirmationMessage": "Confirmer la suppression du matériau et de son contenu ?",
          "levelTitle": "Niveau 2",
          "materialLabel": "Matériau :",
          "materialsTitle": "Matériaux :",
          "thesaurusTermWarningMessage": "Le matériau sélectionné ne correspond pas au type d'observation ci-dessus"
        },
        "observation": {
          "createObservationButtonLabel": "Observation",
          "deleteConfirmationMessage": "Confirmer la suppression de l'observation et de son contenu ?",
          "levelTitle": "Niveau 1",
          "observationLabel": "Type d'observation :",
          "observationsTitle": "Observations :"
        },
        "submit": "Sauvegarder les modifications",
        "submitError": "L'arbre n'a pas pu être mis à jour",
        "submitting": "Sauvegarde en cours..."
      },
      "drawingEditor": {
        "title": "Altération détaillée",
        "imageCaption": "Légende :",
        "imageTitlePlaceholder": "Saisir la légende de l'image",
        "alterationLabel": "{index}",
        "alterationModalTitle": "Sélectionner une altération",
        "observationPlaceholder": "Entrez une observation",
        "validate": "Enregistrer",
        errors: {
          alteration: "Alteration ",
          missingTitleOrType: "Veuillez renseigner un titre ou un type d'altération pour chaque altération.",
          failedUploadDetailedImageDescription: "Le téléversement de {0} images de vues détaillées des altérations {1} a échoué",
        },
        "alterationLine": {
          precisionModal: {
            title: "Précision",
            validateButton: "Valider",
          },
          titlePlaceHoder: "Titre de l'altération...",
          typeOfAlterationPlaceholder: "Type d'altération...",
        },
      },
      "editItemScreen": {
        "author": "Auteur",
        "confirmButton": "Valider",
        "editButton": "Modifier",
        "inventoryNumber": "N° d'inventaire",
        "saveNotification": {
          "errorMessage": "Une erreur est survenue pendant la sauvegarde de l'objet",
          "inventoryNumberNotUnique": "Validation impossible, le numéro d'identification de la notice existe déjà",
          "successMessage": "L'objet a été sauvegardé avec succès"
        },
        sections: {
          creation: "Création",
          description: "Description",
          identification: "Identification",
          location: "Localisation",
          notes: "Notes",
          state: "État",
        },
        "deleteNotification": {
          "errorMessage": "Une erreur est survenue pendant la suppression de l'objet non synchronisés",
          "successMessage": "L'objet a été supprimé avec succès"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Une erreur est survenue pendant la suppression des modifications non synchronisées",
          "successMessage": "Les modifications ont été annulées"
        },
        "errorMessages": {
          "inventoryNumberNotUnique": "Ce numéro d'inventaire est déjà attribué"
        },
        "menu": {
          "saveModifications": "Sauvegarder les modifications",
          "deleteNotSynchronizedNewItem": "Supprimer le nouvel objet",
          "deleteModificationsNotSynchronized": "Supprimer les modifications non synchronisées",
          "offlineWarning": "Les modifications sont sauvegardées sur l'appareil, vous devrez les synchroniser avec la base de données lorsque le réseau sera de nouveau disponible.",
          "offlineShortWarning": "Modifié sur cet appareil"
        },
        "fieldDisabledOffline": "La saisie de ce champ n'est pas disponible en mode hors-ligne"
      },
      "editReportScreen": {
        "alerts": {
          duplicateClosedReport: {
            success: "Le constat a été dupliqué avec succès",
            failure: "La duplication du constat a échoué",
            warningReportNotClosed: "Le constat doit être cloturé pour pouvoir être dupliqué",
          }
        },
        "reportTitlePrefix": "Constat N° {refNumber}",
        "reportStatusInProgress": "En cours",
        "reportIdentifiers": {
          "accordionPanelTitle": "IDENTIFIANTS DU CONSTAT",
          "referenceNumber": "N° de référence",
          "numberingInformation": "Laisser vide pour activer la numérotation automatique à la prochaine sauvegarde",
          "otherIdentifiers": "Autres identifants",
          "reportReason": "Motif du constat",
          "precision": "Précision",
          "reportType": "Type de constat",
          "reportTypePlaceholder": "Sélectionnez un type de constat",
          "tabTitle": "Identification"
        },
        "reportContext": {
          "accordionPanelTitle": "CONTEXTE DU CONSTAT D'ÉTAT",
          "reportDate": "Date du constat",
          "reportDoneInThePresenceOf": "Constat effectué en présence de",
          "andOf": "Et de",
          "name": "Nom/Prénom, Qualité",
          "role": "Qualité",
          "coordinates": "Coordonnées",
          "email": "Email",
          "signer": "Signataire",
          "reportPlace": "Lieu du constat",
          "customer": "Client/Commanditaire",
          "precisions": "Précisions",
          "linkedProject": "Projet Lié",
          "linkedMovement": "Mouvement Lié",
          "technicsAndMaterials": "Techniques et matériels utilisés",
          "comments": "Commentaires",
          "signerComponent": {
            "name": "Signataire",
            "date": "Date de signature",
            "positionOfSignatory": "Fonction du signataire",
            "title": "Signataires",
          },
          counterSignatureComponent: {
            comment: "Commentaire",
            location: "Lieu",
            reason: "Motif",
            date: "Date",
          },
          counterSignaturesComponent: {
            title: "Contre-signatures",
          },
          "counterSignerComponent": {
            "name": "Nom/Prénom",
            "function": "Fonction",
            signature: 'Signature',
          },
          counterSignersComponent: {
            title: "Constat effectué en présence de :",
          },
        },
        "alterations": {
          "accordionPanelTitle": "ALTÉRATIONS",
          "mediasSectionTitle": "IMAGES DU CONSTAT",
          "globalAlterationSectionTitle": "ALTÉRATIONS GÉNÉRALES",
          "createAlterationForm": {
            "createAlterationButtonTitle": "Créer",
            "alterationTypeLabel": "Type d'altération",
            "precisionLabel": "Précision"
          },
          "tabTitle": "Altérations",
          viewMenu: {
            alterationTypeView: "Vue par type d'altération",
            imageView: 'Vue photos',
            titleView: 'Vue par titre',
          },
        },
        "conservation": {
          "accordionPanelTitle": "CONSERVATION ET MANIPULATION"
        },
        "observations": {
          "tabTitle": "Bilan",
          "accordionPanelTitle": "RAPPORT ET OBSERVATIONS",
          "commentsFieldLabel": "Commentaires",
          "countersignature": "Contre-signatures",
          "interventionToSchedule": "Interventions à prévoir",
          "interventionToSchedulePlaceholder": "Choisissez une intervention",
          "interventionToSchedulePrecision": "Précision :",
          "stateOfConservation": "Etat du bien",
          "stateOfConservationPlaceholder": "Choisissez un état",
          "signature": "Signatures",
          "typeOfStateOfConservation": "Type d'état",
          "treatmentPriority": "Priorité de traitement",
          "treatmentPriorityPlaceholder": "Choississez une priorité"
        },
        "medias": {
          "accordionPanelTitle": "MÉDIAS"
        },
        "saveAlert": {
          "errorMessage": "Une erreur est survenue pendant la sauvegarde du constat",
          "inventoryNumberNotUnique": "Validation impossible, le numéro d'identification de la notice existe déjà",
          "successMessage": "Constat d'état sauvegardé"
        },
        "deleteAlert": {
          "errorMessage": "Une erreur est survenue pendant la suppression du constat",
          "successMessage": "Constat d'état supprimé"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Une erreur est survenue pendant la suppression des modifications non synchronisées",
          "successMessage": "Les modifications ont été annulées"
        },
        "fieldDisabledOffline": "La saisie de ce champ n'est pas disponible en mode hors-ligne",
        pdf: {
          counterSignaturePDF: {
            startGenerating: "La génération du PDF a démarré",
            success: "Génération du PDF terminée avec succès",
            failure: "Échec de la génération du PDF",
          },
        },
      },
      "editRecordScreen": {
        "foldAll": "Réduire tout",
        "unfoldAll": "Déployer tout",
        "medias": {
          "accordionPanelTitle": "MÉDIAS"
        }
      },
      "firewall": {
        "collabWarningMessage": "Votre compte n'a pas de collaborateur associé, l'application peut dysfonctionner",
        "noGroupForUserWarningMessage": "L'usage de SKINreporter requiert que votre compte utilisateur soit lié à un groupe d'utilisateurs"
      },
      genericEditScreen: {
        genericErrorMsg: "Une erreur s'est produite",
        saveErrorMsg: "Échec lors de la sauvegarde des modifications",
          saveSuccessMsg: "Sauvegarde des modifications réussie",
      },
      "itemCreationImagePopup": {
        "title": "Ajouter une image",
        "addImage": "AJOUTER UNE IMAGE",
        "ignore": "PLUS TARD, IGNORER CETTE ETAPE"
      },
      "itemSearchScreen": {
        "createNewItem": "CRÉER UN NOUVEL OBJET"
      },
      "listReportScreen": {
        "closed": {
          "downloadFailure": "Une erreur est survenue pendant le téléchargement",
          "downloadSuccess": "Le document {docTitle} a été téléchargé",
          "open": "TÉLÉCHARGER LE DOCUMENT",
          "title": "Constats d'état terminés"
        },
        "inProgress": {
          "edit": "EDITER LE CONSTAT",
          "title": "Constats d'état en cours d'édition"
        },
        "concernedItem": "Objet de musée concerné",
        "nbResults": "{nbResults} résultats",
        "noResults": "Aucun résultat"
      },
      "locationSelector": {
        "inputPlaceholder": "Entrez une localisation",
        "title": "Choisissez une localisation",
        "validate": "Valider"
      },
      "maskFields": {
        "boolean": {
          "no": "Non",
          "undefined": "Non défini",
          "yes": "Oui"
        },
        "entitySelect": {
          "modalPlaceholder": "Mots clés ou identifiants..."
        }
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Déployé le",
          "checkForUpdate": {
            "help": "Si une mise à jour est disponible, elle s'installera automatiquement.",
            "title": "Vérifiez les mises à jour"
          },
          "clearCache": {
            "help": "Si vous êtes hors-ligne, cela supprime l'accès à toutes les données stockées sur l'appareil.",
            "title": "Vider le cache"
          },
          "overrideLocale": {
            "help": "La langue anglaise sera utilisée et le paramétrage de votre terminal ignoré.",
            "title": "Forcer la langue anglaise"
          },
          "resetLocaleOverride": {
            "help": "La langue utilisé dépendra du paramètrage de votre terminal",
            "title": "Réinitialiser la langue"
          },
          "serviceWorker": {
            help: "Le bandeau de mise à jour s'affiche continuellement ? Cliquez ici !",
            title: "Fermer le bandeau de mise à jour",
          },
          "title": "Skin-REPORTER",
          "version": "version",
        },
        "logout": "Etes-vous sûr de vouloir vous déconnecter ?"
      },
      "offlineRibbon": {
        "offline": "Vous êtes hors connexion",
        "online": "Vous êtes connecté"
      },
      "pdfOverviewScreen": {
        "download": "Télécharger",
        "progressBar": {
          "mainLabel": "Génération du document ...",
          "object": "Objet",
          "generalDigest": "Appréciation Générale",
          "defects": "Altérations",
          "contextAndSignatures": "Contexte",
          "documentReady": "Document prêt !"
        },
        "title": "Aperçu",
        "renderFailureAlert": "Impossible d'afficher le PDF, veuillez réessayer plus tard"
      },
      "pdfDocument": {
        "mainTitlePrefix": "CONSTAT D'ETAT - ",
        "objectSection": {
          "sectionTitle": "Objet",
          "inventoryNumber": "N° d'inventaire : ",
          "title": "Titre : ",
          "author": "Artiste / Auteur :",
          "creationDate": "Date de création : ",
          "typology": "Typologie : ",
          "denomination": "Dénomination : ",
          "materialsAndTechniques": "Matériaux et techniques :",
          "dimensions": "Dimensions : ",
          "institution": "Institution :",
          conditioning: "Conditionnement :",
          descriptions: "Description(s) :",
          domains: "Domaine(s) :",
          identification: "Identification :",
          location: "Localisation :",
          materials: "Matériau(x) :",
          ownerInstitutions: "Institution(s) propriétaire(s) :",
          techniques: "Technique(s) :",
        },
        "alterationsSection": {
          "detailedAlteration": "Altération détaillée",
          "noAnnotation": "Aucune annotation à afficher",
          "observationLabel": "Obs.",
          "sectionTitle": "Altérations"
        },
        archiveSection: {
          sectionTitle: "Archive",
          archiveType: "Type d'archive : ",
          conditioning: "Conditionnement : ",
          cote: "Cote : ",
          descriptionLevel: "Niveau de description : ",
          location: "Localisation : ",
          materialImportance: "Importance matérielle et support : ",
          parentArchive: "Archive parente : ",
          productors: "Producteur(s) : ",
          productionDate: "Date de production : ",
          proprietaryInstitution: "Institution propriétaire : ",
          supportType: "Type de support : ",
          title: "Intitulé : ",
        },
        detailedViewsSection: {
          sectionTitle: "Détails des altérations",
        },
        "finalObservationsSection": {
          "sectionTitle": "Observations finales"
        },
        conditioningSection: {
          crateNumber: "Numéro de caisse :",
          sectionTitle: "Conditionnement",
          transportAccessories: "Accessoires pour le transport :",
          typeOfPackaging: "Type d’emballage :",
        },
        "contextSection": {
          "comments": "Commentaires :",
          "editors": "Rédacteurs :",
          "matAndTechs": "Matériaux et techniques :",
          "reportDate": "Date du constat :",
          "reportPlace": "Lieu : ",
          "reportReference": "Référence du constat :",
          "reportType": "Type de constat : ",
          "reportReason": "Motif du constat : ",
          "sectionTitle": "Contexte du présent constat d'état",
          signers: "Signataires :",
        },
        "reportSection": {
          "counterSignaturesTitle": "Contre-signatures",
          counterSignature: {
            comment: 'Commentaire :',
          },
          "interventionsToSchedule": "Interventions à prévoir : ",
          "sectionTitle": "Rapport",
          "signatoriesTitle": "Constat effectué en présence de :",
          "stateOfConservation": "Etat du bien : ",
          "treatmentPriority": "Priorité de traitement : "
        },
        "footer": {
          "prefix": "CONSTAT D'ETAT",
          "separator": "- Page "
        },
        "generationFailureAlert": "La génération du PDF a échoué, veuillez réessayer plus tard"
      },
      "proxy": {
        "error": {
          "default": "Une erreur s'est produite sur la ressource {uri}",
          "network": "La communication avec le serveur a échoué",
          "notFound": "La ressource {uri} n'a pas été trouvée",
          "tokenHasExpired": "Votre session a expiré"
        }
      },
      "search": {
        "noResults": "Aucun résultat",
        "options": {
          "sortType": {
            "creationDate": "Date de création",
            "identifier": "Identifiant principal",
            "lastModification": "Dernière modification",
            "mainTitle": "Titre principal",
            "referenceNumber": "Numéro de référence"
          }
        },
        "queryPlaceholder": "Mots clés ou N° Inventaire",
        "title": "Objets de musée",
        "totalCount": "{totalResults}  Résultat(s) : 1 -"
      },
      "searchFeaturedCard": {
        "consultLastReport": "VOIR LE DERNIER CONSTAT CLOTURÉ",
        "createNewReport": "CRÉER UN NOUVEAU CONSTAT",
        "createNewReportFromLast": "CONSTAT À PARTIR DU DERNIER CONSTAT",
        "institutionLabel": "Institution",
        "lastReportLabel": "Dernier constat d'état",
        "materialsAndTechniques": "Matériaux / Techniques",
        "measurements": "Dimensions",
        "noLinkedItem": "Aucun item n'est lié à ce constat d'état"
      },
      selectItemErrorDialog: {
        cancel: "Abandonner l'objet",
        cancelAll: "Abandonner tous les objets",
        description: "La sélection de {0} objets a échoué.",
        retry: "Réessayer pour cet objet",
        retryAll: "Réessayer pour tous les objets",
        title: "Échec lors de la sélection des images",
      },
      "serviceWorker": {
        "updateAvailable": "Une mise à jour a été installée. Cliquez ici pour recharger la page ou relancez l'application",
        forceServiceWorkerUpdate: {
          modalTitle: "Résolution du problème",
          versionCorrect: "Les informations ci-dessous correspondent-elles à la version et la date transmises par SKINsoft après la dernière mise à jour ?",
          yes: "Oui",
          no: "Non",
        },
      },
      "signatureModuleScreen": {
        "cardTitle": "Signataire",
        "eraseSignature": "Signer à nouveau",
        "missingSignature": "Signature manquante",
        "nameLabel": "Signataire",
        "positionOfSignatory": "Fonction du signataire",
        "presentSignature": "Signature présente",
        "saveSignature": "Enregistrer",
        "signatureStatus": "Statut de la signature",
        "title": "Signatures"
      },
      "synchroModal": {
        "title": "Synchronisation",
        "lastFetch": "Dernière récupération",
        "duration": "Durée",
        "status": "Statut",
        "details": "Détails",
        "lastSynchro": "Dernière synchronisation",
        "noEntityToSync": "Aucune entité à synchroniser",
        "connectionWarningPrefix": "Vous devez être connecté à internet pour pouvoir",
        "connectWarningSend": "envoyer",
        "connectWarningRetrieve": "récupérer",
        "connectionWarningSuffix": "des données",
        "noDataToSync": "Aucune donnée à synchroniser pour le moment",
        "localIconInfoPrefix": "L'icône",
        "localIconInfoSuffix": " indique que les données correspondantes ont été modifiées localement et devront être synchronisées avec la base de données distante.",
        "retrieveAll": "Tout récupérer",
        "finishedSynchros": "synchronisations terminées",
        "syncAll": "Tout synchroniser",
        "remainsToSynchronize": "Reste à synchroniser",
        cleanImageCache: "Supprimer les images fantômes du cache",
        cachedImagedCleaned: "Les images fantômes ont été supprimées !",
        cleanCacheDown: "Vider le cache",
        cacheDownCleaned: "Le cache a été vidé",
        cleanCacheUp: "Supprimer toutes les modifications non synchronisées",
        cacheUpCleaned: "Toute les modifications non synchronisées ont étés supprimées",
      },
      "entityNames": {
        "items": "Items",
        archives: "Archives",
        "auditRecords": "Fiches de récolement",
        "audits": "Projets de récolement",
        "thesaurusTerms": "Termes de thésaurus",
        "thesaurus": "Thésaurus",
        "entityFields": "Données système",
        "collaborators": "Collaborateurs",
        "authorities": "Autorités",
        "aliases": "Alias",
        "locations": "Localisations",
        "conditionReports": "Constats d'état",
        works: "Oeuvres",
        expressions: "Expressions",
        manifestations: "Manifestations",
        specimens: "Spécimens"
      },
      "time": {
        "hours": "heure(s)",
        "minutes": "minute(s)",
        "seconds": "seconde(s)"
      },
      "thesaurusTermCreateForm": {
        "formTitle": "Création d'un terme",
        "openButtonTitle": "Créer un terme",
        "createButton": "Valider",
        "anotherTermButton": "Valider et créer un autre terme",
        "cancelButton": "Annuler",
        "preferedTermLabel": "Terme préféré :",
        "synonymLabel": "Employé pour :",
        "genericTermPlaceholder": "Générique :",
        "selectSpecificLabel": "Sélectionner des termes spécifiques",
        disabledOffline: "La création d’un nouveau terme n’est pas disponible en usage hors-ligne de l’application",
      },
      "thesaurusTermTree": {
        "creationTabTitle": "Création",
        errors: {
          searchError: "La recherche a échouée",
          fetchError: "Impossible de récupérer les termes de thésaurus"
        },
        "modalSearchInputPlaceholder": "Rechercher un terme",
        "selectionTabTitle": "Sélection",
        "thesaurusTermSelectorModalTitle": "Sélectionner un terme",
        "validate": "Valider",
      },
      uploadImageFailureDialog: {
        cancel: "Abandonner l'image {0}",
        cancelAll: "Abandonner toutes les images",
        description: "Le téléversement de {0} images a échoué.",
        imageAndNumber: "Image {0}",
        retry: "Réessayer pour l'image {0}",
        retryAll: "Réessayer pour toutes les images",
        title: "Échec lors du téléversement des images",
      },
      "state": {
        "all": "Tous",
        "archived": "Archivé",
        "canceled": "Annulé",
        "finalized": "Terminé",
        "inPreparation": "En préparation",
        "inProgress": "En cours",
        "programmed": "Planifié",
        "toValidated": "À valider",
        "validated": "Validé",
        "aborted": "Interrompue",
        "success": "Terminée avec succès",
        "error": "Erreur",
        "none": "Aucune synchronisation précédente"
      },
      "SpecimenSearchScreen": {
        "createNewSpecimen": "CRÉER UN NOUVEAU SPÉCIMEN"
      },
    },
    "fr-DIOR": {
      "pdfDocument": {
        "mainTitlePrefix": "CONSTAT D'ETAT - ",
        "objectSection": {
          "sectionTitle": "Objet / Object",
          "inventoryNumber": "N° d'inventaire / Inventory number : ",
          "title": "Titre / Title : ",
          "author": "Créateur / Creator : ",
          "creationDate": "Date de création / Date of creation : ",
          "typology": "Type / Type : ",
          "denomination": "TRANSLATION IN PROGRESS",
          "materialsAndTechniques": "Matériaux et techniques / Materials and techniques : ",
          "dimensions": "Dimensions / Dimensions : ",
          "institution": "Institution propriétaire / Owning institution : ",
          "conditioning": "Conditionnement / Packing : ",
          "descriptions": "Description / Description : ",
          "domains": "Catégorie / Category : ",
          "identification": "N° de passage / Look number : ",
          "location": "Localisation / Location : ",
          "materials": "Matériau(x) / Materials : ",
          "ownerInstitutions": "Institution propriétaire / Owning institution : ",
          "techniques": "Technique(s) / Techniques : "
        },
        "alterationsSection": {
          "detailedAlteration": "Altération détaillée / Detailed alteration",
          "noAnnotation": "Aucune annotation à afficher / No annotations",
          "observationLabel": "Obs.",
          "sectionTitle": "Altérations / Alterations"
        },
        "detailedViewsSection": {
          "sectionTitle": "Détails des altérations / Details of alterations"
        },
        "finalObservationsSection": {
          "sectionTitle": "Observations finales / Final observations"
        },
        "contextSection": {
          "comments": "Commentaires / Comments : ",
          "editors": "Rédacteurs / Editors : ",
          "matAndTechs": "Matériaux et techniques / Materials and techniques : ",
          "reportDate": "Date du constat / Date of the report : ",
          "reportPlace": "Lieu / Place : ",
          "reportReference": "Référence du constat / Report reference : ",
          "sectionTitle": "Contexte du présent constat d'état / Context of the report",
          "reportType": "Type de constat / Type of report : ",
          "reportReason": "Motif du constat / Reason of the report : "
        },
        "reportSection": {
          "counterSignaturesTitle": "Contre-signatures / Countersignatures",
          "counterSignature": {
            "comment": "Commentaire /Comment : "
          },
          "interventionsToSchedule": "Interventions à prévoir / Upcoming interventions : ",
          "sectionTitle": "Rapport / Report",
          "signatoriesTitle": "Constat effectué en présence de / Inspection carried out in the presence of : ",
          "stateOfConservation": "État du bien / Condition of the item : ",
          "treatmentPriority": "Priorité de traitement / Treatment priority : "
        },
        "footer": {
          "prefix": "CONSTAT D'ETAT / CONDITION REPORT",
          "separator": "- Page "
        },
        "generationFailureAlert": "La génération du PDF a échoué, veuillez réessayer plus tard"
      }
    },
    "fr-ca": {
      "countryCode": "ca",
      "actionBar": {
        "bar": {
          "inProgress": "En cours",
          "latest": "Terminés"
        },
        "sideMenu": {
          "saveModifications": "Sauvegarder les modifications",
          "reportOverview": "Aperçu du constat d'état",
          "signReport": "Signer le constat d'état",
          "closeReport": "Clôturer le constat d'état",
          "countersignReport": "Contre-signer le constat d'état",
          "printReport": "Imprimer le constat d'état",
          "deleteReport": "Supprimer le constat en cours",
          "deleteReportOfflineWarning": "Attention, cet élément n'est pas synchronisé !",
          "deleteModificationsNotSynchronized": "Supprimer les modifications non synchronisées",
          "duplicateReport": "Dupliquer le constat d'état",
          "confirmDeletion": "Confirmer la suppression"
        }
      },
      "alerts": {
        "medias": {
          "failUpload": "Échec du téléversement du média.",
          "failGetIdFromFileName": "Le média a été téléversé, mais Skin-Reporter ne parvient pas à le trouver.",
        },
        "permissions": {
          "camera": {
            askForPermission: "SKR-Condition Report a besoin de la permission d'accéder à la caméra. Cette permission est nécessaire pour les fonctionnalités de scan de code-barre/QR-code. Sans cette permission ces fonctionnalités ne pourront être assurées.",
            permissionDeniedWarning: "La permission d'accéder à la caméra a été refusée à SKR-Condition Report auparavant. Les fonctionnalités de scan de code-barre/QR-code ne sont donc pas disponible. Pour pouvoir y accéder, merci d'autoriser manuellement l'accès à la caméra pour SKR-Condition Report.",
          }
        },
        "workspace": {
          "unableToChangeWorkspace": "Échec du changement d'espace de travail",
          "unableToLoadWorkspace": "Le chargement de l'espace de travail a échoué",
        },
      },
      alterationDetailImagePopup: {
        title: "Vues détaillées de l'altération {0}",
      },
      alterationCard: {
        moreMenu: {
          deleteAlteration: "Supprimer l'altération",
          changeAlterationTitle: "Changer le titre de l'altération",
          changeAlterationType: "Changer le type d'altération",
          titleModalHeader: "Éditer le titre de l'altération",
          titleModalButton: 'Valider',
        },
        titleAutoCompletePlaceHolder: "Titre",
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Vos identifiants sont incorrects",
            "network": "La communication avec le serveur a échoué"
          },
          "form": {
            "password": {
              "error": "Veuillez saisir votre nom d'utilisateur",
              "label": "Mot de passe"
            },
            "submit": "Se connecter",
            "submitting": "Connexion...",
            "username": {
              "error": "Veuillez saisir votre mot de passe",
              "label": "Nom d'utilisateur"
            }
          }
        },
        "renew": {
          "slowNetwork": "Cela semble mettre plus de temps que d'habitude, ne quittez pas l'application.",
          "spinner": "Nous vous reconnectons..."
        },
        sso: {
          errors: {
            authenticationFailed: "Erreur : impossible de finaliser l'authentification."
          },
          selectIDP: "S'authentifier avec...",
          otherIDPs: "Autres types de comptes",
        },
      },
      autoCompleteTextField: {
        modal: {
          okButton: "Ok",
        },
      },
      cameraScanner: {
        scanCode: "Scanner un code-barre",
        cancel: "Annuler",
        errors: {
          cameraNotFound: "Aucune caméra n'a été détectée",
        },
      },
      "closeReportScreen": {
        "important": "IMPORTANT",
        "close": "Clôturer",
        "title": "Clôture du constat d'état",
        "notificationContent": "Le constat '{referenceNumber}' a été clôturé, l'état de l'objet lié a été mis à jour.",
        "warningMessage": "Un constat clôturé ne peut être modifié ni supprimé",
        "warningQuestion": "Souhaitez-vous réellement poursuivre la clôture du constat d'état ?",
        "transferingFile": "Transfert du document PDF...",
        "fileGeneration": "Génération du document pdf final...",
        "reportClosing": "Clôture du constat d'état...",
        errors: {
          transitionState: "Une erreur est survenue lors de la clôture du constat, le PDF a bien été généré et ajouté au constat d'état.",
          pushingPDF: "L'ajout du PDF généré au constat d'état a échoué. Abandon de la clôture.", 
        },
      },
      counterSignatureModuleScreen: {
        title: "Contre-Signature",
        saveButton: "Valider",
        warnings: {
          exit: 'Attention ! Si vous quittez la page le travail actuel sera perdu',
          okButton: 'Continuer',
          cancelButton: 'Annuler',
          save: 'Une fois les contre-signatures sauvegardées, elles ne pourront plus être modifiées ultérieurement !',
        },
      },
      "defectTree": {
        "alteration": {
          "alterationLabel": "Type :",
          "alterationsTitle": "Altérations :",
          "createAlterationButtonLabel": "Alteration",
          "levelTitle": "Niveau 3",
          "precisionLabel": "Précision :",
          "deleteConfirmationMessage": "Confirmer la suppression de l'altération et de son contenu ?",
          "precisionPlaceholder": "Sélectionnez un sous-type",
          "thesaurusTermWarningMessage": "Le type d'altération sélectionné ne correspond pas au matériau ci-dessus",
          "typeOfAlterationPlaceholder": "Sélectionnez un type d'observation"
        },
        "annotation": {
          "annotationsTitle": "Annotations :",
          "commentsPlaceholder": "Précisez...",
          "deleteConfirmationMessage": "Confirmer la suppression ?",
          "defaultImageConfirmationMessage": "Définir comme image par défaut ?"
        },
        "defect": {
          "createElementButtonLabel": "Élément",
          "deleteConfirmationMessage": "Confirmer la suppression de l'élément et de son contenu ?",
          "elementLabel": "Elément :",
          "precisionLabel": "Précision",
          "elementPlaceholder": "Nom de l'élément",
          "precisionPlaceholder": "Précisez..."
        },
        "material": {
          "createMaterialButtonLabel": "Matériau",
          "deleteConfirmationMessage": "Confirmer la suppression du matériau et de son contenu ?",
          "levelTitle": "Niveau 2",
          "materialLabel": "Matériau :",
          "materialsTitle": "Matériaux :",
          "thesaurusTermWarningMessage": "Le matériau sélectionné ne correspond pas au type d'observation ci-dessus"
        },
        "observation": {
          "createObservationButtonLabel": "Observation",
          "deleteConfirmationMessage": "Confirmer la suppression de l'observation et de son contenu ?",
          "levelTitle": "Niveau 1",
          "observationLabel": "Type d'observation :",
          "observationsTitle": "Observations :"
        },
        "submit": "Sauvegarder les modifications",
        "submitError": "L'arbre n'a pas pu être mis à jour",
        "submitting": "Sauvegarde en cours..."
      },
      "drawingEditor": {
        "title": "Altération détaillée",
        "imageCaption": "Légende :",
        "imageTitlePlaceholder": "Saisir la légende de l'image",
        "alterationLabel": "{index}",
        "alterationModalTitle": "Sélectionner une altération",
        "observationPlaceholder": "Entrez une observation",
        "validate": "Enregistrer",
        errors: {
          alteration: "Alteration ",
          missingTitleOrType: "Veuillez renseigner un titre ou un type d'altération pour chaque altération.",
          failedUploadDetailedImageDescription: "Le téléversement de {0} images de vues détaillées des altérations {1} a échoué",
        },
        "alterationLine": {
          precisionModal: {
            title: "Précision",
            validateButton: "Valider",
          },
          titlePlaceHoder: "Titre de l'altération...",
          typeOfAlterationPlaceholder: "Type d'altération...",
        },
      },
      "editItemScreen": {
        "author": "Auteur",
        "confirmButton": "Valider",
        "editButton": "Modifier",
        "inventoryNumber": "N° d'inventaire",
        "saveNotification": {
          "errorMessage": "Une erreur est survenue pendant la sauvegarde de l'objet",
          "inventoryNumberNotUnique": "Validation impossible, le numéro d'identification de la notice existe déjà",
          "successMessage": "L'objet a été sauvegardé avec succès"
        },
        sections: {
          creation: "Création",
          description: "Description",
          identification: "Identification",
          location: "Localisation",
          notes: "Notes",
          state: "État",
        },
        "deleteNotification": {
          "errorMessage": "Une erreur est survenue pendant la suppression de l'objet non synchronisés",
          "successMessage": "L'objet a été supprimé avec succès"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Une erreur est survenue pendant la suppression des modifications non synchronisées",
          "successMessage": "Les modifications ont été annulées"
        },
        "errorMessages": {
          "inventoryNumberNotUnique": "Ce numéro d'inventaire est déjà attribué"
        },
        "menu": {
          "saveModifications": "Sauvegarder les modifications",
          "deleteNotSynchronizedNewItem": "Supprimer le nouvel objet",
          "deleteModificationsNotSynchronized": "Supprimer les modifications non synchronisées",
          "offlineWarning": "Les modifications sont sauvegardées sur l'appareil, vous devrez les synchroniser avec la base de données lorsque le réseau sera de nouveau disponible.",
          "offlineShortWarning": "Modifié sur cet appareil"
        },
        "fieldDisabledOffline": "La saisie de ce champ n'est pas disponible en mode hors-ligne"
      },
      "editReportScreen": {
        "alerts": {
          duplicateClosedReport: {
            success: "Le constat a été dupliqué avec succès",
            failure: "La duplication du constat a échoué",
            warningReportNotClosed: "Le constat doit être cloturé pour pouvoir être dupliqué",
          }
        },
        "reportTitlePrefix": "Constat N° {refNumber}",
        "reportStatusInProgress": "En cours",
        "reportIdentifiers": {
          "accordionPanelTitle": "IDENTIFIANTS DU CONSTAT",
          "referenceNumber": "N° de référence",
          "numberingInformation": "Laisser vide pour activer la numérotation automatique à la prochaine sauvegarde",
          "otherIdentifiers": "Autres identifants",
          "reportReason": "Motif du constat",
          "precision": "Précision",
          "reportType": "Type de constat",
          "reportTypePlaceholder": "Sélectionnez un type de constat",
          "tabTitle": "Identification"
        },
        "reportContext": {
          "accordionPanelTitle": "CONTEXTE DU CONSTAT D'ÉTAT",
          "reportDate": "Date du constat",
          "reportDoneInThePresenceOf": "Constat effectué en présence de",
          "andOf": "Et de",
          "name": "Nom/Prénom, Qualité",
          "role": "Qualité",
          "coordinates": "Coordonnées",
          "email": "Email",
          "signer": "Signataire",
          "reportPlace": "Lieu du constat",
          "customer": "Client/Commanditaire",
          "precisions": "Précisions",
          "linkedProject": "Projet Lié",
          "linkedMovement": "Mouvement Lié",
          "technicsAndMaterials": "Techniques et matériels utilisés",
          "comments": "Commentaires",
          "signerComponent": {
            "title": "Signataires",
            "name": "Signataire",
            "date": "Date de signature",
            "positionOfSignatory": "Fonction du signataire",
          },
          counterSignatureComponent: {
            comment: "Commentaire",
            location: "Lieu",
            reason: "Motif",
            date: "Date",
          },
          counterSignaturesComponent: {
            title: "Contre-signatures",
          },
          "counterSignerComponent": {
            "name": "Nom/Prénom",
            "function": "Fonction",
            signature: 'Signature',
          },
          counterSignersComponent: {
            title: "Constat effectué en présence de :",
          },
        },
        "alterations": {
          "accordionPanelTitle": "ALTÉRATIONS",
          "mediasSectionTitle": "IMAGES DU CONSTAT",
          "globalAlterationSectionTitle": "ALTÉRATIONS GÉNÉRALES",
          "createAlterationForm": {
            "createAlterationButtonTitle": "Créer",
            "alterationTypeLabel": "Type d'altération",
            "precisionLabel": "Précision"
          },
          "tabTitle": "Altérations",
          viewMenu: {
            alterationTypeView: "Vue par type d'altération",
            imageView: 'Vue photos',
            titleView: 'Vue par titre',
          },
        },
        "conservation": {
          "accordionPanelTitle": "CONSERVATION ET MANIPULATION"
        },
        "observations": {
          "tabTitle": "Bilan",
          "accordionPanelTitle": "RAPPORT ET OBSERVATIONS",
          "commentsFieldLabel": "Commentaires",
          "countersignature": "Contre-signatures",
          "interventionToSchedule": "Interventions à prévoir",
          "interventionToSchedulePlaceholder": "Choisissez une intervention",
          "interventionToSchedulePrecision": "Précision :",
          "stateOfConservation": "Etat du bien",
          "stateOfConservationPlaceholder": "Choisissez un état",
          "signature": "Signatures",
          "typeOfStateOfConservation": "Type d'état",
          "treatmentPriority": "Priorité de traitement",
          "treatmentPriorityPlaceholder": "Choississez une priorité"
        },
        "medias": {
          "accordionPanelTitle": "MÉDIAS"
        },
        "saveAlert": {
          "errorMessage": "Une erreur est survenue pendant la sauvegarde du constat",
          "inventoryNumberNotUnique": "Validation impossible, le numéro d'identification de la notice existe déjà",
          "successMessage": "Constat d'état sauvegardé"
        },
        "deleteAlert": {
          "errorMessage": "Une erreur est survenue pendant la suppression du constat",
          "successMessage": "Constat d'état supprimé"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Une erreur est survenue pendant la suppression des modifications non synchronisées",
          "successMessage": "Les modifications ont été annulées"
        },
        "fieldDisabledOffline": "La saisie de ce champ n'est pas disponible en mode hors-ligne",
        pdf: {
          counterSignaturePDF: {
            startGenerating: "La génération du PDF a démarré",
            success: "Génération du PDF terminée avec succès",
            failure: "Échec de la génération du PDF",
          },
        },
      },
      "editRecordScreen": {
        "foldAll": "Réduire tout",
        "unfoldAll": "Déployer tout",
        "medias": {
          "accordionPanelTitle": "MÉDIAS"
        }
      },
      "firewall": {
        "collabWarningMessage": "Votre compte n'a pas de collaborateur associé, l'application peut dysfonctionner",
        "noGroupForUserWarningMessage": "L'usage de SKINreporter requiert que votre compte utilisateur soit lié à un groupe d'utilisateurs"
      },
      "itemCreationImagePopup": {
        "title": "Ajouter une image",
        "addImage": "AJOUTER UNE IMAGE",
        "ignore": "PLUS TARD, IGNORER CETTE ETAPE"
      },
      "itemSearchScreen": {
        "createNewItem": "CRÉER UN NOUVEL OBJET"
      },
      "listReportScreen": {
        "closed": {
          "downloadFailure": "Une erreur est survenue pendant le téléchargement",
          "downloadSuccess": "Le document {docTitle} a été téléchargé",
          "open": "TÉLÉCHARGER LE DOCUMENT",
          "title": "Constats d'état terminés"
        },
        "inProgress": {
          "edit": "EDITER LE CONSTAT",
          "title": "Constats d'état en cours d'édition"
        },
        "concernedItem": "Objet de musée concerné",
        "nbResults": "{nbResults} résultats",
        "noResults": "Aucun résultat"
      },
      "locationSelector": {
        "inputPlaceholder": "Entrez une localisation",
        "title": "Choisissez une localisation",
        "validate": "Valider"
      },
      "maskFields": {
        "boolean": {
          "no": "Non",
          "undefined": "Non défini",
          "yes": "Oui"
        },
        "entitySelect": {
          "modalPlaceholder": "Mots clés ou identifiants..."
        }
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Déployé le",
          "checkForUpdate": {
            "help": "Si une mise à jour est disponible, elle s'installera automatiquement.",
            "title": "Vérifiez les mises à jour"
          },
          "clearCache": {
            "help": "Si vous êtes hors-ligne, cela supprime l'accès à toutes les données stockées sur l'appareil.",
            "title": "Vider le cache"
          },
          "overrideLocale": {
            "help": "La langue anglaise sera utilisée et le paramétrage de votre terminal ignoré.",
            "title": "Forcer la langue anglaise"
          },
          "resetLocaleOverride": {
            "help": "La langue utilisé dépendra du paramètrage de votre terminal",
            "title": "Réinitialiser la langue"
          },
          "serviceWorker": {
            help: "Le bandeau de mise à jour s'affiche continuellement ? Cliquez ici !",
            title: "Fermer le bandeau de mise à jour",
          },
          "title": "Skin-REPORTER",
          "version": "version",
        },
        "logout": "Etes-vous sûr de vouloir vous déconnecter ?"
      },
      "offlineRibbon": {
        "offline": "Vous êtes hors connexion",
        "online": "Vous êtes connecté"
      },
      "pdfOverviewScreen": {
        "download": "Télécharger",
        "progressBar": {
          "mainLabel": "Génération du document ...",
          "object": "Objet",
          "generalDigest": "Appréciation Générale",
          "defects": "Altérations",
          "contextAndSignatures": "Contexte",
          "documentReady": "Document prêt !"
        },
        "title": "Aperçu",
        "renderFailureAlert": "Impossible d'afficher le PDF, veuillez réessayer plus tard"
      },
      "pdfDocument": {
        "mainTitlePrefix": "CONSTAT D'ETAT - ",
        "objectSection": {
          "sectionTitle": "Objet",
          "inventoryNumber": "N° d'inventaire : ",
          "title": "Titre : ",
          "author": "Artiste / Auteur :",
          "creationDate": "Date de création : ",
          "typology": "Typologie : ",
          "denomination": "Dénomination : ",
          "materialsAndTechniques": "Matériaux et techniques :",
          "dimensions": "Dimensions : ",
          "institution": "Institution :",
          conditioning: "Conditionnement :",
          descriptions: "Description(s) :",
          domains: "Discipline(s) :",
          identification: "Identification :",
          location: "Emplacement :",
          materials: "Matériau(x) :",
          ownerInstitutions: "Institution(s) propriétaire(s) :",
          techniques: "Technique(s) :",
        },
        "alterationsSection": {
          "detailedAlteration": "Altération détaillée",
          "noAnnotation": "Aucune annotation à afficher",
          "observationLabel": "Obs.",
          "sectionTitle": "Altérations"
        },
        detailedViewsSection: {
          sectionTitle: "Détails des altérations",
        },
        "finalObservationsSection": {
          "sectionTitle": "Observations finales"
        },
        "contextSection": {
          "comments": "Commentaires :",
          "editors": "Rédacteurs :",
          "matAndTechs": "Matériaux et techniques :",
          "reportDate": "Date du constat :",
          "reportPlace": "Lieu : ",
          "reportReason": "Motif du constat : ",
          "reportReference": "Référence du constat :",
          "reportType": "Type de constat : ",
          "sectionTitle": "Contexte du présent constat d'état",
        },
        "reportSection": {
          "counterSignaturesTitle": "Contre-signatures",
          counterSignature: {
            comment: 'Commentaire :',
          },
          "interventionsToSchedule": "Interventions à prévoir : ",
          "sectionTitle": "Rapport",
          "signatoriesTitle": "Constat effectué en présence de :",
          "stateOfConservation": "Etat du bien : ",
          "treatmentPriority": "Priorité de traitement : "
        },
        "footer": {
          "prefix": "CONSTAT D'ETAT",
          "separator": "- Page "
        },
        "generationFailureAlert": "La génération du PDF a échoué, veuillez réessayer plus tard"
      },
      "proxy": {
        "error": {
          "default": "Une erreur s'est produite sur la ressource {uri}",
          "network": "La communication avec le serveur a échoué",
          "notFound": "La ressource {uri} n'a pas été trouvée",
          "tokenHasExpired": "Votre session a expiré"
        }
      },
      "search": {
        "noResults": "Aucun résultat",
        "options": {
          "sortType": {
            "creationDate": "Date de création",
            "identifier": "Identifiant principal",
            "lastModification": "Dernière modification",
            "mainTitle": "Titre principal",
            "referenceNumber": "Numéro de référence"
          }
        },
        "queryPlaceholder": "Mots clés ou N° Inventaire",
        "title": "Objets de musée",
        "totalCount": "{totalResults}  Résultat(s) : 1 -"
      },
      "searchFeaturedCard": {
        "consultLastReport": "VOIR LE DERNIER CONSTAT CLOTURÉ",
        "createNewReport": "CRÉER UN NOUVEAU CONSTAT",
        "createNewReportFromLast": "CONSTAT À PARTIR DU DERNIER CONSTAT",
        "institutionLabel": "Institution",
        "lastReportLabel": "Dernier constat d'état",
        "materialsAndTechniques": "Matériaux / Techniques",
        "measurements": "Dimensions",
        "noLinkedItem": "Aucun item n'est lié à ce constat d'état"
      },
      selectItemErrorDialog: {
        cancel: "Abandonner l'objet",
        cancelAll: "Abandonner tous les objets",
        description: "La sélection de {0} objets a échoué.",
        retry: "Réessayer pour cet objet",
        retryAll: "Réessayer pour tous les objets",
        title: "Échec lors de la sélection des images",
      },
      "serviceWorker": {
        "updateAvailable": "Une mise à jour a été installée. Cliquez ici pour recharger la page ou relancez l'application",
        forceServiceWorkerUpdate: {
          modalTitle: "Résolution du problème",
          versionCorrect: "Les informations ci-dessous correspondent-elles à la version et la date transmises par SKINsoft après la dernière mise à jour ?",
          yes: "Oui",
          no: "Non",
        },
      },
      "signatureModuleScreen": {
        "cardTitle": "Signataire",
        "eraseSignature": "Signer à nouveau",
        "missingSignature": "Signature manquante",
        "nameLabel": "Signataire",
        "positionOfSignatory": "Fonction du signataire",
        "presentSignature": "Signature présente",
        "saveSignature": "Enregistrer",
        "signatureStatus": "Statut de la signature",
        "title": "Signatures"
      },
      "synchroModal": {
        "title": "Synchronisation",
        "lastFetch": "Dernière récupération",
        "duration": "Durée",
        "status": "Statut",
        "details": "Détails",
        "lastSynchro": "Dernière synchronisation",
        "noEntityToSync": "Aucune entité à synchroniser",
        "connectionWarningPrefix": "Vous devez être connecté à internet pour pouvoir",
        "connectWarningSend": "envoyer",
        "connectWarningRetrieve": "récupérer",
        "connectionWarningSuffix": "des données",
        "noDataToSync": "Aucune donnée à synchroniser pour le moment",
        "localIconInfoPrefix": "L'icône",
        "localIconInfoSuffix": " indique que les données correspondantes ont été modifiées localement et devront être synchronisées avec la base de données distante.",
        "retrieveAll": "Tout récupérer",
        "finishedSynchros": "synchronisations terminées",
        "syncAll": "Tout synchroniser",
        "remainsToSynchronize": "Reste à synchroniser",
        cleanImageCache: "Supprimer les images fantômes du cache",
        cachedImagedCleaned: "Les images fantômes ont été supprimées !",
        cleanCacheDown: "Vider le cache",
        cacheDownCleaned: "Le cache a été vidé",
        cleanCacheUp: "Supprimer toutes les modifications non synchronisées",
        cacheUpCleaned: "Toute les modifications non synchronisées ont étés supprimées",
      },
      "entityNames": {
        "items": "Items",
        "auditRecords": "Fiches de récolement",
        "audits": "Projets de récolement",
        "thesaurusTerms": "Termes de thésaurus",
        "thesaurus": "Thésaurus",
        "entityFields": "Données système",
        "collaborators": "Collaborateurs",
        "authorities": "Autorités",
        "aliases": "Alias",
        "locations": "Localisations",
        "conditionReports": "Constats d'état",
        works: "Oeuvres",
        expressions: "Expressions",
        manifestations: "Manifestations",
        specimens: "Spécimens"
      },
      "time": {
        "hours": "heure(s)",
        "minutes": "minute(s)",
        "seconds": "seconde(s)"
      },
      "thesaurusTermCreateForm": {
        "formTitle": "Création d'un terme",
        "openButtonTitle": "Créer un terme",
        "createButton": "Valider",
        "anotherTermButton": "Valider et créer un autre terme",
        "cancelButton": "Annuler",
        "preferedTermLabel": "Terme préféré :",
        "synonymLabel": "Employé pour :",
        "genericTermPlaceholder": "Générique :",
        "selectSpecificLabel": "Sélectionner des termes spécifiques",
        disabledOffline: "La création d’un nouveau terme n’est pas disponible en usage hors-ligne de l’application",
      },
      "thesaurusTermTree": {
        "creationTabTitle": "Création",
        errors: {
          searchError: "La recherche a échouée",
          fetchError: "Impossible de récupérer les termes de thésaurus"
        },
        "modalSearchInputPlaceholder": "Rechercher un terme",
        "selectionTabTitle": "Sélection",
        "thesaurusTermSelectorModalTitle": "Sélectionner un terme",
        "validate": "Valider"
      },
      uploadImageFailureDialog: {
        cancel: "Abandonner l'image {0}",
        cancelAll: "Abandonner toutes les images",
        description: "Le téléversement de {0} images a échoué.",
        imageAndNumber: "Image {0}",
        retry: "Réessayer pour l'image {0}",
        retryAll: "Réessayer pour toutes les images",
        title: "Échec lors du téléversement des images",
      },
      "state": {
        "all": "Tous",
        "archived": "Archivé",
        "canceled": "Annulé",
        "finalized": "Terminé",
        "inPreparation": "En préparation",
        "inProgress": "En cours",
        "programmed": "Planifié",
        "toValidated": "À valider",
        "validated": "Validé",
        "aborted": "Interrompue",
        "success": "Terminée avec succès",
        "error": "Erreur",
        "none": "Aucune synchronisation précédente"
      },
      "SpecimenSearchScreen": {
        "createNewSpecimen": "CRÉER UN NOUVEAU SPÉCIMEN"
      },
    },
    "nl": {
      "countryCode": "nl",
      "actionBar": {
        "bar": {
          "inProgress": "Schetsen",
          "latest": "Gesloten rapporten / Rapporten gesloten"
        },
        "sideMenu": {
          "saveModifications": "Bewaar wijzigingen",
          "reportOverview": "Overzicht van het conditierapport",
          "signReport": "Onderteken conditierapport",
          "closeReport": "Sluit conditierapport",
          "countersignReport": "Het conditierapport medeondertekenen",
          "printReport": "Druk conditierapport af",
          "deleteReport": "Verwijder huidig conditierapport",
          "deleteReportOfflineWarning": "Waarschuwing, dit element is niet gesynchroniseerd !",
          "deleteModificationsNotSynchronized": "Niet gesynchroniseerde wijzigingen verwijderen",
          "duplicateReport": "Het conditierapport dupliceren",
          "confirmDeletion": "Verwijdering bevestigen"
        }
      },
      "alerts": {
        "medias": {
          "failUpload": "Het uploaden van de media is mislukt.",
          "failGetIdFromFileName": "De media is geüpload, maar Skin-Reporter kan het niet vinden.",
        },
        "permissions": {
          "camera": {
            askForPermission: "SKR-Condition Report heeft toestemming nodig voor toegang tot de camera. Deze toestemming is nodig voor de barcode/QR-code scanfuncties. Zonder deze toestemming kunnen deze functies niet worden geleverd.",
            permissionDeniedWarning: "Toegang tot de camera is eerder geweigerd aan SKR-Condition Report. Barcode/QR-code scanfunctionaliteiten zijn daarom niet beschikbaar. Geef SKR-Condition Report handmatig toegang tot de camera om deze toch te kunnen gebruiken.",
          }
        },
        "workspace": {
          "unableToChangeWorkspace": "Niet gelukt om werkruimte te wijzigen",
          "unableToLoadWorkspace": "Laden van werkruimte mislukt",
        },
      },
      alterationDetailImagePopup: {
        title: "Gedetailleerde weergaven van wijzigingen {0}",
      },
      "alterationCard": {
        "moreMenu": {
          "deleteAlteration": "De wijziging verwijderen",
          "changeAlterationTitle": "De titel van de wijziging wijzigen",
          "changeAlterationType": "Het type wijziging wijzigen",
          "titleModalHeader": "Bewerk de titel van de wijziging",
          "titleModalButton": "Bevestig"
        },
        titleAutoCompletePlaceHolder: "Titel",
      },
      archiveCrEditScreenHeader: {
        materialImportance: "MISSING TRANSLATION",
        principalMediumType: "MISSING TRANSLATION",
      },
      archiveEditScreen: {
        saveAlert: {
          errorMessage: "MISSING TRANSLATION",
          successMessage: "MISSING TRANSLATION",
        },
      },
      archiveEditScreenHeader: {
        cote: "MISSING TRANSLATION",
        descriptionLevel: "MISSING TRANSLATION",
      },
      archiveSearchScreen: {
        createNewArchive: "MISSING TRANSLATION",
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Gebruikersnaam en/of paswoord niet correct",
            "network": "Communicatie met server mislukt"
          },
          "form": {
            "password": {
              "error": "Gelieve uw gebruikersnaam in te voeren",
              "label": "Paswoord"
            },
            "submit": "Inloggen",
            "submitting": "Aan het inloggen…",
            "username": {
              "error": "Gelieve uw paswoord in te voeren",
              "label": "Gebruikersnaam"
            }
          }
        },
        "renew": {
          "slowNetwork": "Dit duurt langer dan gebruikelijk. Gelieve de toepassing niet te sluiten.",
          "spinner": "We brengen u terug online "
        },
        sso: {
          errors: {
            authenticationFailed: "Error: authentificatie kon niet worden voltooid."
          },
          selectIDP: "Inloggen met…",
          otherIDPs: "Andere accounttypes",
        },
      },
      autoCompleteTextField: {
        modal: {
          okButton: "Ok",
        },
      },
      cameraScanner: {
        scanCode: "Scan de streepjescode",
        cancel: "Annuleren",
        errors: {
          cameraNotFound: "Geen camera's gedetecteerd",
        },
      },
      "closeReportScreen": {
        "important": "BELANGRIJK",
        "close": "Sluit conditierapport",
        "title": "Sluit conditierapport",
        "notificationContent": "Het rapport '{referenceNumber}' werd gesloten en de status van het gekoppelde object is bijgewerkt.",
        "warningMessage": "Eens gesloten kan het conditierapport niet meer gewijzigd of verwijderd worden",
        "warningQuestion": "Bent u zeker dat u het conditierapport wil sluiten?",
        "transferingFile": "Pdf-document aan het overzetten…",
        "fileGeneration": "Finale pdf wordt aangemaakt",
        "reportClosing": "Sluiten van het huidige conditierapport…",
        errors: {
          transitionState: "Er is een fout opgetreden bij het afsluiten van het rapport. De PDF is gegenereerd en toegevoegd aan het statusrapport.",
          pushingPDF: "De gegenereerde PDF is niet toegevoegd aan het statusrapport. Afsluiting afgebroken.", 
        },
      },
      counterSignatureModuleScreen: {
        title: "Tellerhandtekening",
        saveButton: "Bevestig",
        warnings: {
          exit: 'Waarschuwing! Als je de pagina verlaat, zal je huidige werk verloren gaan.',
          okButton: 'Ga verder',
          cancelButton: 'Annuleren',
          save: 'Als de medeondertekeningen eenmaal zijn opgeslagen, kunnen ze later niet meer worden gewijzigd!',
        },
      },
      createArchiveModal: {
        creationFailed: "MISSING TRANSLATION",
        descriptionLevel: "MISSING TRANSLATION",
        submitBtn: "MISSING TRANSLATION",
        submitting: "MISSING TRANSLATION",
        title: "MISSING TRANSLATION",
      },
      "defectTree": {
        "alteration": {
          "alterationLabel": "Soort beschadiging:",
          "alterationsTitle": "Beschadigingen: ",
          "createAlterationButtonLabel": "Beschadiging",
          "levelTitle": "Niveau 3",
          "precisionLabel": "Detail:",
          "deleteConfirmationMessage": "Bevestig schrapping van de schade",
          "precisionPlaceholder": "Selecteer subcategorie",
          "thesaurusTermWarningMessage": "De geselecteerde beschadiging komt niet overeen met de soort materiaal",
          "typeOfAlterationPlaceholder": "Selecteer soort observatie"
        },
        "annotation": {
          "annotationsTitle": "Annotatie",
          "commentsPlaceholder": "Verduidelijk",
          "deleteConfirmationMessage": "Bevestig schrapping?",
          "defaultImageConfirmationMessage": "Als standaardafbeelding instellen ?"
        },
        "defect": {
          "createElementButtonLabel": "Zone",
          "deleteConfirmationMessage": "Bevestig schrapping van de zone",
          "elementLabel": "Zone:",
          "precisionLabel": "Detail",
          "elementPlaceholder": "Naam van het element",
          "precisionPlaceholder": "Verduidelijk"
        },
        "material": {
          "createMaterialButtonLabel": "Materiaal",
          "deleteConfirmationMessage": "Bevestig schrapping van het materiaal",
          "levelTitle": "Niveau 2",
          "materialLabel": "Materiaal:",
          "materialsTitle": "Materialen:",
          "thesaurusTermWarningMessage": "Het geselecteerde materiaal komt niet overeen met het soort observatie"
        },
        "observation": {
          "createObservationButtonLabel": "Observatie",
          "deleteConfirmationMessage": "Bevestig schrapping van de observatie",
          "levelTitle": "Niveau 1",
          "observationLabel": "Soort observatie:",
          "observationsTitle": "Observaties:"
        },
        "submit": "Bewaar wijzigingen",
        "submitError": "De boomstructuur werd niet geüpdatet",
        "submitting": "Bewaren in verwerking…"
      },
      "drawingEditor": {
        "title": "Gedetailleerde beschadiging:",
        "imageCaption": "Beeldbijschrift:",
        "imageTitlePlaceholder": "Soort beeldbijschrift/Voer beeldbijschrift in",
        "alterationLabel": "{index}",
        "alterationModalTitle": "Selecteer een beschadiging",
        "observationPlaceholder": "Voer observatie in",
        "validate": "Bewaar",
        "errors": {
          alteration: "Wijziging ",
          "missingTitleOrType": "Voer een titel of type wijziging in voor elke wijziging",
          failedUploadDetailedImageDescription: "Het uploaden van {0} afbeeldingen van gedetailleerde weergaven van wijzigingen {1} is mislukt",
        },
        "alterationLine": {
          "precisionModal": {
            "title": "Precisie",
            "validateButton": "Bevestig"
          },
          "titlePlaceHoder": "Titel van de wijziging...",
          "typeOfAlterationPlaceholder": "Type wijziging..."
        }
      },
      "editItemScreen": {
        "author": "Auteur",
        "confirmButton": "Bevestig",
        "editButton": "Aanpassen",
        "inventoryNumber": "Inventarisnummer",
        "saveNotification": {
          "errorMessage": "Er is een fout opgetreden bij het bewaren van het item",
          "inventoryNumberNotUnique": "Onmogelijke validatie",
          "successMessage": "Item succesvol bewaard"
        },
        sections: {
          creation: "Aanmaak",
          description: "Beschrijving",
          identification: "Identificatie",
          location: "Locatie",
          notes: "Opmerkingen",
          state: "Status",
        },
        "deleteNotification": {
          "errorMessage": "TRANSLATING IN PROGRESS",
          "successMessage": "TRANSLATING IN PROGRESS"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Er is een fout opgetreden bij het verwijderen van niet-gesynchroniseerde wijzigingen",
          "successMessage": "De wijzigingen werden geannuleerd"
        },
        "errorMessages": {
          "inventoryNumberNotUnique": "Dit inventarisnummer is al toegekend"
        },
        "menu": {
          "saveModifications": "Save modifications",
          "deleteNotSynchronizedNewItem": "TRANSLATING IN PROGRESS",
          "deleteModificationsNotSynchronized": "TRANSLATING IN PROGRESS",
          "offlineWarning": "Modifications are saved on this device, you will have to synchronize them with the database when the network is back.",
          "offlineShortWarning": "Modified on this device"
        },
        "fieldDisabledOffline": "Dit veld is niet beschikbaar in offline modus"
      },
      "editReportScreen": {
        "alerts": {
          duplicateClosedReport: {
            success: "Het rapport is met succes gedupliceerd",
            failure: "Duplicatie van het rapport mislukt",
            warningReportNotClosed: "Het rapport moet gesloten zijn om gedupliceerd te kunnen worden",
          }
        },
        "reportTitlePrefix": "Rapportnummer {refNumber}",
        "reportStatusInProgress": "In verwerking",
        "reportIdentifiers": {
          "accordionPanelTitle": "ALGEMENE INFORMATIE",
          "referenceNumber": "Referentienummer",
          "numberingInformation": "Laat dit veld leeg om de automatische nummering te activeren van zodra het rapport is bewaard",
          "otherIdentifiers": "Andere identificatoren",
          "reportReason": "Reden conditierapport",
          "precision": "Detail",
          "reportType": "Rapporttype",
          "reportTypePlaceholder": "Selecteer een rapporttype",
          "tabTitle": "Identificatie"
        },
        "reportContext": {
          "accordionPanelTitle": "CONTEXT",
          "reportDate": "Datum van het rapport",
          "reportDoneInThePresenceOf": "Rapport geschreven in aanwezigheid van",
          "andOf": "en",
          "name": "Familienaam / Voornaam, Rol/Functie",
          "role": "Rol/Functie",
          "coordinates": "Contactgegevens",
          "email": "E-mail",
          "signer": "Personen die gemachtigd zijn om het rapport te ondertekenen",
          "reportPlace": "Plaats",
          "customer": "Klant",
          "precisions": "Details",
          "linkedProject": "Gerelateerd project",
          "linkedMovement": "Gerelateerde verplaatsing",
          "technicsAndMaterials": "Technieken en materialen",
          "comments": "Opmerkingen",
          "signerComponent": {
            "name": "Ondertekenaar",
            "date": "Datum ondertekening",
            "positionOfSignatory": "Positie van ondertekenaar",
            "title": "Ondertekenaar(s)",
          },
          counterSignatureComponent: {
            comment: "Opmerking",
            location: "Locatie",
            reason: "Reden",
            date: "Datum",
          },
          counterSignaturesComponent: {
            title: "Tegenhandtekeningen",
          },
          "counterSignerComponent": {
            "name": "Achternaam/voornaam",
            "function": "Functie",
            signature: 'Handtekening',
          },
          counterSignersComponent: {
            title: "Rapport opgemaakt in aanwezigheid van:",
          },
        },
        "alterations": {
          "accordionPanelTitle": "BESCHADIGINGEN",
          "mediasSectionTitle": "afbeeldingsrapporten",
          "globalAlterationSectionTitle": "ALGEMENE SCHADE",
          "createAlterationForm": {
            "createAlterationButtonTitle": "Aanmaken",
            "alterationTypeLabel": "Type schade",
            "precisionLabel": "Precisie"
          },
          "tabTitle": "Veranderingen",
          "viewMenu": {
            "alterationTypeView": "Weergeven op type wijziging",
            "imageView": "Foto bekijken",
            "titleView": "Weergeven op titel"
          }
        },
        "conservation": {
          "accordionPanelTitle": "CONSERVATIE EN MANIPULATIE"
        },
        "observations": {
          "tabTitle": "Balans",
          "accordionPanelTitle": "ALGEMENE INFORMATIE & AANBEVELINGEN",
          "commentsFieldLabel": "Opmerkingen",
          "countersignature": "Tegenhandtekeningen",
          "interventionToSchedule": "Geplande interventies",
          "interventionToSchedulePlaceholder": "Kies een interventie",
          "interventionToSchedulePrecision": "Detail :",
          "stateOfConservation": "Conservatiestaat",
          "stateOfConservationPlaceholder": "Kies een staat",
          "signature": "Handtekeningen",
          "typeOfStateOfConservation": "Type status",
          "treatmentPriority": "Behandelprioriteit",
          "treatmentPriorityPlaceholder": "Kies een prioriteit"
        },
        "medias": {
          "accordionPanelTitle": "BIJGEVOEGDE MULTIMEDIA"
        },
        "saveAlert": {
          "errorMessage": "Error bij het bewaren van het conditierapport",
          "inventoryNumberNotUnique": "Onmogelijke validatie",
          "successMessage": "Conditierapport werd bewaard"
        },
        "deleteAlert": {
          "errorMessage": "Error bij het verwijderen van het conditierapport",
          "successMessage": "Conditierapport werd verwijderd"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Er is een fout opgetreden bij het verwijderen van niet-gesynchroniseerde wijzigingen",
          "successMessage": "De wijzigingen werden geannuleerd"
        },
        "fieldDisabledOffline": "Dit veld is niet beschikbaar in offline modus",
        pdf: {
          counterSignaturePDF: {
            startGenerating: "Het genereren van PDF is gestart",
            success: "Het aanmaken van PDF's is voltooid",
            failure: "PDF genereren mislukt",
          }
        },
      },
      "editRecordScreen": {
        "foldAll": "Verminder alle",
        "unfoldAll": "Zet alle",
        "medias": {
          "accordionPanelTitle": "BIJGEVOEGDE MULTIMEDIA"
        }
      },
      "itemCreationImagePopup": {
        "title": "Een afbeelding toevoegen",
        "addImage": "EEN AFBEELDING TOEVOEGEN",
        "ignore": "LATER, NEGEER DEZE STAP"
      },
      "itemSearchScreen": {
        "createNewItem": "NIEUW ITEM MAKEN"
      },
      "firewall": {
        "collabWarningMessage": "Er is geen medewerker gelinkt aan uw account, de toepassing kan minder goed werken",
        "noGroupForUserWarningMessage": "Om SKIN-reporter te kunnen gebruiken moet uw gebruikersaccount gelinkt zijn aan een gebruikersgroep"
      },
      genericEditScreen: {
        genericErrorMsg: "MISSING TRANSLATION",
        saveErrorMsg: "MISSING TRANSLATION",
        saveSuccessMsg: "MISSING TRANSLATION",
      },
      "listReportScreen": {
        "closed": {
          "downloadFailure": "Error bij het downloaden van het document",
          "downloadSuccess": "Het document {docTitle} werd gedownload",
          "open": "Document openen",
          "title": "Afgewerkte conditierapporten"
        },
        "inProgress": {
          "edit": "BEWERK CONDITIERAPPORT",
          "title": "Schetsen"
        },
        "concernedItem": "Gerelateerde objecten",
        "nbResults": "{nbResults} Resultaten",
        "noResults": "Geen resultaten"
      },
      "locationSelector": {
        "inputPlaceholder": "Soort locatie",
        "title": "Selecteer locatie",
        "validate": "Valideer"
      },
      "maskFields": {
        "boolean": {
          "no": "Nee",
          "undefined": "Ongedefinieerd",
          "yes": "Ja"
        },
        "entitySelect": {
          "modalPlaceholder": "Trefwoorden of identificatoren"
        }
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Ingezet/Ontwikkeld op:",
          "checkForUpdate": {
            "help": "Als een update beschikbaar is, zal die automatisch worden geïnstalleerd.",
            "title": "Gelieve te controleren op updates"
          },
          "clearCache": {
            "help": "Als u offline bent, heeft u niet langer toegang tot alle gegevens die op uw toestel zijn opgeslagen.",
            "title": "Maak cache (tijdelijk geheugen) leeg"
          },
          "overrideLocale": {
            "help": "Het Engels zal worden gebruikt en de instellingen van uw apparaat zullen worden genegeerd.",
            "title": "Het Engels forceren"
          },
          "resetLocaleOverride": {
            "help": "De gebruikte taal zal afhangen van de instellingen van uw terminal",
            "title": "Stel taal opnieuw in"
          },
          "serviceWorker": {
            help: "Blijft het updatebanner verschijnen? Klik hier!",
            title: "Sluit de updatebanner",
          },
          "title": "Skin-REPORTER",
          "version": "versie",
        },
        "logout": "Bent u zeker dat u wil uitloggen?"
      },
      "offlineRibbon": {
        "offline": "U bent nu offline",
        "online": "U bent nu online"
      },
      "pdfOverviewScreen": {
        "download": "Download",
        "progressBar": {
          "mainLabel": "Document wordt voorbereid",
          "object": "Object",
          "generalDigest": "Algemene informatie",
          "defects": "Beschadiging",
          "contextAndSignatures": "Context",
          "documentReady": "Document is klaar!"
        },
        "title": "Overzicht",
        "renderFailureAlert": "PDF kan niet worden gemaakt, probeer het opnieuw"
      },
      "pdfDocument": {
        "mainTitlePrefix": "CONDITIERAPPORT - ",
        "objectSection": {
          "sectionTitle": "Object",
          "inventoryNumber": "Inventarisnummer:",
          "title": "Titel:",
          "author": "Kunstenaar / Auteur:",
          "creationDate": "Aanmaakdatum:",
          "typology": "Typologie:",
          "denomination": "Benaming:",
          "materialsAndTechniques": "Materialen en technieken:",
          "dimensions": "Afmetingen:",
          "institution": "Instelling:",
          conditioning: "Verpakking:",
          descriptions: "Beschrijving(en):",
          domains: "Domein:",
          identification: "Identificatie:",
          location: "Locatie:",
          materials: "Materia(a)l(en):",
          ownerInstitutions: "Instelling(en) die eigenaar is/zijn:",
          techniques: "Techniek(en):",
        },
        "alterationsSection": {
          "detailedAlteration": "Details van de beschadiging",
          "noAnnotation": "Geen annotatie om te tonen",
          "observationLabel": "Obs.",
          "sectionTitle": "Beschadigingen"
        },
        archiveSection: {
          sectionTitle: "MISSING TRANSLATION",
          archiveType: "MISSING TRANSLATION",
          conditioning: "MISSING TRANSLATION",
          cote: "MISSING TRANSLATION",
          descriptionLevel: "MISSING TRANSLATION",
          location: "MISSING TRANSLATION",
          materialImportance: "MISSING TRANSLATION",
          parentArchive: "MISSING TRANSLATION",
          productors: "MISSING TRANSLATION",
          productionDate: "MISSING TRANSLATION",
          proprietaryInstitution: "MISSING TRANSLATION",
          supportType: "MISSING TRANSLATION",
          title: "MISSING TRANSLATION",
        },
        detailedViewsSection: {
          sectionTitle: "Details van de beschadigingen",
        },
        "finalObservationsSection": {
          "sectionTitle": "Finale observaties"
        },
        conditioningSection: {
          crateNumber: "Kassanummer:",
          sectionTitle: "Verpakking",
          transportAccessories: "Transportaccessoires:",
          typeOfPackaging: "Soort verpakking:",
        },
        "contextSection": {
          "comments": "Opmerkingen:",
          "editors": "Redactie:",
          "matAndTechs": "Materialen en technieken:",
          "reportDate": "Datum van het rapport:",
          "reportPlace": "Plaats van het rapport:",
          "reportReference": "Rapportreferentie:",
          "reportType": "Rapporttype:",
          "reportReason": "Reden conditierapport:",
          "sectionTitle": "Context",
          signers: "Ondertekenaar(s):",
        },
        "reportSection": {
          "counterSignaturesTitle": "Tegenhandtekeningen",
          counterSignature: {
            comment: 'Opmerking:',
          },
          "interventionsToSchedule": "Interventies om in te plannen:",
          "sectionTitle": "Rapport",
          "signatoriesTitle": "Rapport opgemaakt in aanwezigheid van:",
          "stateOfConservation": "Conservatiestaat",
          "treatmentPriority": "Behandelprioriteit:"
        },
        "footer": {
          "prefix": "CONDITIERAPPORT",
          "separator": " - Pagina"
        },
        "generationFailureAlert": "PDF genereren mislukt, probeer opnieuw"
      },
      "proxy": {
        "error": {
          "default": "Error bij de hulpbron {uri}",
          "network": "Communicatie met server mislukt",
          "notFound": "De oplossing {uri} kon niet worden gevonden",
          "tokenHasExpired": "Uw sessie is vervallen"
        }
      },
      "search": {
        "noResults": "Geen resultaten",
        "options": {
          "sortType": {
            "creationDate": "Aanmaakdatum",
            "identifier": "Hoofdidentificator",
            "lastModification": "Laatste wijziging",
            "mainTitle": "Hoofdtitel",
            "referenceNumber": "Referentienummer"
          }
        },
        "queryPlaceholder": "Zoekopdracht",
        "title": "Objecten",
        "totalCount": "{totalResults}  Resulta(a)t(en) : 1 -"
      },
      "searchFeaturedCard": {
        "consultLastReport": "BEKIJK HET LAATSTE GESLOTEN VERSLAG",
        "createNewReport": "MAAK NIEUW CONDITIERAPPORT AAN",
        "createNewReportFromLast": "MAAK CONDITIERAPPORT AAN OP BASIS VAN HET LAATSTE RAPPORT",
        "institutionLabel": "Instelling",
        "lastReportLabel": "Laatste conditierapport",
        "materialsAndTechniques": "Materialen / Technieken",
        "measurements": "Afmetingen",
        "noLinkedItem": "Er is geen item gelinkt aan dit conditierapport"
      },
      selectItemErrorDialog: {
        cancel: "Object afbreken",
        cancelAll: "Alle objecten afbreken",
        description: "De selectie van {0} objecten is mislukt.",
        retry: "Herhaal voor dit object",
        retryAll: "Herhaal voor alle objecten",
        title: "Mislukt bij het selecteren van afbeeldingen",
      },
      "serviceWorker": {
        "updateAvailable": "Update werd geïnstalleerd. U kunt ofwel hier klikken om de pagina te vernieuwen ofwel de toepassing opnieuw opstarten",
        forceServiceWorkerUpdate: {
          modalTitle: "Het probleem oplossen",
          versionCorrect: "Komen de onderstaande gegevens overeen met de versie en datum die door SKINsoft zijn verstrekt na de laatste update ?",
          "yes": "Ja",
          "no": "Nee",
        },
      },
      "signatureModuleScreen": {
        "cardTitle": "Ondertekenaar",
        "eraseSignature": "Haal handtekening weg",
        "missingSignature": "Het conditierapport werd niet ondertekend",
        "nameLabel": "Ondertekenaar",
        "positionOfSignatory": "Positie van ondertekenaar",
        "presentSignature": "Het conditierapport werd ondertekend",
        "saveSignature": "Bewaar",
        "signatureStatus": "Status/Statuut van de handtekening",
        "title": "Handtekeningen"
      },
      "synchroModal": {
        "title": "Synchronisatie",
        "lastFetch": "Laatste recuperatie",
        "duration": "Duur",
        "status": "Status",
        "details": "Details",
        "lastSynchro": "Laaste synchronisatie",
        "noEntityToSync": "Niks om te synchroniseren",
        "connectionWarningPrefix": "U moet verbonden zijn met het internet om te",
        "connectWarningSend": "verzenden",
        "connectWarningRetrieve": "haal terug",
        "connectionWarningSuffix": "gegevens",
        "noDataToSync": "Geen gegevens om te synchroniseren op dit ogenblik",
        "localIconInfoPrefix": "Het icoon",
        "localIconInfoSuffix": " geeft aan dat de corresponderende gegevens lokaal zijn gewijzigd en moeten worden gesynchroniseerd met de databank.",
        "retrieveAll": "haal alles terug",
        "finishedSynchros": "Synchronisatie beëindigd",
        "syncAll": "Alles synchroniseren",
        "remainsToSynchronize": "Nog te synchroniseren",
        "cleanImageCache": "Spookafbeeldingen uit de cache verwijderen",
        "cachedImagedCleaned": "De spookbeelden zijn verwijderd!",
        "cleanCacheDown": "De cache wissen",
        "cacheDownCleaned": "De cache is geleegd!",
        "cleanCacheUp": "Alle niet gesynchroniseerde wijzigingen verwijderen",
        "cacheUpCleaned": "Alle niet gesynchroniseerde wijzigingen zijn verwijderd!"
      },
      "entityNames": {
        "items": "Items",
        archives: "MISSING TRANSLATION",
        "auditRecords": "Inventarisfiches",
        "audits": "Inventariscampagnes",
        "thesaurusTerms": "Thesaurusitems",
        "thesaurus": "Thesaurus",
        "entityFields": "Systeemgegevens",
        "collaborators": "Medewerkers",
        "authorities": "Autoriteiten",
        "aliases": "Aliassen",
        "locations": "Locaties",
        "conditionReports": "Conditierapporten",
        "works": "Werken",
        "expressions": "Expressies",
        "manifestations": "Verschijningsvormen",
        "specimens": "MISSING TRANSLATION"
      },
      "time": {
        "hours": "uur/uren",
        "minutes": "minuut/minuten",
        "seconds": "seconde(n)"
      },
      "thesaurusTermCreateForm": {
        "formTitle": "Termijn aanmaken",
        "openButtonTitle": "Termijn aanmaken",
        "createButton": "Bevestig",
        "anotherTermButton": "Bevestigen en andere termijn aanmaken",
        "cancelButton": "Annuleren",
        "preferedTermLabel": "Voorkeur term ",
        "synonymLabel": "Gebruikt voor",
        "genericTermPlaceholder": "Algemeen",
        "selectSpecificLabel": "Specifieke termen selecteren",
        "disabledOffline": "Een thesaurusTerm aanmaken terwijl u offline bent, is niet toegestaan"
      },
      "thesaurusTermTree": {
        "creationTabTitle": "Aanmaken",
        errors: {
          searchError: "De zoektocht was niet succesvol",
          fetchError: "Kan thesaurustermen niet ophalen"
        },
        "modalSearchInputPlaceholder": "Een term onderzoeken",
        "selectionTabTitle": "Selectie",
        "thesaurusTermSelectorModalTitle": "Selecteer een term",
        "validate": "Valideren"
      },
      uploadImageFailureDialog: {
        cancel: "Verlaat afbeelding {0}",
        cancelAll: "Verlaat alle afbeeldingen",
        description: "Het uploaden van {0} afbeeldingen is mislukt.",
        imageAndNumber: "Afbeelding {0}",
        retry: "Opnieuw proberen voor afbeelding {0}",
        retryAll: "Opnieuw proberen voor alle afbeeldingen",
        title: "Fout bij uploaden afbeelding",
      },
      "state": {
        "all": "Alle",
        "archived": "Gearchiveerd",
        "canceled": "Geannuleerd",
        "finalized": "Beëindigd",
        "inPreparation": "In voorbereiding",
        "inProgress": "In uitvoering",
        "programmed": "Gepland",
        "toValidated": "Moet worden gevalideerd",
        "validated": "Gevalideerd",
        "aborted": "Afgebroken",
        "success": "Succesvol beëindigd",
        "error": "Fout",
        "none": "Geen voorgaande synchronisatie"
      },
      "SpecimenSearchScreen": {
        "createNewSpecimen": "MISSING TRANSLATION"
      },
    },
    "es": {
      "countryCode": "es",
      "actionBar": {
        "bar": {
          "inProgress": "En curso",
          "latest": "Completado"
        },
        "sideMenu": {
          "saveModifications": "Guardar los cambios",
          "reportOverview": "Vista previa del informe de estado",
          "signReport": "Firmar el informe de estado",
          "closeReport": "Clausurar el informe de estado",
          "countersignReport": "Refrendar el informe de estado",
          "printReport": "Imprimir el informe de estado",
          "deleteReport": "Eliminar el informe actual",
          "deleteReportOfflineWarning": "Tenga en cuenta que este elemento no está sincronizado.",
          "deleteModificationsNotSynchronized": "Borrar cambios no sincronizados",
          "duplicateReport": "Duplicar el informe de estado",
          "confirmDeletion": "Confirmar eliminación"
        }
      },
      "alerts": {
        "medias": {
          "failUpload": "No se ha podido cargar el multimedia",
          "failGetIdFromFileName": "El multimedia se ha cargado, pero Skin-Reporter no puede encontrarlo",
        },
        "permissions": {
          "camera": {
            "askForPermission": "SKR-Condition Report necesita un permiso para acceder a la cámara. Este permiso es necesario para las funciones de escaneo de códigos de barras/códigos QR. Sin este permiso no se pueden proporcionar estas funciones.",
            "permissionDeniedWarning": "El permiso de acceso a la cámara se ha negado previamente a SKR-Condition Report. Por lo tanto, las funciones de escaneo de códigos de barras/QR no están disponibles. Para poder acceder a ellas, autorice manualmente el acceso a la cámara para SKR-Condition Report."
          }
        },
        "workspace": {
          "unableToChangeWorkspace": "Error al cambiar el espacio de trabajo",
          "unableToLoadWorkspace": "Error al cargar el espacio de trabajo"
        },
      },
      alterationDetailImagePopup: {
        title: "Detalles de la alteración {0}",
      },
      "alterationCard": {
        "moreMenu": {
          "deleteAlteration": "Eliminar la alteración",
          "changeAlterationTitle": "Cambiar el título de la alteración",
          "changeAlterationType": "Cambiar el tipo de alteración",
          "titleModalHeader": "Editar el título de la alteración",
          "titleModalButton": "Confirmar"
        },
        titleAutoCompletePlaceHolder: "Título",
      },
      archiveCrEditScreenHeader: {
        materialImportance: "MISSING TRANSLATION",
        principalMediumType: "MISSING TRANSLATION",
      },
      archiveEditScreen: {
        saveAlert: {
          errorMessage: "MISSING TRANSLATION",
          successMessage: "MISSING TRANSLATION",
        },
      },
      archiveEditScreenHeader: {
        cote: "MISSING TRANSLATION",
        descriptionLevel: "MISSING TRANSLATION",
      },
      archiveSearchScreen: {
        createNewArchive: "MISSING TRANSLATION",
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Sus datos de acceso son incorrectos",
            "network": "La comunicación con el servidor ha fallado"
          },
          "form": {
            "password": {
              "error": "Por favor, introduzca su nombre de usuario",
              "label": "Contraseña"
            },
            "submit": "Conectarse",
            "submitting": "Conectando...",
            "username": {
              "error": "Por favor, introduzca su contraseña",
              "label": "Nombre de usuario"
            }
          }
        },
        "renew": {
          "slowNetwork": "Está tomando más tiempo de lo habitual. Por favor no abandone la aplicación.",
          "spinner": "Reconectando…"
        },
        sso: {
          errors: {
            authenticationFailed: "Error: No se ha podido completar la autenticación"
          },
          selectIDP: "Autenticarse con...",
          otherIDPs: "Otros tipos de cuenta",
        },
      },
      autoCompleteTextField: {
        modal: {
          okButton: "OK",
        },
      },
      "cameraScanner": {
        "scanCode": "Escanear el código de barras",
        "cancel": "Cancelar",
        "errors": {
          "cameraNotFound": "No se ha detectado la cámara"
        }
      },
      "closeReportScreen": {
        "important": "IMPORTANTE",
        "close": "Clausurar ",
        "title": "Clausura del informe de estado",
        "notificationContent": "El informe '{referenceNumber}' ha sido clausurado y se ha actualizado el estado del objeto enlazado.",
        "warningMessage": "Un informe clausurado no puede modificarse ni borrarse",
        "warningQuestion": "¿Realmente desea continuar la clausura del informe de estado?",
        "transferingFile": "Transferir el documento PDF...",
        "fileGeneration": "Generación del documento pdf final...",
        "reportClosing": "Clausura del informe estado...",
        errors: {
          transitionState: "Se ha producido un error al cerrar el informe. Se ha generado el PDF y se ha añadido al informe de estado.",
          pushingPDF: "El PDF generado no se ha añadido al informe de estado. Cierre abortado.", 
        },
      },
      counterSignatureModuleScreen: {
        title: "Contrafirma",
        saveButton: "Confirmar",
        warnings: {
          exit: 'Atención Si abandona la página, su trabajo actual se perderá.',
          okButton: 'Continuar',
          cancelButton: 'Cancelar',
          save: 'Una vez que haya guardado sus refrendos, no podrá modificarlos posteriormente.',
        },
      },
      createArchiveModal: {
        creationFailed: "MISSING TRANSLATION",
        descriptionLevel: "MISSING TRANSLATION",
        submitBtn: "MISSING TRANSLATION",
        submitting: "MISSING TRANSLATION",
        title: "MISSING TRANSLATION",
      },
      "defectTree": {
        "alteration": {
          "alterationLabel": "Tipo:",
          "alterationsTitle": "Alteraciones :",
          "createAlterationButtonLabel": "Alteración",
          "levelTitle": "Nivel 3",
          "precisionLabel": "Especificación:",
          "deleteConfirmationMessage": "¿Confirmar la supresión de la alteración y su contenido?",
          "precisionPlaceholder": "Seleccione un subtipo",
          "thesaurusTermWarningMessage": "El tipo de alteraciónseleccionado no coincide con el material anterior",
          "typeOfAlterationPlaceholder": "Seleccione un tipo de observación"
        },
        "annotation": {
          "annotationsTitle": "Anotaciones:",
          "commentsPlaceholder": "Especifique...",
          "deleteConfirmationMessage": "¿Confirmar la supresión?",
          "defaultImageConfirmationMessage": "¿Fijar como imagen por defecto?"
        },
        "defect": {
          "createElementButtonLabel": "Elemento",
          "deleteConfirmationMessage": "¿Confirmar la supresión del elemento y su contenido?",
          "elementLabel": "Elemento:",
          "precisionLabel": "Precisión",
          "elementPlaceholder": "Nombre del elemento",
          "precisionPlaceholder": "Especifica..."
        },
        "material": {
          "createMaterialButtonLabel": "Material",
          "deleteConfirmationMessage": "¿Confirmar la supresión del material y su contenido?",
          "levelTitle": "Nivel 2",
          "materialLabel": "Material:",
          "materialsTitle": "Materiales:",
          "thesaurusTermWarningMessage": "El material seleccionado no coincide con el tipo de observación anterior"
        },
        "observation": {
          "createObservationButtonLabel": "Observación",
          "deleteConfirmationMessage": "¿Confirmar la supresión de la observación y su contenido?",
          "levelTitle": "Nivel 1",
          "observationLabel": "Tipo de observación:",
          "observationsTitle": "Observaciones:"
        },
        "submit": "Guardar los cambios",
        "submitError": "El árbol no ha podido ser actualizado",
        "submitting": "Copia de seguridad en curso..."
      },
      "drawingEditor": {
        "title": "Alteración detallada",
        "imageCaption": "Leyenda:",
        "imageTitlePlaceholder": "Introducir la leyenda de la imagen",
        "alterationLabel": "{index}",
        "alterationModalTitle": "Seleccionar una modificación",
        "observationPlaceholder": "Introduzca una observación ",
        "validate": "Guardar",
        "errors": {
          alteration: "Alteración",
          "missingTitleOrType": "Introduzca un título o tipo de alteración para cada alteración",
          failedUploadDetailedImageDescription: "La transferencia de {0} imágenes de detalles de las alteraciones {1} ha fallado",
        },
        "alterationLine": {
          "precisionModal": {
            "title": "Especificación",
            "validateButton": "Confirmar"
          },
          "titlePlaceHoder": "Título de la alteración...",
          "typeOfAlterationPlaceholder": "Tipo de alteración..."
        }
      },
      "editItemScreen": {
        "author": "Autor",
        "confirmButton": "Confirmar",
        "editButton": "Modificar",
        "inventoryNumber": "Número de inventario",
        "saveNotification": {
          "errorMessage": "Se ha producido un error al guardar el objeto",
          "inventoryNumberNotUnique": "No se puede validar, el número de identificación del registro ya existe",
          "successMessage": "El objeto se ha guardado correctamente"
        },
        sections: {
          creation: "Creación",
          description: "Descripción",
          identification: "Identificación",
          location: "Ubicación",
          notes: "Notas",
          state: "Estado",
        },
        "deleteNotification": {
          "errorMessage": "Se ha producido un error al borrar el objeto no sincronizado",
          "successMessage": "El objeto se ha borrado correctamente"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Se ha producido un error al borrar los cambios no sincronizados",
          "successMessage": "Los cambios han sido cancelados"
        },
        "errorMessages": {
          "inventoryNumberNotUnique": "Este número de inventario ya ha sido asignado"
        },
        "menu": {
          "saveModifications": "Guardar los cambios",
          "deleteNotSynchronizedNewItem": "Eliminar el nuevo objeto",
          "deleteModificationsNotSynchronized": "Eliminar las modificaciones no sincronizadas",
          "offlineWarning": "Los cambios están guardados en el dispositivo, tendrá que sincronizarlos con la base de datos cuando la red vuelva a estar disponible.",
          "offlineShortWarning": "Modificado en este dispositivo"
        },
        "fieldDisabledOffline": "Este campo no está disponible en modo sin conexión"
      },
      "editReportScreen": {
        "alerts": {
          "duplicateClosedReport": {
            "success": "El informe ha sido duplicado correctamente",
            "failure": "La duplicación del informe ha fallado",
            "warningReportNotClosed": "El informe debe ser clausurado para poder ser duplicado"
          }
        },
        "reportTitlePrefix": "Informe nº {refNumber}",
        "reportStatusInProgress": "En curso",
        "reportIdentifiers": {
          "accordionPanelTitle": "IDENTIFICADORES DEL INFORME",
          "referenceNumber": "Número de referencia",
          "numberingInformation": "Dejar en blanco para activar la numeración automática en el siguiente guardado",
          "otherIdentifiers": "Otros identificadores",
          "reportReason": "Motivo del informe",
          "precision": "Precisión",
          "reportType": "Tipo de informe",
          "reportTypePlaceholder": "Seleccione un tipo de informe",
          "tabTitle": "Identificación"
        },
        "reportContext": {
          "accordionPanelTitle": "CONTEXTO DEL INFORME DE ESTADO",
          "reportDate": "Fecha del informe",
          "reportDoneInThePresenceOf": "Informe realizado en presencia de",
          "andOf": "Y de",
          "name": "Apellidos/Nombre, Cargo",
          "role": "Cargo",
          "coordinates": "Datos de contacto",
          "email": "Correo electrónico",
          "signer": "Firmante",
          "reportPlace": "Lugar del informe",
          "customer": "Cliente/Comanditario",
          "precisions": "Especificaciones ",
          "linkedProject": "Proyecto relacionado",
          "linkedMovement": "Movimiento relacionado",
          "technicsAndMaterials": "Técnicas y materiales utilizados",
          "comments": "Comentarios",
          "signerComponent": {
            "name": "Firmante",
            "date": "Fecha de la firma",
            "positionOfSignatory": "Cargo del firmante",
            "title": "Firmantes"
          },
          counterSignatureComponent: {
            comment: "Comentario",
            location: "Ubicación",
            reason: "Motivo",
            date: "Fecha",
          },
          counterSignaturesComponent: {
            title: "Contrafirmas",
          },
          "counterSignerComponent": {
            "name": "Apellidos/Nombre",
            "function": "Función",
            signature: 'Firma',
          },
          counterSignersComponent: {
            title: "Informe realizado en presencia de:",
          },
        },
        "alterations": {
          "accordionPanelTitle": "ALTERACIONES",
          "mediasSectionTitle": "IMÁGENES DEL INFORME",
          "globalAlterationSectionTitle": "ALTERACIONES GENERALES",
          "createAlterationForm": {
            "createAlterationButtonTitle": "Crear",
            "alterationTypeLabel": "Tipo de alteración",
            "precisionLabel": "Precisión"
          },
          "tabTitle": "Alteraciones",
          "viewMenu": {
            "alterationTypeView": "Ver por tipo de alteración",
            "imageView": "Ver foto",
            "titleView": "Ver por título"
          }
        },
        "conservation": {
          "accordionPanelTitle": "CONSERVACIÓN Y MANIPULACIÓN"
        },
        "observations": {
          "tabTitle": "Balance",
          "accordionPanelTitle": "REPORTE Y COMENTARIOS",
          "commentsFieldLabel": "Comentarios",
          "countersignature": "Contrafirmas",
          "interventionToSchedule": "Intervenciones a planificar",
          "interventionToSchedulePlaceholder": "Elija una intervención",
          "interventionToSchedulePrecision": "Especificación:",
          "stateOfConservation": "Estado del bien",
          "stateOfConservationPlaceholder": "Elija un estado",
          "signature": "Firmas",
          "typeOfStateOfConservation": "Tipo de estado",
          "treatmentPriority": "Prioridad de tratamiento",
          "treatmentPriorityPlaceholder": "Elija una prioridad"
        },
        "medias": {
          "accordionPanelTitle": "MEDIA"
        },
        "saveAlert": {
          "errorMessage": "Se ha producido un error al guardar el informe",
          "inventoryNumberNotUnique": "No se puede validar, el número de identificación del registro ya existe",
          "successMessage": "Informe de estado guardado"
        },
        "deleteAlert": {
          "errorMessage": "Se ha producido un error al borrar el informe",
          "successMessage": "Informe de estado borrado"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Se ha producido un error al borrar los cambios no sincronizados",
          "successMessage": "Los cambios han sido cancelados"
        },
        "fieldDisabledOffline": "Este campo no está disponible en modo sin conexión",
        pdf: {
          counterSignaturePDF: {
            startGenerating: "Se ha iniciado la generación de PDF",
            success: "La generación de PDF se ha completado correctamente",
            failure: "Error en la generación del PDF",
          }
        },
      },
      "editRecordScreen": {
        "foldAll": "Reducir todo",
        "unfoldAll": "Desplegar todo",
        "medias": {
          "accordionPanelTitle": "MEDIA"
        }
      },
      "firewall": {
        "collabWarningMessage": "Su cuenta no tiene un colaborador asociado, la aplicación puede funcionar mal",
        "noGroupForUserWarningMessage": "El uso de SKINreporter requiere que su cuenta de usuario esté vinculada a un grupo de usuarios"
      },
      genericEditScreen: {
        genericErrorMsg: "MISSING TRANSLATION",
        saveErrorMsg: "MISSING TRANSLATION",
        saveSuccessMsg: "MISSING TRANSLATION",
      },
      "itemCreationImagePopup": {
        "title": "Añadir una imagen",
        "addImage": "AÑADIR UNA IMAGEN",
        "ignore": "MÁS TARDE, OMITIR ESTE PASO"
      },
      "itemSearchScreen": {
        "createNewItem": "CREAR UN NUEVO OBJETO"
      },
      "listReportScreen": {
        "closed": {
          "downloadFailure": "Se ha producido un error durante la descarga",
          "downloadSuccess": "El documento {docTitle} ha sido descargado",
          "open": "DESCARGAR EL DOCUMENTO",
          "title": "Informes de estado completados"
        },
        "inProgress": {
          "edit": "EDITAR EL INFORME",
          "title": "Informes de estado en proceso de edición "
        },
        "concernedItem": "Objeto de museo en cuestión",
        "nbResults": "{nbResults} resultados",
        "noResults": "No hay resultados"
      },
      "locationSelector": {
        "inputPlaceholder": "Introduzca una ubicación",
        "title": "Elija una ubicación",
        "validate": "Validar"
      },
      "maskFields": {
        "boolean": {
          "no": "No",
          "undefined": "Indefinido",
          "yes": "Sí"
        },
        "entitySelect": {
          "modalPlaceholder": "Palabras clave o identificadores..."
        }
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Desplegado en",
          "checkForUpdate": {
            "help": "Si hay una actualización disponible, se instalará automáticamente.",
            "title": "Comprobar las actualizaciones"
          },
          "clearCache": {
            "help": "Si está sin conexión, esto elimina el acceso a todos los datos almacenados en el dispositivo.",
            "title": "Vaciar la memoria caché"
          },
          "overrideLocale": {
            "help": "Se utilizará el idioma inglés y no se tomará en cuenta la configuración de su dispositivo.",
            "title": "Forzar el idioma inglés"
          },
          "resetLocaleOverride": {
            "help": "El idioma utilizado dependerá de la configuración de su dispositivo.",
            "title": "Restablecer el idioma"
          },
          "serviceWorker": {
            "help": "¿Se muestra continuamente el banner de actualización? ¡Haga clic aquí!",
            "title": "Cerrar el banner de actualización"
          },
          "title": "Skin-REPORTER",
          "version": "versión"
        },
        "logout": "¿Está seguro de que quiere desconectarte?"
      },
      "offlineRibbon": {
        "offline": "Está desconectado",
        "online": "Está conectado"
      },
      "pdfOverviewScreen": {
        "download": "Descargar",
        "progressBar": {
          "mainLabel": "Generación de documentos ...",
          "object": "Objeto",
          "generalDigest": "Apreciación general",
          "defects": "Alteraciones",
          "contextAndSignatures": "Contexto",
          "documentReady": "¡Documento listo!"
        },
        "title": "Vista previa",
        "renderFailureAlert": "No se puede mostrar el PDF, inténtelo de nuevo más tarde"
      },
      "pdfDocument": {
        "mainTitlePrefix": "INFORME DE ESTADO - ",
        "objectSection": {
          "sectionTitle": "Objeto",
          "inventoryNumber": "Nº de inventario: ",
          "title": "Título: ",
          "author": "Artista / Autor: ",
          "creationDate": "Fecha de creación: ",
          "typology": "Tipología: ",
          "denomination": "Denominación: ",
          "materialsAndTechniques": "Materiales y técnicas :",
          "dimensions": "Dimensiones: ",
          "institution": "Institución:",
          conditioning: "Embalaje:",
          descriptions: "Descripción:",
          domains: "Dominio:",
          identification: "Identificación:",
          location: "Ubicación:",
          materials: "Material(es):",
          ownerInstitutions: "Institución(es) propietaria(s):",
          techniques: "Técnica(s):",
        },
        "alterationsSection": {
          "detailedAlteration": "Alteración detallada",
          "noAnnotation": "No hay anotaciones que mostrar",
          "observationLabel": "Obs.",
          "sectionTitle": "Alteraciones"
        },
        archiveSection: {
          sectionTitle: "MISSING TRANSLATION",
          archiveType: "MISSING TRANSLATION",
          conditioning: "MISSING TRANSLATION",
          cote: "MISSING TRANSLATION",
          descriptionLevel: "MISSING TRANSLATION",
          location: "MISSING TRANSLATION",
          materialImportance: "MISSING TRANSLATION",
          parentArchive: "MISSING TRANSLATION",
          productors: "MISSING TRANSLATION",
          productionDate: "MISSING TRANSLATION",
          proprietaryInstitution: "MISSING TRANSLATION",
          supportType: "MISSING TRANSLATION",
          title: "MISSING TRANSLATION",
        },
        detailedViewsSection: {
          sectionTitle: "Detalles de las alteraciones",
        },
        "finalObservationsSection": {
          "sectionTitle": "Observaciones finales"
        },
        conditioningSection: {
          crateNumber: "Número de caja:",
          sectionTitle: "Embalaje",
          transportAccessories: "Accesorios de transporte:",
          typeOfPackaging: "Tipo de embalaje:",
        },
        "contextSection": {
          "comments": "Comentarios:",
          "editors": "Redactores:",
          "matAndTechs": "Materiales y técnicas:",
          "reportDate": "Fecha del informe:",
          "reportPlace": "Ubicación: ",
          "reportReference": "Referencia del informe:",
          "reportType": "Tipo de informe: ",
          "reportReason": "Motivo del informe: ",
          "sectionTitle": "Contexto de este informe de estado",
          signers: "Firmantes:",
        },
        "reportSection": {
          "counterSignaturesTitle": "Contrafirmas",
          counterSignature: {
            comment: 'Comentario:',
          },
          "interventionsToSchedule": "Intervenciones a planificar: ",
          "sectionTitle": "Reporte",
          "signatoriesTitle": "Informe realizado en presencia de:",
          "stateOfConservation": "Estado del bien: ",
          "treatmentPriority": "Prioridad del tratamiento : "
        },
        "footer": {
          "prefix": "INFORME DE ESTADO ",
          "separator": "- Página"
        },
        "generationFailureAlert": "Error en la generación del PDF, inténtelo de nuevo más tarde"
      },
      "proxy": {
        "error": {
          "default": "Se ha producido un error en el recurso {uri}",
          "network": "La comunicación con el servidor ha fallado",
          "notFound": "No se ha encontrado el recurso {uri}",
          "tokenHasExpired": "Su sesión ha expirado"
        }
      },
      "search": {
        "noResults": "No hay resultados",
        "options": {
          "sortType": {
            "creationDate": "Fecha de creación",
            "identifier": "Identificador principal",
            "lastModification": "Última modificación",
            "mainTitle": "Título principal",
            "referenceNumber": "Número de referencia"
          }
        },
        "queryPlaceholder": "Palabras clave o número de inventario",
        "title": "Objetos de museo",
        "totalCount": "{totalResults} Resultado(s) : 1 -"
      },
      "searchFeaturedCard": {
        "consultLastReport": "VER EL ÚLTIMO INFORME CLAUSURADO",
        "createNewReport": "CREAR UN NUEVO INFORME",
        "createNewReportFromLast": "OBSERVACIONES DESDE EL ÚLTIMO INFORME DE ESTADO",
        "institutionLabel": "Institución",
        "lastReportLabel": "Último informe de estado",
        "materialsAndTechniques": "Materiales / Técnicas",
        "measurements": "Dimensiones",
        "noLinkedItem": "No hay objetos relacionados con este informe de estado"
      },
      selectItemErrorDialog: {
        cancel: "Cancelar el objeto",
        cancelAll: "Cancelar todos los objetos",
        description: "La selección de {0} objetos ha fallado",
        retry: "Volver a intentar para este objeto",
        retryAll: "Volver a intentar para todos los objetos",
        title: "Se ha producido un error al seleccionar las imágenes",
      },
      "serviceWorker": {
        "updateAvailable": "Se ha instalado una actualización. Pulse aquí para actualizar la página o reiniciar la aplicación",
        "forceServiceWorkerUpdate": {
          "modalTitle": "Resolución del problema",
          "versionCorrect": "¿La versión que se muestra coincide con el número de versión y la fecha que SKINsoft envió después de la actualización?",
          "yes": "Sí",
          "no": "No"
        }
      },
      "signatureModuleScreen": {
        "cardTitle": "Firmante",
        "eraseSignature": "Firma de nuevo",
        "missingSignature": "Falta la firma",
        "nameLabel": "Firmante",
        "positionOfSignatory": "Cargo del firmante",
        "presentSignature": "Firma presente",
        "saveSignature": "Guardar",
        "signatureStatus": "Estado de la firma",
        "title": "Firmas"
      },
      "synchroModal": {
        "title": "Sincronización",
        "lastFetch": "Última recuperación",
        "duration": "Duración",
        "status": "Estado",
        "details": "Detalles",
        "lastSynchro": "Última sincronización",
        "noEntityToSync": "No hay entidades que sincronizar",
        "connectionWarningPrefix": "Debe estar conectado a Internet para poder",
        "connectWarningSend": "enviar",
        "connectWarningRetrieve": "recuperar",
        "connectionWarningSuffix": "datos",
        "noDataToSync": "No hay datos que sincronizar por el momento",
        "localIconInfoPrefix": "El icono",
        "localIconInfoSuffix": " indica que los datos correspondientes han sido modificados localmente y tendrán que ser sincronizados con la base de datos remota.",
        "retrieveAll": "Recuperar todo",
        "finishedSynchros": "sincronizaciones completadas",
        "syncAll": "Sincronizar todo",
        "remainsToSynchronize": "Queda por sincronizar",
        "cleanImageCache": "Eliminar imágenes fantasma de la memoria caché",
        "cachedImagedCleaned": "Se han eliminado las imágenes fantasma",
        "cleanCacheDown": "Borrar la memoria caché",
        "cacheDownCleaned": "Se ha vaciado la caché",
        "cleanCacheUp": "Borrar todos los cambios no sincronizados",
        "cacheUpCleaned": "Se han eliminado todos los cambios no sincronizados"
      },
      "entityNames": {
        "items": "Objetos ",
        archives: "MISSING TRANSLATION",
        "auditRecords": "Fichas de auditoría",
        "audits": "Proyectos de auditoría",
        "thesaurusTerms": "Términos del tesauro",
        "thesaurus": "Tesauro",
        "entityFields": "Datos del sistema",
        "collaborators": "Personal",
        "authorities": "Autoridades",
        "aliases": "Alias",
        "locations": "Ubicaciones",
        "conditionReports": "Informes de estado",
        "works": "Obras",
        "expressions": "Expresiones",
        "manifestations": "Manifestaciones",
        "specimens": "MISSING TRANSLATION"
      },
      "time": {
        "hours": "hora(s)",
        "minutes": "minuto(s)",
        "seconds": "segundo(s)"
      },
      "thesaurusTermCreateForm": {
        "formTitle": "Creación de un término",
        "openButtonTitle": "Crear un término",
        "createButton": "Validar",
        "anotherTermButton": "Validar y crear otro término",
        "cancelButton": "Cancelar",
        "preferedTermLabel": "Término preferido :",
        "synonymLabel": "Utilizado para :",
        "genericTermPlaceholder": "Genérico :",
        "selectSpecificLabel": "Seleccionar términos específicos",
        "disabledOffline": "La creación de un nuevo término no está disponible cuando se utiliza la aplicación sin conexión."
      },
      "thesaurusTermTree": {
        "creationTabTitle": "Creación",
        "errors": {
          "searchError": "La búsqueda ha fallado",
          "fetchError": "No se pueden recuperar los términos del tesauro"
        },
        "modalSearchInputPlaceholder": "Buscar un término",
        "selectionTabTitle": "Selección",
        "thesaurusTermSelectorModalTitle": "Seleccione un término",
        "validate": "Confirmar"
      },
      uploadImageFailureDialog: {
        cancel: "Cancelar la imagen {0}",
        cancelAll: "Cancelar todas las imágenes",
        description: "La transferencia de {0} imágenes ha fallado",
        imageAndNumber: "Imagen {0}",
        retry: "Volver a intentar para la imagen {0}",
        retryAll: "Volver a intentar para todas las imágenes",
        title: "Se ha producido un error al transferir las imágenes ",
      },
      "state": {
        "all": "Todos",
        "archived": "Archivado",
        "canceled": "Cancelado",
        "finalized": "Completado",
        "inPreparation": "En preparación",
        "inProgress": "En proceso",
        "programmed": "Planificado",
        "toValidated": "Por validar",
        "validated": "Validado",
        "aborted": "Interrumpido",
        "success": "Completado correctamente",
        "error": "Error",
        "none": "No hay sincronización previa"
      },
      "SpecimenSearchScreen": {
        "createNewSpecimen": "MISSING TRANSLATION"
      },
    },
    "it": {
      "countryCode": "it",
      "actionBar": {
        "bar": {
          "inProgress": "In corso",
          "latest": "Completato"
        },
        "sideMenu": {
          "saveModifications": "Salvare le modifiche",
          "reportOverview": "Panoramica del report sulle condizioni",
          "signReport": "Firmare il condition report",
          "closeReport": "Chiudere il condition report",
          "countersignReport": "Controfirmare il condition report",
          "printReport": "Stampare il condition report",
          "deleteReport": "Eliminare il condition report corrente",
          "deleteReportOfflineWarning": "Si prega di notare che questo elemento non è sincronizzato!",
          "deleteModificationsNotSynchronized": "Cancellare le modifiche non sincronizzate",
          "duplicateReport": "Duplicare il condition report",
          "confirmDeletion": "Confermare l'eliminazione"
        }
      },
      "alerts": {
        "medias": {
          "failUpload": "Non è riuscito a caricare il supporto",
          "failGetIdFromFileName": "Il supporto è stato caricato, ma Skin-Reporter non lo trova.",
        },
        "permissions": {
          "camera": {
            askForPermission: "SKR-Condition Report ha bisogno di un'autorizzazione per accedere alla telecamera. Questa autorizzazione è necessaria per le funzionalità di scansione dei codici a barre/QR. Senza questa autorizzazione, queste funzioni non possono essere fornite.",
            permissionDeniedWarning: "Il permesso di accedere alla telecamera è stato precedentemente negato a SKR-Condition Report. Le funzionalità di scansione di codici a barre/QR non sono quindi disponibili. Per potervi accedere, autorizzare manualmente l'accesso alla telecamera per SKR-Condition Report.",
          }
        },
        "workspace": {
          "unableToChangeWorkspace": "Impossibile cambiare lo spazio di lavoro",
          "unableToLoadWorkspace": "Caricamento dell'area di lavoro non riuscito",
        },
      },
      alterationDetailImagePopup: {
        title: "Viste dettagliate di alterazioni {0}",
      },
      "alterationCard": {
        "moreMenu": {
          "deleteAlteration": "Eliminare l’alterazione",
          "changeAlterationTitle": "Modificare il titolo dell’alterazione",
          "changeAlterationType": "Modificare il tipo d’alterazione",
          "titleModalHeader": "Modificare il titolo dell’alterzione",
          "titleModalButton": "Confermare"
        },
        titleAutoCompletePlaceHolder: "Titolo",
      },
      archiveCrEditScreenHeader: {
        materialImportance: "MISSING TRANSLATION",
        principalMediumType: "MISSING TRANSLATION",
      },
      archiveEditScreen: {
        saveAlert: {
          errorMessage: "MISSING TRANSLATION",
          successMessage: "MISSING TRANSLATION",
        },
      },
      archiveEditScreenHeader: {
        cote: "MISSING TRANSLATION",
        descriptionLevel: "MISSING TRANSLATION",
      },
      archiveSearchScreen: {
        createNewArchive: "MISSING TRANSLATION",
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Le sue credenziali non sono corrette",
            "network": "Comunicazione con il server fallita"
          },
          "form": {
            "password": {
              "error": "Per favore",
              "label": "Password"
            },
            "submit": "Per accedere",
            "submitting": "Login...",
            "username": {
              "error": "Inserisce il password",
              "label": "Nome dell’utente"
            }
          }
        },
        "renew": {
          "slowNetwork": "Sembra che ci stia impiegando più tempo del solito, non esca dall'app.",
          "spinner": "Le ricolleghiamo..."
        },
        sso: {
          errors: {
            authenticationFailed: "Errore"
          },
          selectIDP: "Autentica con...",
          otherIDPs: "Altri tipi di conti",
        },
      },
      autoCompleteTextField: {
        modal: {
          okButton: "OK",
        },
      },
      cameraScanner: {
        scanCode: "Scannerizzare il codice",
        cancel: "Annullare",
        errors: {
          cameraNotFound: "Nessuna videocamera rilevata",
        },
      },
      "closeReportScreen": {
        "important": "IMPORTANTE",
        "close": "Avvolgere",
        "title": "Chiusura del condition report",
        "notificationContent": "Il condition report '{referenceNumber}' è stato chiuso e lo stato dell'oggetto collegato è stato aggiornato.",
        "warningMessage": "Un rapporto chiuso non può essere modificato o eliminato",
        "warningQuestion": "Vuole davvero continuare a chiudere il condition report ?",
        "transferingFile": "Trasferimento del documento PDF...",
        "fileGeneration": "Generazione del documento pdf finale...",
        "reportClosing": "Chiusura del condition report…",
        errors: {
          transitionState: "Si è verificato un errore durante la chiusura del rapporto. Il PDF è stato generato e aggiunto al rapporto di stato.",
          pushingPDF: "Il PDF generato non è stato aggiunto al rapporto di stato. Chiusura interrotta.", 
        },
      },
      counterSignatureModuleScreen: {
        title: "Controfirma",
        saveButton: "Confermare",
        warnings: {
          exit: 'Attenzione Se si abbandona la pagina, il lavoro in corso andrà perso.',
          okButton: 'Continua',
          cancelButton: 'Annulla',
          save: 'Una volta salvate le proprie annotazioni, non sarà più possibile modificarle in seguito.',
        },
      },
      createArchiveModal: {
        creationFailed: "MISSING TRANSLATION",
        descriptionLevel: "MISSING TRANSLATION",
        submitBtn: "MISSING TRANSLATION",
        submitting: "MISSING TRANSLATION",
        title: "MISSING TRANSLATION",
      },
      "defectTree": {
        "alteration": {
          "alterationLabel": "Tipo :",
          "alterationsTitle": "Alterazioni:",
          "createAlterationButtonLabel": "Alterazione",
          "levelTitle": "Livello 3",
          "precisionLabel": "Precisione:",
          "deleteConfirmationMessage": "Conferma l'eliminazione della modifica e del suo contenuto?",
          "precisionPlaceholder": "Seleziona un sottotipo",
          "thesaurusTermWarningMessage": "Il tipo d’alterazione selezionato non corrisponde al materiale sopra",
          "typeOfAlterationPlaceholder": "Seleziona un tipo di osservazione"
        },
        "annotation": {
          "annotationsTitle": "Annotazioni",
          "commentsPlaceholder": "Specificare...",
          "deleteConfirmationMessage": "Confermare la cancellazione?",
          "defaultImageConfirmationMessage": "Impostare come immagine predefinita?"
        },
        "defect": {
          "createElementButtonLabel": "Elemento",
          "deleteConfirmationMessage": "Conferma l'eliminazione dell'elemento e del suo contenuto?",
          "elementLabel": "Elemento :",
          "precisionLabel": "Precisione",
          "elementPlaceholder": "Nome dell'oggetto",
          "precisionPlaceholder": "Specifica.."
        },
        "material": {
          "createMaterialButtonLabel": "Materiali",
          "deleteConfirmationMessage": "Conferma la cancellazione del materiale e del suo contenuto?",
          "levelTitle": "Livello 2",
          "materialLabel": "Materiale ",
          "materialsTitle": "Materiale ",
          "thesaurusTermWarningMessage": "Il materiale selezionato non corrisponde al tipo di osservazione di cui sopra."
        },
        "observation": {
          "createObservationButtonLabel": "Osservazione",
          "deleteConfirmationMessage": "Confermare la cancellazione dell'osservazione e del suo contenuto?",
          "levelTitle": "Livello 1",
          "observationLabel": "Tipo di osservazione ",
          "observationsTitle": "Osservazione "
        },
        "submit": "Salva le modifiche",
        "submitError": "Non è stato possibile aggiornare l'albero",
        "submitting": "Salvataggio in corso..."
      },
      "drawingEditor": {
        "title": "Modifica dettagliata",
        "imageCaption": "Didascalia:",
        "imageTitlePlaceholder": "Inserire la didascalia dell'immagine",
        "observationLabel": "Obs {index}",
        "observationPlaceholder": "Inserire un'osservazione",
        "validate": "Salvare",
        "alterationLabel": "{index}",
        "alterationModalTitle": "Selezionare una modifica",
        "errors": {
          alteration: "Alterazione ",
          "missingTitleOrType": "Inserire un titolo o un tipo di modifica per ciascuna alterazione",
          failedUploadDetailedImageDescription: "Il caricamento di {0} immagini di viste dettagliate di alterazioni {1} è fallito",
        },
        "alterationLine": {
          "precisionModal": {
            "title": "Precisioni",
            "validateButton": "Confermare"
          },
          "titlePlaceHoder": "Titolo dell’alterazione",
          "typeOfAlterationPlaceholder": "Tipo di alterazione"
        }
      },
      "editReportScreen": {
        "alerts": {
          duplicateClosedReport: {
            success: "Il rapporto è stato duplicato con successo",
            failure: "La duplicazione del rapporto non è riuscita",
            warningReportNotClosed: "Il rapporto deve essere chiuso prima di poter essere duplicato",
          }
        },
        "reportTitlePrefix": "Numero di osservazione {refNumber}",
        "reportStatusInProgress": "In corso",
        "reportIdentifiers": {
          "accordionPanelTitle": "IDENTIFICATORI DI OSSERVAZIONE",
          "referenceNumber": "Numero di riferimento",
          "numberingInformation": "Lasciare vuoto per attivare la numerazione automatica alla prossima memorizzazione.",
          "otherIdentifiers": "Altri identificatori",
          "reportReason": "Motivo del rapporto",
          "precision": "Precisione",
          "reportType": "Tipo di rapporto",
          "reportTypePlaceholder": "Selezionare un tipo di condition report",
          "tabTitle": "Identificazione"
        },
        "reportContext": {
          "accordionPanelTitle": "CONTESTO DEL RAPPORTO SULLE CONDIZIONI",
          "reportDate": "Data del condition report",
          "reportDoneInThePresenceOf": "Condition report redatto in presenza di",
          "andOf": "E di",
          "name": "Cognome/Nome, Posizione",
          "role": "Qualità",
          "coordinates": "Dettagli di contatto",
          "email": "Email",
          "signer": "Firmatario",
          "reportPlace": "Luogo del condition report",
          "customer": "Cliente",
          "precisions": "Dettagli",
          "linkedProject": "Progetto correlato",
          "linkedMovement": "Movimento collegato",
          "technicsAndMaterials": "Tecniche e materiali utilizzati",
          "comments": "Commenti",
          "signerComponent": {
            "name": "Firmatario",
            "date": "Data della firma",
            "positionOfSignatory": "Posizione del firmatario",
            "title": "Firmatari",
          },
          counterSignatureComponent: {
            comment: "Commento",
            location: "Posizione",
            reason: "Motivo",
            date: "Data",
          },
          counterSignaturesComponent: {
            title: "Controfirme",
          },
          "counterSignerComponent": {
            "name": "Cognome/Nome",
            "function": "Funzione",
            signature: 'Firma',
          },
          counterSignersComponent: {
            title: "Relazione svolta in presenza di :",
          },
        },
        "alterations": {
          "accordionPanelTitle": "ALTERAZIONI",
          "mediasSectionTitle": "RAPPORTO IMMAGINI",
          "globalAlterationSectionTitle": "ALTERAZIONI GENERALI",
          "createAlterationForm": {
            "createAlterationButtonTitle": "Creare",
            "alterationTypeLabel": "Tipo di alterazione",
            "precisionLabel": "Precisione"
          },
          "tabTitle": "Alterazioni",
          "viewMenu": {
            "alterationTypeView": "Vista per tipo di alterazione",
            "imageView": "Vista foto",
            "titleView": "Vista per titolo"
          }
        },
        "conservation": {
          "accordionPanelTitle": "CONSERVAZIONE E MANIPOLAZIONE"
        },
        "observations": {
          "tabTitle": "Bilancio",
          "accordionPanelTitle": "RELAZIONI E OSSERVAZIONI",
          "commentsFieldLabel": "Commenti",
          "countersignature": "Controfirme",
          "interventionToSchedule": "Interventi da pianificare",
          "interventionToSchedulePlaceholder": "Scegliere un intervento",
          "interventionToSchedulePrecision": "Precisione ",
          "stateOfConservation": "Condizioni dell'oggetto",
          "stateOfConservationPlaceholder": "Scegliere uno stato",
          "signature": "Firme",
          "typeOfStateOfConservation": "Tipo di stato",
          "treatmentPriority": "Priorità di trattamento",
          "treatmentPriorityPlaceholder": "Scegliere una priorità"
        },
        "medias": {
          "accordionPanelTitle": "MEDIA"
        },
        "saveAlert": {
          "errorMessage": "Si è verificato un errore durante il salvataggio del rapporto",
          "successMessage": "Condition report salvato",
          "inventoryNumberNotUnique": "Non può essere convalidato, il numero di identificazione del record esiste già."
        },
        "deleteAlert": {
          "errorMessage": "Si è verificato un errore durante l'eliminazione del condition report",
          "successMessage": "Condition report cancellato"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Si è verificato un errore durante l'eliminazione delle modifiche non sincronizzate",
          "successMessage": "Le modifiche sono state annullate"
        },
        "fieldDisabledOffline": "Questo campo non è disponibile in modalità offline",
        pdf: {
          counterSignaturePDF: {
            startGenerating: "La generazione del PDF è iniziata",
            success: "Generazione PDF completata con successo",
            failure: "Generazione PDF fallita",
          }
        },
      },
      "firewall": {
        "collabWarningMessage": "Se il vostro account non ha un collaboratore associato, l'applicazione potrebbe non funzionare correttamente.",
        "noGroupForUserWarningMessage": "L'utilizzo di SKINreporter richiede che l'account utente sia collegato a un gruppo di utenti"
      },
      genericEditScreen: {
        genericErrorMsg: "MISSING TRANSLATION",
        saveErrorMsg: "MISSING TRANSLATION",
        saveSuccessMsg: "MISSING TRANSLATION",
      },
      "listReportScreen": {
        "closed": {
          "downloadFailure": "Si è verificato un errore durante il scaricamento",
          "downloadSuccess": "Il documento {docTitle} è stato scaricato",
          "open": "SCARICA IL DOCUMENTO",
          "title": "Condition report di avanzamento completati"
        },
        "inProgress": {
          "edit": "MODIFICARE IL CONDITION REPORT",
          "title": "Condition report in fase di modifica"
        },
        "concernedItem": "Oggetto del museo interessato",
        "nbResults": "{nbRisultati} risultati",
        "noResults": "Nessun risultato"
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Distribuito su",
          "checkForUpdate": {
            "help": "Se è disponibile un aggiornamento, questo verrà installato automaticamente.",
            "title": "Controlla gli aggiornamenti"
          },
          "clearCache": {
            "help": "Se l'utente è offline, questo rimuove l'accesso a tutti i dati memorizzati sul dispositivo.",
            "title": "Svuotare la cache"
          },
          "overrideLocale": {
            "help": "Verrà utilizzata la lingua inglese e le impostazioni del dispositivo verranno ignorate.",
            "title": "Forza la lingua inglese"
          },
          "resetLocaleOverride": {
            "help": "La lingua utilizzata dipende dalle impostazioni del dispositivo.",
            "title": "Reimpostare la lingua"
          },
          "serviceWorker": {
            help: "Il banner di aggiornamento continua ad apparire? Clicca qui!",
            title: "Chiudi il banner di aggiornamento",
          },
          "title": "Skin-REPORTER",
          "version": "versione",
        },
        "logout": "É sicuro di volersi scollegare?"
      },
      "offlineRibbon": {
        "offline": "É offline",
        "online": "É connesso a internet"
      },
      "pdfOverviewScreen": {
        "download": "Scaricare",
        "progressBar": {
          "mainLabel": "Generazione di documenti ...",
          "object": "Oggetto",
          "generalDigest": "Valutazione generale",
          "defects": "Alterazioni",
          "contextAndSignatures": "Contesto",
          "documentReady": "Documento pronto!"
        },
        "title": "Panoramica",
        "renderFailureAlert": "Impossibile visualizzare il PDF, riprovare più tardi"
      },
      "pdfDocument": {
        "mainTitlePrefix": "CONDITION REPORT ",
        "objectSection": {
          "sectionTitle": "Oggetto",
          "inventoryNumber": "Numero d’inventario :",
          "title": "Titolo : ",
          "author": "Artista / Autore :",
          "creationDate": "Data di creazione :",
          "typology": "Tipologia :",
          "denomination": "Denominazione :",
          "materialsAndTechniques": "Materiali e tecniche : ",
          "dimensions": "Dimensioni :",
          "institution": "Istituzione :",
          conditioning: "Imballaggio :",
          descriptions: "Descrizione(i) :",
          domains: "Dominio :",
          identification: "Identificazione :",
          location: "Posizione :",
          materials: "Materiale(i) :",
          ownerInstitutions: "Ente/i proprietario/i :",
          techniques: "Tecnica/e :",
        },
        "alterationsSection": {
          "detailedAlteration": "Alterazione dettagliata",
          "noAnnotation": "Nessuna annotazione da visualizzare",
          "observationLabel": "Osservazioni.",
          "sectionTitle": "Alterazioni"
        },
        archiveSection: {
          sectionTitle: "MISSING TRANSLATION",
          archiveType: "MISSING TRANSLATION",
          conditioning: "MISSING TRANSLATION",
          cote: "MISSING TRANSLATION",
          descriptionLevel: "MISSING TRANSLATION",
          location: "MISSING TRANSLATION",
          materialImportance: "MISSING TRANSLATION",
          parentArchive: "MISSING TRANSLATION",
          productors: "MISSING TRANSLATION",
          productionDate: "MISSING TRANSLATION",
          proprietaryInstitution: "MISSING TRANSLATION",
          supportType: "MISSING TRANSLATION",
          title: "MISSING TRANSLATION",
        },
        detailedViewsSection: {
          sectionTitle: "Dettagli delle alterazioni",
        },
        "finalObservationsSection": {
          "sectionTitle": "Osservazioni finali"
        },
        conditioningSection: {
          crateNumber: "Numero di cassa :",
          sectionTitle: "Imballaggio",
          transportAccessories: "Accessori per il trasporto :",
          typeOfPackaging: "Tipo di imballaggio :",
        },
        "contextSection": {
          "comments": "Commenti :",
          "editors": "Redazione :",
          "matAndTechs": "Materiali e tecniche : ",
          "reportDate": "Data del condition report :",
          "reportReference": "Riferimento del condition report :",
          "reportPlace": "Posizione :",
          "reportType": "Tipo di condition report :",
          "reportReason": "Motivo del condition report :",
          "sectionTitle": "Contesto di questo rapporto sulle condizioni",
          signers: "Firmatari :",
        },
        "reportSection": {
          "counterSignaturesTitle": "Controfirme",
          counterSignature: {
            comment: 'Commento:',
          },
          "interventionsToSchedule": "Interventi da pianificare :",
          "sectionTitle": "Rapporto :",
          "signatoriesTitle": "Relazione svolta in presenza di :",
          "stateOfConservation": "Condizioni della proprietà :",
          "treatmentPriority": "Priorità di trattamento :"
        },
        "footer": {
          "prefix": "Condition REPORT ",
          "separator": "- Pagina "
        },
        "generationFailureAlert": "Generazione PDF non riuscita, riprovare più tardi"
      },
      "proxy": {
        "error": {
          "default": "Si è verificato un errore sulla risorsa {uri}",
          "network": "La comunicazione con il server è fallita",
          "notFound": "La risorsa {uri} non è stata trovata",
          "tokenHasExpired": "La sessione è scaduta"
        }
      },
      "search": {
        "noResults": "Nessun risultato",
        "options": {
          "sortType": {
            "creationDate": "Data di creazione",
            "identifier": "ID principale",
            "lastModification": "Ultima modifica",
            "mainTitle": "Titolo principale",
            "referenceNumber": "Numero di riferimento"
          }
        },
        "queryPlaceholder": "Parole chiave o numero di inventario",
        "title": "Oggetti del museo",
        "totalCount": "{totalResults} Risultato(i) : 1 -"
      },
      "searchFeaturedCard": {
        "consultLastReport": "VEDERE L'ULTIMO RAPPORTO CHIUSO",
        "createNewReport": "CREARE UN NUOVO CONDITION REPORT",
        "createNewReportFromLast": "CONDITION REPORT DALL'ULTIMO RISULTATO",
        "institutionLabel": "Istituzione",
        "lastReportLabel": "Ultimo condition report sulle condizioni",
        "materialsAndTechniques": "Materiali / Tecniche",
        "measurements": "Dimensioni",
        "noLinkedItem": "Nessun oggetto è collegato a questo condition report"
      },
      selectItemErrorDialog: {
        cancel: "Abbandono dell'oggetto",
        cancelAll: "Abbandono di tutti gli oggetti",
        description: "La selezione di {0} oggetti non è riuscita.",
        retry: "Riprova per questo oggetto",
        retryAll: "Riprova per tutti gli oggetti",
        title: "Impossibile selezionare le immagini",
      },
      "serviceWorker": {
        "updateAvailable": "È stato installato un aggiornamento. Fare clic qui per ricaricare la pagina o riavviare l'applicazione.",
        forceServiceWorkerUpdate: {
          modalTitle: "Risolvere il problema",
          versionCorrect: "Le informazioni qui sotto corrispondono alla versione e alla data fornite da SKINsoft dopo l'ultimo aggiornamento?",
          "yes": "Sì",
          "no": "No",
        },
      },
      "signatureModuleScreen": {
        "cardTitle": "Firmatario",
        "eraseSignature": "Firmare di nuovo",
        "missingSignature": "Manca la firma",
        "nameLabel": "Firmatario",
        "positionOfSignatory": "Posizione del firmatario",
        "presentSignature": "Firma presente",
        "saveSignature": "Registrare",
        "signatureStatus": "Stato della firma",
        "title": "Firme"
      },
      "editItemScreen": {
        "author": "Autore",
        "confirmButton": "Confermare",
        "editButton": "Modificare",
        "inventoryNumber": "Numero di inventario",
        "saveNotification": {
          "errorMessage": "Si è verificato un errore durante il salvataggio dell'oggetto",
          "inventoryNumberNotUnique": "Non può essere convalidato, il numero di identificazione del record esiste già",
          "successMessage": "Il backup dell'oggetto è stato eseguito con successo"
        },
        sections: {
          creation: "Creazione",
          description: "Descrizione",
          identification: "Identificazione",
          location: "Posizione",
          notes: "Note",
          state: "Stato Abbandono dell'oggetto",
        },
        "deleteNotification": {
          "errorMessage": "Si è verificato un errore durante l'eliminazione dell'oggetto non sincronizzato",
          "successMessage": "L'oggetto è stato eliminato con successo"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Si è verificato un errore durante l'eliminazione delle modifiche non sincronizzate",
          "successMessage": "Le modifiche sono state annullate"
        },
        "errorMessages": {
          "inventoryNumberNotUnique": "Questo numero di inventario è già stato assegnato"
        },
        "menu": {
          "saveModifications": "Salva le modifiche",
          "deleteNotSynchronizedNewItem": "Cancellare il nuovo oggetto",
          "deleteModificationsNotSynchronized": "Cancellare le modifiche non sincronizzate",
          "offlineWarning": "Le modifiche vengono salvate sul dispositivo",
          "offlineShortWarning": "Modificato su questo dispositivo"
        },
        "fieldDisabledOffline": "Questo campo non è disponibile in modalità offline"
      },
      "editRecordScreen": {
        "foldAll": "Ridurre tutti",
        "unfoldAll": "Aprire tutti",
        "medias": {
          "accordionPanelTitle": "MEDIA"
        }
      },
      "itemCreationImagePopup": {
        "title": "Aggiungi un'immagine",
        "addImage": "AGGIUNGERE UN'IMMAGINE",
        "ignore": "IN SEGUITO, SALTARE QUESTO PASSAGGIO"
      },
      "itemSearchScreen": {
        "createNewItem": "CREARE UN NUOVO OGGETTO"
      },
      "locationSelector": {
        "inputPlaceholder": "Inserire una posizione",
        "title": "Scegliere una posizione",
        "validate": "Convalidare"
      },
      "maskFields": {
        "boolean": {
          "no": "No",
          "undefined": "Non definito",
          "yes": "Sì"
        },
        "entitySelect": {
          "modalPlaceholder": "Parole chiave o identificatori…"
        }
      },
      "synchroModal": {
        "title": "Sincronizzazione",
        "lastFetch": "Ultimo recupero",
        "duration": "Durata",
        "status": "Stato",
        "details": "Dettagli",
        "lastSynchro": "Ultima sincronizzazione",
        "noEntityToSync": "Nessuna entità da sincronizzare",
        "connectionWarningPrefix": "È necessario essere collegati a internet per poter",
        "connectWarningSend": "inviare",
        "connectWarningRetrieve": "recuperare",
        "connectionWarningSuffix": "dati",
        "noDataToSync": "Al momento non ci sono dati da sincronizzare",
        "localIconInfoPrefix": "L'icona",
        "localIconInfoSuffix": " indica che i dati corrispondenti sono stati modificati localmente e dovranno essere sincronizzati con il database remoto.",
        "retrieveAll": "Recupera tutti",
        "finishedSynchros": "sincronizzazioni completate",
        "syncAll": "Sincronizzare tutti",
        "remainsToSynchronize": "Ancora da sincronizzare",
        "cleanImageCache": "Rimozione delle immagini fantasma dalla cache",
        "cachedImagedCleaned": "Le immagini fantasma sono state rimosse!",
        "cleanCacheDown": "Pulire la cache",
        "cacheDownCleaned": "La cache è stata svuotata!",
        "cleanCacheUp": "Cancellare tutte le modifiche non sincronizzate",
        "cacheUpCleaned": "Tutte le modifiche non sincronizzate sono state eliminate!"
      },
      "entityNames": {
        "items": "Articoli",
        archives: "MISSING TRANSLATION",
        "auditRecords": "Schede di raccolta",
        "audits": "Progetti di raccolta",
        "thesaurusTerms": "Termini del thesaurus",
        "thesaurus": "Tesauro",
        "entityFields": "Dati del sistema",
        "collaborators": "Collaboratori",
        "authorities": "Autorità",
        "aliases": "Alias",
        "locations": "Luoghi",
        "conditionReports": "Rapporti sullo stato",
        "works": "Opere",
        "expressions": "Espressioni",
        "manifestations": "Eventi",
        "specimens": "MISSING TRANSLATION"
      },
      "time": {
        "hours": "ora/e",
        "minutes": "minuti",
        "seconds": "secondo(i)"
      },
      "thesaurusTermCreateForm": {
        "formTitle": "Creare un termine",
        "openButtonTitle": "Creare un termine",
        "createButton": "Convalidare",
        "anotherTermButton": "Convalidare e creare un altro termine",
        "cancelButton": "Annullare",
        "preferedTermLabel": "Termine preferito :",
        "synonymLabel": "Utilizzato per :",
        "genericTermPlaceholder": "Generico :",
        "selectSpecificLabel": "Selezionare termini specifici",
        "disabledOffline": "La creazione di un nuovo termine non è disponibile quando si utilizza l'applicazione offline."
      },
      "thesaurusTermTree": {
        "creationTabTitle": "Creare",
        errors: {
          searchError: "La ricerca non ha avuto successo",
          fetchError: "Impossibile recuperare i termini del thesaurus"
        },
        "modalSearchInputPlaceholder": "Ricerca di un termine",
        "selectionTabTitle": "Selezionare",
        "thesaurusTermSelectorModalTitle": "Selezionare un termine",
        "validate": "Confermare"
      },
      uploadImageFailureDialog: {
        cancel: "Abbandona l'immagine {0}",
        cancelAll: "Abbandona tutte le immagini",
        description: "Il caricamento di {0} immagini non è riuscito.",
        imageAndNumber: "Immagine {0}",
        retry: "Riprova per l'immagine {0}",
        retryAll: "Riprova per tutte le immagini",
        title: "Caricamento immagine fallito",
      },
      "state": {
        "all": "Tutti",
        "archived": "Archiviato",
        "canceled": "Annullato",
        "finalized": "Completato",
        "inPreparation": "In preparazione",
        "inProgress": "In corso",
        "programmed": "Pianificato",
        "toValidated": "Da convalidare",
        "validated": "Convalidato",
        "aborted": "Non più in uso",
        "success": "Completato con successo",
        "error": "Errore",
        "none": "Nessuna sincronizzazione precedente"
      },
      "SpecimenSearchScreen": {
        "createNewSpecimen": "MISSING TRANSLATION"
      },
    },
    "no": {
      "countryCode": "no",
      "actionBar": {
        "bar": {
          "inProgress": "Pågår",
          "latest": "Avsluttet"
        },
        "sideMenu": {
          "saveModifications": "Lagre endringene",
          "reportOverview": "Oversikt over tilstandsrapport",
          "signReport": "Signer tilstandsrapport",
          "closeReport": "Lukk tilstandsrapport",
          "countersignReport": "Kontrasigner tilstandsrapporten",
          "printReport": "Skriv ut tilstandsrapport",
          "deleteReport": "Slett gjeldende tilstandsrapport",
          "deleteReportOfflineWarning": "Advarsel, dette elementet er ikke synkronisert!",
          "deleteModificationsNotSynchronized": "Slett usynkroniserte endringer",
          "duplicateReport": "Dupliser tilstandsrapporten",
          "confirmDeletion": "Bekreft sletting"
        }
      },
      "alerts": {
        "medias": {
          "failUpload": "Kunne ikke laste opp mediet",
          "failGetIdFromFileName": "Mediet er lastet opp, men Skin-Reporter finner det ikke",
        },
        "permissions": {
          "camera": {
            askForPermission: "SKR-Condition Report trenger tillatelse til å få tilgang til kameraet. Denne tillatelsen er nødvendig for strekkode-/QR-kodeskanningsfunksjonene. Uten denne tillatelsen kan ikke disse funksjonene leveres.",
            permissionDeniedWarning: "SKR-Condition Report har tidligere blitt nektet tilgang til kameraet. Funksjonene for skanning av strekkoder/QR-koder er derfor ikke tilgjengelige. For å få tilgang til disse må du manuelt autorisere tilgang til kameraet for SKR-Condition Report.",
          }
        },
        "workspace": {
          "unableToChangeWorkspace": "Kunne ikke endre arbeidsområdet",
          "unableToLoadWorkspace": "Lasting av arbeidsområdet mislyktes",
        },
      },
      alterationDetailImagePopup: {
        title: "Gedetailleerde weergaven van wijzigingen {0}",
      },
      "alterationCard": {
        "moreMenu": {
          "deleteAlteration": "Slett endringen",
          "changeAlterationTitle": "Endre tittelen på endringen",
          "changeAlterationType": "Endre type endring",
          "titleModalHeader": "Rediger tittelen på endringen",
          "titleModalButton": "Bekreft"
        },
        titleAutoCompletePlaceHolder: "Tittel",
      },
      archiveCrEditScreenHeader: {
        materialImportance: "MISSING TRANSLATION",
        principalMediumType: "MISSING TRANSLATION",
      },
      archiveEditScreen: {
        saveAlert: {
          errorMessage: "MISSING TRANSLATION",
          successMessage: "MISSING TRANSLATION",
        },
      },
      archiveEditScreenHeader: {
        cote: "MISSING TRANSLATION",
        descriptionLevel: "MISSING TRANSLATION",
      },
      archiveSearchScreen: {
        createNewArchive: "MISSING TRANSLATION",
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Brukernavn og/eller passord er feil",
            "network": "Kommunikasjon med server mislyktes"
          },
          "form": {
            "password": {
              "error": "Vennligst skriv inn brukernavnet ditt",
              "label": "Passord"
            },
            "submit": "Logg Inn",
            "submitting": "Logger inn",
            "username": {
              "error": "Vennligst skriv inn passordet ditt",
              "label": "Brukernavn"
            }
          }
        },
        "renew": {
          "slowNetwork": "Dette tar mer tid enn vanlig. Vennligst ikke avslutt applikasjonen.",
          "spinner": "Får deg online igjen"
        },
        sso: {
          errors: {
            authenticationFailed: "Feil: Autentiseringen feilet"
          },
          selectIDP: "Logg inn med…",
          otherIDPs: "Andre brukertyper",
        },
      },
      autoCompleteTextField: {
        modal: {
          okButton: "OK",
        },
      },
      cameraScanner: {
        scanCode: "Skann strekkoden",
        cancel: "Annuleren",
        errors: {
          cameraNotFound: "Ingen kameraer oppdaget",
        },
      },
      "closeReportScreen": {
        "important": "VIKTIG",
        "close": "Tilstandsrapporten lukkes",
        "title": "Lukk tilstandsrapport",
        "notificationContent": "Rapporten '{referenceNumber}' er lukket, og statusen til det koblede objektet er oppdatert.",
        "warningMessage": "Når den er lukket, kan ikke tilstandsrapporten endres eller slettes",
        "warningQuestion": "Er du sikker på at du vil lukke tilstandsrapporten?",
        "transferingFile": "Overfører PDF-dokument...",
        "fileGeneration": "Genererer endelig PDF-dokument...",
        "reportClosing": "Lukker gjeldende tilstandsrapport...",
        errors: {
          transitionState: "Det oppstod en feil ved lukking av rapporten. PDF-filen ble generert og lagt til i statusrapporten.",
          pushingPDF: "PDF-filen som ble generert, ble ikke lagt til i statusrapporten. Avslutningen ble avbrutt.", 
        },
      },
      counterSignatureModuleScreen: {
        title: "Contrasignering",
        saveButton: "Bekreft",
        warnings: {
          exit: 'OBS Hvis du forlater siden, vil det pågående arbeidet gå tapt.',
          okButton: 'Fortsett',
          cancelButton: 'Avbryt',
          save: 'Når du har lagret merknadene dine, kan du ikke redigere dem senere.',
        },
      },
      createArchiveModal: {
        creationFailed: "MISSING TRANSLATION",
        descriptionLevel: "MISSING TRANSLATION",
        submitBtn: "MISSING TRANSLATION",
        submitting: "MISSING TRANSLATION",
        title: "MISSING TRANSLATION",
      },
      "defectTree": {
        "alteration": {
          "alterationLabel": "Type skade:",
          "alterationsTitle": "Skader:",
          "createAlterationButtonLabel": "Skade",
          "levelTitle": "Nivå 3",
          "precisionLabel": "Detalj:",
          "deleteConfirmationMessage": "Bekreft sletting av skaden og -innholdet?",
          "precisionPlaceholder": "Velg underkategori",
          "thesaurusTermWarningMessage": "Den valgte skaden samsvarer ikke med materialet lenger opp",
          "typeOfAlterationPlaceholder": "Velg type observasjon"
        },
        "annotation": {
          "annotationsTitle": "Merknader:",
          "commentsPlaceholder": "Presiser…",
          "deleteConfirmationMessage": "Bekreft sletting ?",
          "defaultImageConfirmationMessage": "Angi som standardbilde ?"
        },
        "defect": {
          "createElementButtonLabel": "Element",
          "deleteConfirmationMessage": "Bekreft sletting av elementet med innhold?",
          "elementLabel": "Element:",
          "precisionLabel": "Detalj",
          "elementPlaceholder": "Navn på elementet",
          "precisionPlaceholder": "Spesifiser…"
        },
        "material": {
          "createMaterialButtonLabel": "Materiale",
          "deleteConfirmationMessage": "Bekreft sletting av materiale med innhold?",
          "levelTitle": "Nivå 2",
          "materialLabel": "Materiale:",
          "materialsTitle": "Materialer:",
          "thesaurusTermWarningMessage": "Det valgte materialet samsvarer ikke med typen observasjon"
        },
        "observation": {
          "createObservationButtonLabel": "Observasjon",
          "deleteConfirmationMessage": "Bekreft sletting av observasjon med innhold?",
          "levelTitle": "Nivå 1",
          "observationLabel": "Type observasjon:",
          "observationsTitle": "Observasjoner:"
        },
        "submit": "Lagre endringene",
        "submitError": "Datatreet kunne ikke oppdateres",
        "submitting": "Lagrer …"
      },
      "drawingEditor": {
        "title": "Detaljert skade",
        "imageCaption": "Bildetekst:",
        "imageTitlePlaceholder": "Tast inn bildetekst",
        "observationLabel": "Obs.{indeks}",
        "observationPlaceholder": "Tast inn en observasjon",
        "validate": "Lagre",
        "alterationLabel": "{index}",
        "alterationModalTitle": "Velg en skade",
        "errors": {
          alteration: "Wijziging ",
          "missingTitleOrType": "Vennligst oppgi en tittel eller type endring for hver endring",
          failedUploadDetailedImageDescription: "Het uploaden van {0} afbeeldingen van gedetailleerde weergaven van wijzigingen {1} is mislukt",
        },
        "alterationLine": {
          "precisionModal": {
            "title": "Presisjon",
            "validateButton": "Bekreft"
          },
          "titlePlaceHoder": "Tittel på endringen...",
          "typeOfAlterationPlaceholder": "Type endring..."
        }
      },
      "editReportScreen": {
        "alerts": {
          duplicateClosedReport: {
            success: "Rapporten ble duplisert med suksess",
            failure: "Duplisering av rapporten mislyktes",
            warningReportNotClosed: "Rapporten må lukkes før den kan dupliseres",
          }
        },
        "reportTitlePrefix": "Rapportnummer {refNumber}",
        "reportStatusInProgress": "Pågår",
        "reportIdentifiers": {
          "accordionPanelTitle": "Rapportens identifikatorer",
          "referenceNumber": "Referansenummer",
          "numberingInformation": "La dette feltet stå tomt for å aktivere den automatiske nummereringen ved neste lagring",
          "otherIdentifiers": "Andre identifikatorer",
          "reportReason": "Årsak til tilstandsrapport",
          "precision": "Presiser",
          "reportType": "Rapporttype",
          "reportTypePlaceholder": "Velg en rapporttype",
          "tabTitle": "Identifikasjon"
        },
        "reportContext": {
          "accordionPanelTitle": "RAPPORTENS KONTEKST",
          "reportDate": "Dato for rapport",
          "reportDoneInThePresenceOf": "Rapport skrevet i nærvær av",
          "andOf": "og",
          "name": "Navn/etternavn, stilling",
          "role": "Stilling",
          "coordinates": "Kontaktinfo",
          "email": "E-post",
          "signer": "Rapporten er signert av:",
          "reportPlace": "Sted",
          "customer": "Kunde/oppdragsgiver",
          "precisions": "Presiser",
          "linkedProject": "Tilknyttet prosjekt",
          "linkedMovement": "Tilknyttet bevegelse",
          "technicsAndMaterials": "Teknikker og materialer",
          "comments": "Kommentarer",
          "signerComponent": {
            "name": "Signert av",
            "date": "Dato for underskrift",
            "positionOfSignatory": "Signatarens stilling",
            "title": "Signert av",
          },
          counterSignatureComponent: {
            comment: "Kommentar",
            location: "Beliggenhet",
            reason: "Begrunnelse",
            date: "Dato",
          },
          counterSignaturesComponent: {
            title: "Tegenduidingen",
          },
          "counterSignerComponent": {
            "name": "Etternavn/fornavn",
            "function": "Funksjon",
            signature: 'Signatur',
          },
          counterSignersComponent: {
            title: "Rapport utarbeidet i nærvær av:",
          },
        },
        "alterations": {
          "accordionPanelTitle": "SKADER",
          "mediasSectionTitle": "RAPPORTENS BILDER",
          "globalAlterationSectionTitle": "GENERELLE SKADER",
          "createAlterationForm": {
            "createAlterationButtonTitle": "Opprett",
            "alterationTypeLabel": "Skadetype",
            "precisionLabel": "Presisjon"
          },
          "tabTitle": "Endringer",
          "viewMenu": {
            "alterationTypeView": "Vis etter type endring",
            "imageView": "Bildevisning",
            "titleView": "Vis etter tittel"
          }
        },
        "conservation": {
          "accordionPanelTitle": "KONSERVERING OG MANIPULERING"
        },
        "observations": {
          "tabTitle": "Balanse",
          "accordionPanelTitle": "RAPPORT OG OBSERVASJONER ",
          "commentsFieldLabel": "Kommentarer",
          "countersignature": "Kontrasignaturer",
          "interventionToSchedule": "Planlagte intervensjoner",
          "interventionToSchedulePlaceholder": "Velg en intervensjon",
          "interventionToSchedulePrecision": "Presisering:",
          "stateOfConservation": "Objektets tilstand",
          "stateOfConservationPlaceholder": "Velg en tilstand",
          "signature": "Underskriver",
          "typeOfStateOfConservation": "Type status",
          "treatmentPriority": "Behandlingsprioritet",
          "treatmentPriorityPlaceholder": "Velg en prioritet"
        },
        "medias": {
          "accordionPanelTitle": "MEDIA"
        },
        "saveAlert": {
          "errorMessage": "Det oppstod en feil under lagring av tilstandsrapporten",
          "successMessage": "Tilstandsrapporten er lagret",
          "inventoryNumberNotUnique": "Umulig validering"
        },
        "deleteAlert": {
          "errorMessage": "Det oppstod en feil ved sletting av tilstandsrapporten",
          "successMessage": "Tilstandsrapporten er slettet"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Det oppstod en feil under sletting av usynkroniserte endringer",
          "successMessage": "Endringene er kansellert"
        },
        "fieldDisabledOffline": "Dette feltet er ikke tilgjengelig i frakoblet modus",
        pdf: {
          counterSignaturePDF: {
            startGenerating: "PDF-generering har startet",
            success: "PDF-generering fullført vellykket",
            failure: "PDF-generering mislyktes",
          }
        },
      },
      "firewall": {
        "collabWarningMessage": "Kontoen din har ingen tilknyttet samarbeidspartner, det kan hende at appen ikke fungerer",
        "noGroupForUserWarningMessage": "Din brukerkonto må være en del av en brukergruppe for å kunne bruke SKINreporter"
      },
      genericEditScreen: {
        genericErrorMsg: "MISSING TRANSLATION",
        saveErrorMsg: "MISSING TRANSLATION",
        saveSuccessMsg: "MISSING TRANSLATION",
      },
      "listReportScreen": {
        "closed": {
          "downloadFailure": "Det oppstod en feil under nedlastingen ",
          "downloadSuccess": "Dokumentet {docTitle} ble lastet ned",
          "open": "LAST NED DOKUMENTET",
          "title": "Fullførte tilstandsrapporter"
        },
        "inProgress": {
          "edit": "REDIGER TILSTANDSRAPPORT",
          "title": "Tilstandsrapporter under redigering"
        },
        "concernedItem": "Berørt museumsobjekt",
        "nbResults": "{nbResults} resultater",
        "noResults": "Intet resultat"
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Utplassert den",
          "checkForUpdate": {
            "help": "Er en oppdatering  tilgjengelig, vil den installeres automatisk.",
            "title": "Vennligst se etter oppdateringer"
          },
          "clearCache": {
            "help": "Hvis du er frakoblet, vil denne prosessen fjerne tilgangen til alle data som er lagret på enheten",
            "title": "Tøm hurtigbufferminnet"
          },
          "overrideLocale": {
            "help": "Det engelske språket vil bli brukt, og enhetens innstillinger vil bli ignorert",
            "title": "Overstyr lokalspråket med engelsk"
          },
          "resetLocaleOverride": {
            "help": "Språket som vil brukes, styres av enhetens innstillinger",
            "title": "Tilbakestill språket"
          },
          "serviceWorker": {
            help: "Vises oppdateringsbanneret kontinuerlig? Klikk her!",
            title: "Lukk oppdateringsbanneret",
          },
          "title": "Skin-REPORTER",
          "version": "versjon",
        },
        "logout": "Er du sikker på at du vil logge ut?"
      },
      "offlineRibbon": {
        "offline": "Du er nå offline",
        "online": "Du er nå online"
      },
      "pdfOverviewScreen": {
        "download": "Nedlasting",
        "progressBar": {
          "mainLabel": "Generer dokumentet",
          "object": "Objekt",
          "generalDigest": "Generelle vurderinger",
          "defects": "Skader",
          "contextAndSignatures": "Kontekst",
          "documentReady": "Dokumentet er nå klart!"
        },
        "title": "Oversikt",
        "renderFailureAlert": "Kunne ikke gjengi PDF-filen, vennligst prøv igjen"
      },
      "pdfDocument": {
        "mainTitlePrefix": "TILSTANDSRAPPORT -",
        "objectSection": {
          "sectionTitle": "Gjenstand",
          "inventoryNumber": "Inventarnummer:",
          "title": "Tittel:",
          "author": "Kunstner/forfatter:",
          "creationDate": "Opprettelsesdato :",
          "typology": "Typologi:",
          "denomination": "Navn:",
          "materialsAndTechniques": "Materialer og teknikker:",
          "dimensions": "Dimensjoner:",
          "institution": "Institusjon:",
          conditioning: "Emballasje:",
          descriptions: "Beskrivelse(r):",
          domains: "Hovedkategori:",
          identification: "Identifikasjon:",
          location: "Plassering:",
          materials: "Materiale(r):",
          ownerInstitutions: "Eiende institusjon:",
          techniques: "Teknikk(er):",
        },
        "alterationsSection": {
          "detailedAlteration": "Skadedetaljer",
          "noAnnotation": "Ingen merknad å vise",
          "observationLabel": "Obs.",
          "sectionTitle": "Skader"
        },
        archiveSection: {
          sectionTitle: "MISSING TRANSLATION",
          archiveType: "MISSING TRANSLATION",
          conditioning: "MISSING TRANSLATION",
          cote: "MISSING TRANSLATION",
          descriptionLevel: "MISSING TRANSLATION",
          location: "MISSING TRANSLATION",
          materialImportance: "MISSING TRANSLATION",
          parentArchive: "MISSING TRANSLATION",
          productors: "MISSING TRANSLATION",
          productionDate: "MISSING TRANSLATION",
          proprietaryInstitution: "MISSING TRANSLATION",
          supportType: "MISSING TRANSLATION",
          title: "MISSING TRANSLATION",
        },
        detailedViewsSection: {
          sectionTitle: "Detaljer om skader",
        },
        "finalObservationsSection": {
          "sectionTitle": "Siste observasjoner"
        },
        conditioningSection: {
          crateNumber: "Nummer på kassaapparatet:",
          sectionTitle: "Emballasje",
          transportAccessories: "Tilbehør til transport:",
          typeOfPackaging: "Type emballasje:",
        },
        "contextSection": {
          "comments": "Kommentarer:",
          "editors": "Redaktører:",
          "matAndTechs": "Teknikker og materialer:",
          "reportDate": "Rapportdato:",
          "reportReference": "Rapportens referanser",
          "reportPlace": "Plassering:",
          "reportType": "Rapporttype:",
          "reportReason": "Årsak til tilstandsrapport:",
          "sectionTitle": "Tilstandsrapportens kontekst",
          signers: "Signert av:",
        },
        "reportSection": {
          "counterSignaturesTitle": "Kontrasignaturer",
          counterSignature: {
            comment: 'Commentaar:',
          },
          "interventionsToSchedule": "Intervensjoner å planlegge:",
          "sectionTitle": "Rapport",
          "signatoriesTitle": "Rapport utarbeidet i nærvær av:",
          "stateOfConservation": "Objektets tilstand",
          "treatmentPriority": "Behandlingsprioritet:"
        },
        "footer": {
          "prefix": "TILSTANDSRAPPORT",
          "separator": "- Side"
        },
        "generationFailureAlert": "PDF-generering mislyktes, prøv igjen"
      },
      "proxy": {
        "error": {
          "default": "Det oppsto en feil på ressursen {uri}",
          "network": "Kommunikasjon med serveren har mislyktes",
          "notFound": "Ressursen {uri} ble ikke funnet",
          "tokenHasExpired": "Økten din har utløpt"
        }
      },
      "search": {
        "noResults": "Ingen resultater",
        "options": {
          "sortType": {
            "creationDate": "Opprettelsesdato",
            "identifier": "Hoved identifikator",
            "lastModification": "Siste endring",
            "mainTitle": "Hovedtittel",
            "referenceNumber": "Referansenummer"
          }
        },
        "queryPlaceholder": "Søkeord eller katalognummer",
        "title": "Objekter",
        "totalCount": "{totalResults} resultat(er): 1 - {nbResults}"
      },
      "searchFeaturedCard": {
        "consultLastReport": "SE DEN SISTE LUKKEDE RAPPORTEN",
        "createNewReport": "OPPRETT NY TILSTANDSRAPPORT",
        "createNewReportFromLast": "TILSTANDSRAPPORT SIDEN SISTE RAPPORT",
        "institutionLabel": "Institusjon",
        "lastReportLabel": "Siste tilstandsrapport",
        "materialsAndTechniques": "Materialer / Teknikker",
        "measurements": "Dimensjoner:",
        "noLinkedItem": "Intet objekt er knyttet til denne tilstandsrapporten"
      },
      selectItemErrorDialog: {
        cancel: "Forlat objektet",
        cancelAll: "Forlat alle objekter",
        description: "Valget av {0} objekter mislyktes.",
        retry: "Prøv på nytt for dette objektet",
        retryAll: "Prøv på nytt for alle objekter",
        title: "Kunne ikke velge bilder",
      },
      "serviceWorker": {
        "updateAvailable": "En oppdatering er installert. Du kan enten klikke her for å oppdatere siden eller starte applikasjonen på nytt.",
        forceServiceWorkerUpdate: {
          modalTitle: "Løsning på problemet",
          versionCorrect: "Stemmer informasjonen nedenfor overens med versjonen og datoen gitt av SKINsoft etter den siste oppdateringen ?",
          "yes": "Ja",
          "no": "Nei",
        },
      },
      "signatureModuleScreen": {
        "cardTitle": "Underskriver",
        "eraseSignature": "Signer om igjen",
        "missingSignature": "Tilstandsrapporten er ikke signert",
        "nameLabel": "Signert av",
        "positionOfSignatory": "Signatarens stilling",
        "presentSignature": "Tilstandsrapporten er signert",
        "saveSignature": "Lagre",
        "signatureStatus": "Status for signatur",
        "title": "Signaturer"
      },
      "editItemScreen": {
        "author": "Kunstner",
        "inventoryNumber": "Inventarnummer:",
        "confirmButton": "Bekreft",
        "editButton": "Endre",
        "saveNotification": {
          "errorMessage": "Det oppsto en feil under lagring av objektet",
          "inventoryNumberNotUnique": "Umulig validering",
          "successMessage": "Objektet er lagret"
        },
        sections: {
          creation: "Opprettelse",
          description: "Beskrivelse",
          identification: "Identifikasjon",
          location: "Plassering",
          notes: "Merknader",
          state: "Status",
        },
        "deleteNotification": {
          "errorMessage": "Det oppstod en feil under sletting av det usynkroniserte objektet",
          "successMessage": "Objektet er slettet"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Det oppstod en feil under sletting av usynkroniserte endringer",
          "successMessage": "Endringene er kansellert"
        },
        "errorMessages": {
          "inventoryNumberNotUnique": "Dette inventarnummeret er allerede tildelt"
        },
        "menu": {
          "saveModifications": "Lagre endringene",
          "deleteNotSynchronizedNewItem": "Slett det nye objektet",
          "deleteModificationsNotSynchronized": "Slett usynkroniserte endringer",
          "offlineWarning": "Endringer lagres på denne enheten, du må synkronisere dem med databasen når nettverket er tilbake.",
          "offlineShortWarning": "Endret på denne enheten"
        },
        "fieldDisabledOffline": "Dette feltet er ikke tilgjengelig i frakoblet modus"
      },
      "editRecordScreen": {
        "foldAll": "Reduser alle",
        "unfoldAll": "Distribuere alle",
        "medias": {
          "accordionPanelTitle": "MEDIER"
        }
      },
      "itemCreationImagePopup": {
        "title": "Legg til et bilde",
        "addImage": "LEGG TIL ET BILDE",
        "ignore": "SENERE, IGNORER DETTE TRINNET"
      },
      "itemSearchScreen": {
        "createNewItem": "OPPRETT NYTT ELEMENT"
      },
      "locationSelector": {
        "inputPlaceholder": "Tast inn en plassering",
        "title": "Velg en plassering",
        "validate": "Valider"
      },
      "maskFields": {
        "boolean": {
          "no": "Nei",
          "undefined": "Udefinert",
          "yes": "Ja"
        },
        "entitySelect": {
          "modalPlaceholder": "Søkeord eller identifikatorer…"
        }
      },
      "synchroModal": {
        "title": "Synkronisering",
        "lastFetch": "Siste henting",
        "duration": "Varighet",
        "status": "Status",
        "details": "Detaljer",
        "lastSynchro": "Siste synkronisering",
        "noEntityToSync": "Ingen enhet å synkronisere",
        "connectionWarningPrefix": "Du må ha en internettforbindelse for å kunne",
        "connectWarningSend": "sende",
        "connectWarningRetrieve": "hente",
        "connectionWarningSuffix": "data",
        "noDataToSync": "Ingen data å synkronisere foreløpig",
        "localIconInfoPrefix": "Ikonet",
        "localIconInfoSuffix": " indikerer at de tilsvarende dataene har blitt endret lokalt og må synkroniseres med den eksterne databasen.",
        "retrieveAll": "Hent alle",
        "finishedSynchros": "Ferdige synkroniseringer",
        "syncAll": "Synkroniser alle",
        "remainsToSynchronize": "Gjenstår å synkronisere",
        "cleanImageCache": "Fjerne spøkelsesbilder fra hurtigbufferen",
        "cachedImagedCleaned": "Spøkelsesbildene er fjernet!",
        "cleanCacheDown": "Tøm hurtigbufferen",
        "cacheDownCleaned": "Cachen er tømt!",
        "cleanCacheUp": "Slett alle usynkroniserte endringer",
        "cacheUpCleaned": "Alle usynkroniserte endringer er slettet!"
      },
      "entityNames": {
        "items": "Gjenstander",
        archives: "MISSING TRANSLATION",
        "auditRecords": "Revisjonsskjemaer",
        "audits": "Revisjonsprosjekter",
        "thesaurusTerms": "Termer i tesaurusen",
        "thesaurus": "Tesaurus",
        "entityFields": "Systemdata",
        "collaborators": "Samarbeidspartnere",
        "authorities": "Myndigheter",
        "aliases": "Aliaser",
        "locations": "Plasseringer",
        "conditionReports": "Tilstandsrapporter",
        "works": "Verk",
        "expressions": "Uttrykk",
        "manifestations": "Arrangementer",
        "specimens": "MISSING TRANSLATION"
      },
      "time": {
        "hours": "time(r)",
        "minutes": "minutt(er)",
        "seconds": "sekund(er)"
      },
      "thesaurusTermCreateForm": {
        "formTitle": "Opprett begrep",
        "openButtonTitle": "Opprett vilkår",
        "createButton": "Bekreft",
        "anotherTermButton": "Bekreft og opprett et annet vilkår",
        "cancelButton": "Avbryt",
        "preferedTermLabel": "Foretrukket begrep ",
        "synonymLabel": "Brukes for",
        "genericTermPlaceholder": "Generisk",
        "selectSpecificLabel": "Velg spesifikke termer",
        "disabledOffline": "Det er ikke tillatt å opprette en tesaurusTerm mens du er frakoblet."
      },
      "thesaurusTermTree": {
        "creationTabTitle": "Opprettelse",
        errors: {
          searchError: "Søket var resultatløst",
          fetchError: "Kan ikke hente termer fra tesaurusen"
        },
        "modalSearchInputPlaceholder": "Søke etter en term",
        "selectionTabTitle": "Utvelgelse",
        "thesaurusTermSelectorModalTitle": "Velg et begrep",
        "validate": "Validere"
      },
      uploadImageFailureDialog: {
        cancel: "Avbryt bilde {0}",
        cancelAll: "Avbryt alle bilder",
        description: "Opplastingen av {0} bilder mislyktes.",
        imageAndNumber: "Bilde {0}",
        retry: "Prøv på nytt for bilde {0}",
        retryAll: "Prøv på nytt for alle bilder",
        title: "Opplasting av bilder mislyktes",
      },
      "state": {
        "all": "Alle",
        "archived": "Arkivert",
        "canceled": "Kansellert",
        "finalized": "Fullført",
        "inPreparation": "Under forberedelse",
        "inProgress": "pågår",
        "programmed": "Programmert",
        "toValidated": "Trenger validering",
        "validated": "Validert",
        "aborted": "Avbrutt",
        "success": "Fullført",
        "error": "Feil",
        "none": "Ingen tidligere synkronisering"
      },
      "SpecimenSearchScreen": {
        "createNewSpecimen": "MISSING TRANSLATION"
      },
    },
    "de": {
      "countryCode": "de",
      "actionBar": {
        "sideMenu": {
          "deleteReportOfflineWarning": "Achtung, dieses Element ist nicht synchronisiert!",
          "deleteModificationsNotSynchronized": "Nicht synchronisierte Änderungen löschen",
          "confirmDeletion": "Löschung bestätigen",
          "countersignReport": "Unterschreiben Sie die Zustandsfeststellung gegen",
          "saveModifications": "Änderungen abspeichern",
          "reportOverview": "Vorschau des Zustandsprotokolls",
          "signReport": "Zustandsprotokoll unterzeichnen",
          "closeReport": "Zustandsprotokoll abschließen",
          "printReport": "Zustandsprotokoll ausdrucken",
          "duplicateReport": "Statusbericht duplizieren",
          "deleteReport": "laufendes Zustandsprotokoll löschen"
        },
        "bar": {
          "inProgress": "in Arbeit",
          "latest": "beendet"
        }
      },
      archiveCrEditScreenHeader: {
        materialImportance: "MISSING TRANSLATION",
        principalMediumType: "MISSING TRANSLATION",
      },
      archiveEditScreen: {
        saveAlert: {
          errorMessage: "MISSING TRANSLATION",
          successMessage: "MISSING TRANSLATION",
        },
      },
      archiveEditScreenHeader: {
        cote: "MISSING TRANSLATION",
        descriptionLevel: "MISSING TRANSLATION",
      },
      archiveSearchScreen: {
        createNewArchive: "MISSING TRANSLATION",
      },
      autoCompleteTextField: {
        modal: {
          okButton: "Ok",
        },
      },
      cameraScanner: {
        scanCode: "Barcode scannen",
        cancel: "Abbrechen",
        errors: {
          cameraNotFound: "Es wurde keine Kamera erkannt",
        },
      },
      counterSignatureModuleScreen: {
        title: "Gegenunterschrift",
        saveButton: "Bestätigen",
        warnings: {
          exit: 'Achtung! Wenn Sie die Seite verlassen, geht die aktuelle Arbeit verloren.',
          okButton: 'Weiter',
          cancelButton: 'Abbrechen',
          save: 'Sobald die Gegenunterschriften gespeichert sind, können sie später nicht mehr geändert werden!',
        },
      },
      createArchiveModal: {
        creationFailed: "MISSING TRANSLATION",
        descriptionLevel: "MISSING TRANSLATION",
        submitBtn: "MISSING TRANSLATION",
        submitting: "MISSING TRANSLATION",
        title: "MISSING TRANSLATION",
      },
      "defectTree": {
        "annotation": {
          "defaultImageConfirmationMessage": "Als Standardbild festlegen?",
          "annotationsTitle": "Bemerkungen:",
          "commentsPlaceholder": "bitte genau angeben…",
          "deleteConfirmationMessage": "Bestätigen sie die Löschung?"
        },
        "alteration": {
          "alterationLabel": "Art der Beschädigung:",
          "alterationsTitle": "Beschädigungen:",
          "createAlterationButtonLabel": "Beschädigung",
          "levelTitle": "Stufe 3",
          "precisionLabel": "genaue Angabe:",
          "deleteConfirmationMessage": "Bestätigen sie die Löschung der Beschädigung und ihres Inhalts?",
          "precisionPlaceholder": "eine Unterart auswählen",
          "thesaurusTermWarningMessage": "Die Art der ausgewählten Beschädigung entspricht nicht dem oben genannten Material",
          "typeOfAlterationPlaceholder": "Art der Beobachtung auswählen"
        },
        "defect": {
          "createElementButtonLabel": "Element",
          "deleteConfirmationMessage": "Bestätigen sie die Löschung des Elements und seines Inhalts?",
          "elementLabel": "Element:",
          "precisionLabel": "genaue Angabe",
          "elementPlaceholder": "Name des Elements",
          "precisionPlaceholder": "bitte genau angeben…"
        },
        "material": {
          "createMaterialButtonLabel": "Material",
          "deleteConfirmationMessage": "Bestätigen sie die Löschung des Materials und seines Inhalts?",
          "levelTitle": "Stufe 2",
          "materialLabel": "Material",
          "materialsTitle": "Materialien",
          "thesaurusTermWarningMessage": "Das ausgewählte Material entspricht nicht der oben genanten Beobachtungsart"
        },
        "observation": {
          "createObservationButtonLabel": "Beobachtung",
          "deleteConfirmationMessage": "Bestätigen sie die Löschung der Beobachtung und ihres Inhalts?",
          "levelTitle": "Stufe 1",
          "observationLabel": "Art der Beobachtung",
          "observationsTitle": "Beobachtungen:"
        },
        "submit": "die Anderungen abspeichern",
        "submitError": "der Baum konnte nicht aktualisiert werden",
        "submitting": "Speicherung läuft…"
      },
      "drawingEditor": {
        "alterationModalTitle": "eine Beschädigung auswählen",
        "title": "ausführliche Beschreibung der Beschädigung",
        "imageCaption": "Bildunterschrift:",
        "imageTitlePlaceholder": "Bildunterschrift eingeben",
        "alterationLabel": "{index}",
        "observationPlaceholder": "eine Beobachtung eingeben",
        "validate": "Eingeben",
        "errors": {
          alteration: "Alteration ",
          "missingTitleOrType": "Geben sie für jede Beschädigung einen Titel bzw. die Art der Beschädigung ein",
          failedUploadDetailedImageDescription: "Das Herunterladen von {0} Bildern von Detailansichten der Veränderungen {1} ist fehlgeschlagen",
        },
        "alterationLine": {
          "precisionModal": {
            "title": "genaue Angabe",
            "validateButton": "Bestätigen"
          },
          "titlePlaceHoder": "Titel der Beschädigung ",
          "typeOfAlterationPlaceholder": "Art der Beschädigung"
        }
      },
      "editItemScreen": {
        "saveNotification": {
          "inventoryNumberNotUnique": "Bestätigung unmöglich, da die Datensatz-ID bereits existiert",
          "errorMessage": "Bei der Speicherung des Objekts ist ein Fehler aufgetreten",
          "successMessage": "Das Objekt wurde erfolgreich abgespeichert"
        },
        sections: {
          creation: "Erstellung",
          description: "Beschreibung",
          identification: "Identifikation",
          location: "Lokalisierung",
          notes: "Anmerkungen",
          state: "Status",
        },
        "errorMessages": {
          "inventoryNumberNotUnique": "Diese Inv.-Nr. ist bereits vergeben"
        },
        "fieldDisabledOffline": "Die Eingabe in dieses Feld ist offline nicht möglich",
        "author": "Autor",
        "confirmButton": "Bestätigen",
        "editButton": "Ändern",
        "inventoryNumber": "Inv.-Nr.",
        "deleteNotification": {
          "errorMessage": "Bei der Löschung des nicht synchronisierten Objekts ist ein Fehler aufgetreten",
          "successMessage": "Das Objekt wurde erfolgreich gelöscht"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Bei der Löschung der nicht synchronisierten Änderungen ist ein Fehler aufgetreten",
          "successMessage": "Die Änderungen sind gelöscht worden"
        },
        "menu": {
          "saveModifications": "Änderungen abspeichern",
          "deleteNotSynchronizedNewItem": "das neue Objekt löschen",
          "deleteModificationsNotSynchronized": "nicht synchronisierte Änderungen löschen",
          "offlineWarning": "Die Änderungen sind auf dem Endgerät abgespeichert. Sie müssen mit der Datenbank synchronisiert werden, sobald das Netz wieder verfügbar ist.",
          "offlineShortWarning": "auf diesem Endgerät ändern"
        }
      },
      "editReportScreen": {
        "alerts": {
          duplicateClosedReport: {
            success: "Der Bericht wurde erfolgreich dupliziert",
            failure: "Die Vervielfältigung des Berichts ist fehlgeschlagen",
            warningReportNotClosed: "Der Bericht muss geschlossen werden, bevor er dupliziert werden kann",
          }
        },
        "alterations": {
          "mediasSectionTitle": "BILDMATERIAL ZUSTANDSPROTOKOLL",
          "globalAlterationSectionTitle": "ALLGEMEINE BESCHÄDIGUNGEN",
          "createAlterationForm": {
            "createAlterationButtonTitle": "erstellen",
            "alterationTypeLabel": "Art der Beschädigung",
            "precisionLabel": "genaue Angabe"
          },
          "accordionPanelTitle": "Beschädigungen:",
          "tabTitle": "Alterationen",
          "viewMenu": {
            "alterationTypeView": "Ansicht nach Art der Beschädigung",
            "imageView": "Fotoansicht",
            "titleView": "Ansicht nach Titel"
          }
        },
        "saveAlert": {
          "inventoryNumberNotUnique": "Bestätigung unmöglich, da die Datensatz-ID bereits existiert",
          "errorMessage": "bei der Speicherung des Zustandsprokolls ist ein Fehler aufgetreten",
          "successMessage": "Zustandsprotokoll gespeichert"
        },
        "fieldDisabledOffline": "Die Eingabe in dieses Feld ist offline nicht möglich",
        "reportTitlePrefix": "Zustandsprotokoll Nr.  {refNumber}",
        "reportStatusInProgress": "in Arbeit",
        "reportIdentifiers": {
          "accordionPanelTitle": "ZUSTANDSPROTOKOLL-ID",
          "referenceNumber": "Referenz-Nr.",
          "numberingInformation": "Bitte leer lassen, so dass bei der nächsten Abspeicherung die automatische Nummerierung aktiviert wird",
          "otherIdentifiers": "andere Identifikatoren",
          "reportReason": "Grund der Zustandsbegutachtung",
          "precision": "genaue Angabe:",
          "reportType": "Art des Zustandsprotokolls",
          "reportTypePlaceholder": "eine Art des Zustandsprotokolls auswählen ",
          "tabTitle": "Identifikation"
        },
        "reportContext": {
          "accordionPanelTitle": "KONTEXT DER ZUSTANDSBEGUTACHTUNG",
          "reportDate": "Datum des Protokolls",
          "reportDoneInThePresenceOf": "Protokoll erstellt in Anwesenheit von",
          "andOf": "und von",
          "name": "Name, Vorname, Funktion",
          "role": "Funktion",
          "coordinates": "Kontaktdaten",
          "email": "Email",
          "signer": "Unterschrift",
          "reportPlace": "Ort der Protokollerstellung",
          "customer": "Kunde/Auftraggeber",
          "precisions": "genaue Angaben",
          "linkedProject": "verbundenes Projekt ",
          "linkedMovement": "verbundene Objektbewegung",
          "technicsAndMaterials": "benutzte(s) Technik/Material",
          "comments": "Bemerkungen",
          "signerComponent": {
            "name": "Unterzeichner",
            "date": "Datum der Unterschrift",
            "positionOfSignatory": "Funktion des Unterzeichners",
            "title": "Unterzeichner*in",
          },
          counterSignatureComponent: {
            comment: "Kommentar",
            location: "Ort",
            reason: "Grund",
            date: "Datum",
          },
          counterSignaturesComponent: {
            title: "Gegenunterschriften",
          },
          "counterSignerComponent": {
            "name": "Name/Vorname",
            "function": "Funktion",
            signature: 'Unterschrift',
          },
          counterSignersComponent: {
            title: "Zustandsbegutachtung ausgeführt im Beisein von:",
          },
        },
        "conservation": {
          "accordionPanelTitle": "KONSERVIERUNG UND HANDLING"
        },
        "observations": {
          "tabTitle": "Schlussfolgerung",
          "accordionPanelTitle": "BERICHT UND BEOBACHTUNGEN",
          "commentsFieldLabel": "Bemerkungen",
          "countersignature": "Gegenunterschriften",
          "interventionToSchedule": "zu planende Maßnahmen",
          "interventionToSchedulePlaceholder": "eine Maßnahme auswählen",
          "interventionToSchedulePrecision": "genaue Angabe:",
          "stateOfConservation": "Zustand des Guts",
          "stateOfConservationPlaceholder": "einen Zustand auswählen",
          "signature": "Unterschriften",
          "typeOfStateOfConservation": "Art des Zustands",
          "treatmentPriority": "Behandlungspriorität",
          "treatmentPriorityPlaceholder": "eine Priorität auswählen"
        },
        "medias": {
          "accordionPanelTitle": "MEDIEN"
        },
        "deleteAlert": {
          "errorMessage": "bei der Löschung des Zustandsprotokolls ist ein Fehler aufgetreten",
          "successMessage": "Zustandsprotokoll gelöscht"
        },
        "deleteModificationsNotification": {
          "errorMessage": "bei der Löschung der nicht synchronisierten Änderungen  ist ein Fehler aufgetreten",
          "successMessage": "die Änderungen wurden abgebrochen"
        },
        pdf: {
          counterSignaturePDF: {
            startGenerating: "Die PDF-Generierung wurde gestartet.",
            success: "PDF-Generierung erfolgreich abgeschlossen.",
            failure: "PDF-Generierung fehlgeschlagen.",
          }
        },
      },
      "itemCreationImagePopup": {
        "title": "Bild hinzufügen",
        "addImage": "EIN BILD HINZUFÜGEN",
        "ignore": "SPÄTER DIESE ETAPPE ÜBERGEHEN"
      },
      "itemSearchScreen": {
        "createNewItem": "EIN NEUES OBJEKT ANLEGEN"
      },
      "pdfOverviewScreen": {
        "renderFailureAlert": "PDF-Dokument kann nicht angezeigt werden, bitte versuchen sie es später noch einmal",
        "download": "hochladen",
        "progressBar": {
          "mainLabel": "Erstellung des Dokuments ",
          "object": "Objekt",
          "generalDigest": "allgemeine Beurteilung",
          "defects": "Beschädigungen",
          "contextAndSignatures": "Kontext",
          "documentReady": "Das Dokument ist bereit!"
        },
        "title": "Vorschau"
      },
      "pdfDocument": {
        "generationFailureAlert": "Die Erstellung des PDF-Dokuments ist fehlgeschlagern, bitte versuchen sie es später noch einmal.",
        "mainTitlePrefix": "ZUSTANDSPROTOKOLL",
        "objectSection": {
          "sectionTitle": "Objekt",
          "inventoryNumber": "Inv.-Nr.",
          "title": "Titel",
          "author": "Künstler/ Autor:",
          "creationDate": "Herstellungsdatum:",
          "typology": "Typologie:",
          "denomination": "Benennung:",
          "materialsAndTechniques": "Material/Technik:",
          "dimensions": "Maße:",
          "institution": "Institution:",
          conditioning: "Verpackung:",
          descriptions: "Beschreibung(en):",
          domains: "Fachgebiet:",
          identification: "Identifikation:",
          location: "Standort:",
          materials: "Material(ien):",
          ownerInstitutions: "Besitzende Institution(en):",
          techniques: "Technik(en):",
        },
        "alterationsSection": {
          "detailedAlteration": "ausführliche Beschreibung der Beschädigung",
          "noAnnotation": "keine anzuzeigende Anmerkung",
          "observationLabel": "Beobachtung",
          "sectionTitle": "Schäden"
        },
        archiveSection: {
          sectionTitle: "MISSING TRANSLATION",
          archiveType: "MISSING TRANSLATION",
          conditioning: "MISSING TRANSLATION",
          cote: "MISSING TRANSLATION",
          descriptionLevel: "MISSING TRANSLATION",
          location: "MISSING TRANSLATION",
          materialImportance: "MISSING TRANSLATION",
          parentArchive: "MISSING TRANSLATION",
          productors: "MISSING TRANSLATION",
          productionDate: "MISSING TRANSLATION",
          proprietaryInstitution: "MISSING TRANSLATION",
          supportType: "MISSING TRANSLATION",
          title: "MISSING TRANSLATION",
        },
        detailedViewsSection: {
          sectionTitle: "Details zum Schäden",
        },
        "finalObservationsSection": {
          "sectionTitle": "Abschlussbemerkungen"
        },
        conditioningSection: {
          crateNumber: "Kassennummer:",
          sectionTitle: "Verpackung",
          transportAccessories: "Zubehör für den Transport:",
          typeOfPackaging: "Art der Verpackung:",
        },
        "contextSection": {
          "comments": "Bemerkungen:",
          "editors": "Redakteure:",
          "matAndTechs": "Material/Technik:",
          "reportDate": "Datum des Protokolls:",
          "reportPlace": "Ort der Protokollerstellung:",
          "reportReason": "Grund der Zustandsbegutachtung:",
          "reportReference": "Referenz-Nr.",
          "reportType": "Art des Protokolls:",
          "sectionTitle": "Kontext der vorliegenden Zustandsbegutachtung",
          signers: "Unterzeichner*in:",
        },
        "reportSection": {
          "counterSignaturesTitle": "Gegenunterschriften",
          counterSignature: {
            comment: 'Kommentar:',
          },
          "interventionsToSchedule": "zu planende Maßnahmen:",
          "sectionTitle": "Bericht",
          "signatoriesTitle": "Zustandsbegutachtung ausgeführt im Beisein von:",
          "stateOfConservation": "Zustand des Guts",
          "treatmentPriority": "Behandlungspriorität"
        },
        "footer": {
          "prefix": "ZUSTANDSPROTOKOLL",
          "separator": "- Seite"
        }
      },
      "entityNames": {
        "conditionReports": "Zustandsprotokolle",
        "items": "Items",
        archives: "MISSING TRANSLATION",
        "auditRecords": "Inventurberichte",
        "audits": "Inventurvorhaben",
        "thesaurusTerms": "Thesaurusbegriffe",
        "thesaurus": "Thesaurus",
        "entityFields": "Systemdaten",
        "collaborators": "Mitarbeiter",
        "authorities": "Personen/Körperschaften",
        "aliases": "Alias",
        "locations": "Standorte",
        "works": "Werk",
        "expressions": "Expression",
        "manifestations": "Manifestation",
        "specimens": "MISSING TRANSLATION"
      },
      "thesaurusTermCreateForm": {
        "formTitle": "Erstellung eines Begriff",
        "openButtonTitle": "einen Begriff erstellen",
        "createButton": "bestätigen",
        "anotherTermButton": "bestätigen und einen weiteren Begriff erstellen",
        "cancelButton": "abbrechen",
        "preferedTermLabel": "bevorzugter Begriff: ",
        "synonymLabel": "genutzt für:",
        "genericTermPlaceholder": "Oberbegriff:",
        "selectSpecificLabel": "spezifische Begriffe auswählen",
        "disabledOffline": "Die Erstellung eines neuen Begriffs ist im Offline-Modus nicht möglich"
      },
      "thesaurusTermTree": {
        "creationTabTitle": "Erstellen",
        errors: {
          searchError: "Die Suche ist fehlgeschlagen",
          fetchError: "Thesaurusbegriffe können nicht abgerufen werden"
        },
        "modalSearchInputPlaceholder": "einen Begriff suchen",
        "selectionTabTitle": "auswählen",
        "thesaurusTermSelectorModalTitle": "Einen Begriff auswählen",
        "validate": "bestätigen"
      },
      "alerts": {
        "permissions": {
          "camera": {
            askForPermission: "SKR-Condition Report benötigt die Erlaubnis, auf die Kamera zuzugreifen. Diese Erlaubnis ist für die Barcode-/QR-Code-Scan-Funktionen erforderlich. Ohne diese Berechtigung können diese Funktionen nicht gewährleistet werden.",
            permissionDeniedWarning: "SKR-Condition Report wurde zuvor die Erlaubnis verweigert, auf die Kamera zuzugreifen. Die Barcode-/QR-Code-Scan-Funktionen sind daher nicht verfügbar. Um darauf zugreifen zu können, erlauben Sie bitte SKR-Condition Report manuell den Zugriff auf die Kamera.",
          }
        },
        "medias": {
          "failUpload": "Das Medium konnte nicht hochgeladen werden",
          "failGetIdFromFileName": "Die Medien wurden hochgeladen, aber Skin-Reporter kann sie nicht finden.",
        },
        "workspace": {
          "unableToChangeWorkspace": "Wechsel des Arbeitsbereichs fehlgeschlagen",
          "unableToLoadWorkspace": "Das Laden des Arbeitsbereichs ist fehlgeschlagen",
        },
      },
      alterationDetailImagePopup: {
        title: "Detailansichten der Veränderung {0}",
      },
      "alterationCard": {
        "moreMenu": {
          "deleteAlteration": "Beschädigung löschen",
          "changeAlterationTitle": "Titel der Beschädigung ändern",
          "changeAlterationType": "Art der Beschädigung ändern",
          "titleModalHeader": "Titel der Beschädigung bearbeiten",
          "titleModalButton": "Bestätigen"
        },
        titleAutoCompletePlaceHolder: "Titel",
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "ihre Zugangsdaten sind fehlerhaft",
            "network": "der Verbindungsaufbau ist fehlgeschlagen"
          },
          "form": {
            "password": {
              "error": "Geben sie ihren Benutzernamen ein",
              "label": "Kennwort"
            },
            "submit": "sich einloggen",
            "submitting": "Verbindungsaufbau…",
            "username": {
              "error": "Geben sie ihr Kennwort ein",
              "label": "Benutzername"
            }
          }
        },
        "renew": {
          "slowNetwork": "Der Verbindungsaufbau dauert länger als gewöhnlich, bitte die Anwendung nicht beenden",
          "spinner": "Wiederverbindung …"
        },
        sso: {
          errors: {
            authenticationFailed: "Fehler: Die Authentifizierung konnte nicht abgeschlossen werden."
          },
          selectIDP: "Sich einloggen mit...",
          otherIDPs: "Andere Arten von Konten",
        },
      },
      "closeReportScreen": {
        "important": "WICHTIG",
        "close": "Abschließen",
        "title": "Zustandsprotokoll abschließen",
        "notificationContent": "Das Zustandsprotokoll '{referenceNumber}' wurde abschlossen, der Status des verknüpften Objekts wurde aktualisiert.",
        "warningMessage": "Ein abgeschlossenes Zustandsprotokoll kann weder geändert noch gelöscht werden",
        "warningQuestion": "Möchten sie das Zustandsprotokoll wirklich abschließen?",
        "transferingFile": "Übertragung des PDF-Dokuments…",
        "fileGeneration": "Erstellung des endgültigen PDF-Dokuments…",
        "reportClosing": "Abschluss des Zustandsprotokolls",
        errors: {
          transitionState: "Beim Abschließen des Statusberichts ist ein Fehler aufgetreten. Die PDF wurde tatsächlich erzeugt und dem Statusbericht hinzugefügt.",
          pushingPDF: "Das Hinzufügen der erzeugten PDF zum Statusbericht ist fehlgeschlagen. Abbruch des Abschlusses.", 
        },
      },
      "editRecordScreen": {
        "foldAll": "alles einklappen",
        "unfoldAll": "alles aufklappen",
        "medias": {
          "accordionPanelTitle": "MEDIEN"
        }
      },
      "firewall": {
        "collabWarningMessage": "Ihr Account hat keinen zugeordneten Mitarbeiter, die Anwendung funktioniert evtl nicht",
        "noGroupForUserWarningMessage": "Die Arbeit mit SKINreporter setzt voraus, dass ihr Benutzerkonto mit einer Benutzergruppe verknüpft ist"
      },
      genericEditScreen: {
        genericErrorMsg: "MISSING TRANSLATION",
        saveErrorMsg: "MISSING TRANSLATION",
        saveSuccessMsg: "MISSING TRANSLATION",
      },
      "listReportScreen": {
        "closed": {
          "downloadFailure": "während des Hochladens ist ein Fehler aufgetreten",
          "downloadSuccess": "das Dokument  {docTitle} wurde hochgeladen",
          "open": "EIN DOKUMENT HOCHLADEN",
          "title": "abgeschlossene Zustandsbegutachtungen"
        },
        "inProgress": {
          "edit": "DAS ZUSTANDSPROTOKOLL BEARBEITEN",
          "title": "Zustandsprotokolle in Bearbeitung"
        },
        "concernedItem": "betreffendes Museumsobjekt",
        "nbResults": "{nbResults} Ergebnisse",
        "noResults": "kein Ergebnis"
      },
      "locationSelector": {
        "inputPlaceholder": "einen Standort eingeben",
        "title": "einen Standort auswählen",
        "validate": "bestätigen"
      },
      "maskFields": {
        "boolean": {
          "no": "Nein",
          "undefined": "nicht definiert",
          "yes": "Ja"
        },
        "entitySelect": {
          "modalPlaceholder": "Schlagworte oder ID"
        }
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "aufgeklappt ...",
          "checkForUpdate": {
            "help": "Falls ein Update verfügbar ist, wird es automatisch installiert.",
            "title": "Updates überprüfen"
          },
          "clearCache": {
            "help": "Sind Sie offline, wird der Zugriff auf alle auf dem Endgerät gespeicherten Daten gelöscht.",
            "title": "Cache leeren"
          },
          "overrideLocale": {
            "help": "Es wird die englische Sprache verwendet und die Einstellung Ihres Endgeräts ignoriert.",
            "title": "Spracheinstellung Englisch erzwingen"
          },
          "resetLocaleOverride": {
            "help": "Die verwendete Sprache hängt von den Einstellungen Ihres Endgeräts ab.",
            "title": "Spracheinstellung zurücksetzen"
          },
          "serviceWorker": {
            help: "Das Update-Banner wird ständig angezeigt? Klicken Sie hier!",
            title: "Schließen Sie das Update-Banner",
          },
          "title": "Skin-REPORTER",
          "version": "version",
        },
        "logout": "Möchten sie sich wirklich abmelden?"
      },
      "offlineRibbon": {
        "offline": "Sie sind offline",
        "online": "Sie sind online"
      },
      "proxy": {
        "error": {
          "default": "bei der Ressource  {uri} ist ein Fehler aufgetreten",
          "network": "keine Verbindung zum Server",
          "notFound": "die Ressource {uri} kann nicht gefunden werden",
          "tokenHasExpired": "ihre Sitzung ist abgelaufen"
        }
      },
      "search": {
        "noResults": "keine Ergebnis",
        "options": {
          "sortType": {
            "creationDate": "Datum des Protokolls",
            "identifier": "Haupt-ID",
            "lastModification": "letzte Änderung",
            "mainTitle": "Haupttitel",
            "referenceNumber": "Referenz-Nr."
          }
        },
        "queryPlaceholder": "Stichwort oder Inv.-Nr.",
        "title": "Museumsobjekt",
        "totalCount": "{totalResults} Ergebnis(se) : 1 -"
      },
      "searchFeaturedCard": {
        "consultLastReport": "LETZTEN ABGESCHLOSSENEN BERICHT ANSEHEN",
        "createNewReport": "EIN NEUES ZUSTANDSPROTOKOLL ERSTELLEN",
        "createNewReportFromLast": "ZUSTANDSPROTOKOLL AUS DEM VORHERIGEN PROTOKOLL",
        "institutionLabel": "Institution",
        "lastReportLabel": "vorherige Zustandsbegutachtung",
        "materialsAndTechniques": "Material/Technik",
        "measurements": "Maße",
        "noLinkedItem": "für dieses Protokoll wurde kein Item gefunden"
      },
      selectItemErrorDialog: {
        cancel: "Objekt abbrechen",
        cancelAll: "Alle Objekte abbrechen",
        description: "Die Auswahl von {0} Objekten ist fehlgeschlagen.",
        retry: "Versuchen Sie es erneut für dieses Objekt",
        retryAll: "Versuchen Sie es erneut für alle Objekte",
        title: "Fehler bei der Auswahl von Bildern",
      },
      "serviceWorker": {
        "updateAvailable": "Es wurde ein Update installiert. Klicken Sie hier, um die Seite neu zu laden oder starten Sie die Anwendung neu.",
        forceServiceWorkerUpdate: {
          modalTitle: "Lösung des Problems",
          versionCorrect: "Entsprechen die unten stehenden Informationen der von SKINsoft nach dem letzten Update übermittelten Version und dem Datum ?",
          yes: "Ja",
          no: "Nein",
        },
      },
      "signatureModuleScreen": {
        "cardTitle": "Unterzeichner",
        "eraseSignature": "Unterschrift wiederholen",
        "missingSignature": "fehlende Unterschrift",
        "nameLabel": "Unterzeichner",
        "positionOfSignatory": "Funktion des Unterzeichners",
        "presentSignature": "vorliegende Unterschrift",
        "saveSignature": "speichern",
        "signatureStatus": "Status der Unterschrift",
        "title": "Unterschriften"
      },
      "synchroModal": {
        "title": "Synchronisation",
        "lastFetch": "letzter Abruf ",
        "duration": "Dauer",
        "status": "Status",
        "details": "Details",
        "lastSynchro": "letzte Synchronisation",
        "noEntityToSync": "keine zu synchronisierenden Entitäten",
        "connectionWarningPrefix": "Sie müssen mit dem Internet verbunden sein, um zu",
        "connectWarningSend": "senden",
        "connectWarningRetrieve": "wiederherstellen",
        "connectionWarningSuffix": "von Daten",
        "noDataToSync": "aktuell keine zu synchronisierende Angabe",
        "localIconInfoPrefix": "Das Icon",
        "localIconInfoSuffix": "gibt an, dass die entsprechenden Daten lokal geändert wurden und mit der festgelegten Datenbank synchronisiert werden müssen.",
        "retrieveAll": "alles wiederherstellen",
        "finishedSynchros": "Abgeschlossene Synchronisationen ",
        "syncAll": "alles synchronisieren",
        "remainsToSynchronize": "noch zu synchronisieren",
        "cleanImageCache": "Geisterbilder des Cache löschen",
        "cachedImagedCleaned": "die Geisterbilder sind gelöscht worden!",
        "cleanCacheDown": "Cache leeren",
        "cacheDownCleaned": "der Cache wurde geleert",
        "cleanCacheUp": "alle nicht synchronisierten Änderungen löschen",
        "cacheUpCleaned": "alle nicht synchronisierten Änderungen sind gelöscht worden"
      },
      "time": {
        "hours": "Stunde(n)",
        "minutes": "Minute(n)",
        "seconds": "Sekunde(n)"
      },
      uploadImageFailureDialog: {
        cancel: "Bild {0} abbrechen",
        cancelAll: "Alle Bilder abbrechen",
        description: "Das Hochladen von {0} Bildern ist fehlgeschlagen.",
        imageAndNumber: "Bild {0}",
        retry: "Erneut versuchen für Bild {0}",
        retryAll: "Erneut versuchen für alle Bilder",
        title: "Fehler beim Hochladen von Bildern",
      },
      "state": {
        "all": "alle",
        "archived": "archiviert",
        "canceled": "abgebrochen",
        "finalized": "beendet",
        "inPreparation": "in Vorbereitung",
        "inProgress": "in Arbeit",
        "programmed": "geplant",
        "toValidated": "zu bestätigen",
        "validated": "bestätigt",
        "aborted": "unterbrochen",
        "success": "erfolgreich beendet",
        "error": "Fehler",
        "none": "keine vorhergehende Synchronisation"
      },
      "SpecimenSearchScreen": {
        "createNewSpecimen": "MISSING TRANSLATION"
      },
    },
    "se": {
      "countryCode": "se",
      "alerts": {
        "medias": {
          "failUpload": "Misslyckades med att ladda upp media",
          "failGetIdFromFileName": "Medierna har laddats upp, men Skin-Reporter kan inte hitta dem",
        },
        "permissions": {
          "camera": {
            askForPermission: "MISSING TRANSLATION",
            permissionDeniedWarning: "MISSING TRANSLATION",
          }
        },
        "workspace": {
          "unableToChangeWorkspace": "MISSING TRANSLATION",
          "unableToLoadWorkspace": "MISSING TRANSLATION",
        },
      },
      archiveCrEditScreenHeader: {
        materialImportance: "MISSING TRANSLATION",
        principalMediumType: "MISSING TRANSLATION",
      },
      archiveEditScreen: {
        saveAlert: {
          errorMessage: "MISSING TRANSLATION",
          successMessage: "MISSING TRANSLATION",
        },
      },
      archiveEditScreenHeader: {
        cote: "MISSING TRANSLATION",
        descriptionLevel: "MISSING TRANSLATION",
      },
      archiveSearchScreen: {
        createNewArchive: "MISSING TRANSLATION",
      },
      auth: {
        sso: {
          errors: {
            authenticationFailed: "Fel: Det gick inte att slutföra autentiseringen."
          },
          selectIDP: "Autentisera med...",
          otherIDPs: "Andra typer av konton",
        },
      },
      autoCompleteTextField: {
        modal: {
          okButton: "MISSING TRANSLATION",
        },
      },
      cameraScanner: {
          scanCode: "MISSING TRANSLATION",
          cancel: "MISSING TRANSLATION",
          errors: {
            cameraNotFound: "MISSING TRANSLATION",
          },
      },
      closeReportScreen: {
        notificationContent: "'{referenceNumber}'-utlåtandet har avslutats och statusen för det länkade objektet har uppdaterats.",
        errors: {
          transitionState: "Ett fel inträffade när rapporten stängdes. PDF-filen skapades och lades till i statusrapporten.",
          pushingPDF: "Den genererade PDF-filen lades inte till i statusrapporten. Avslutningen avbröts.", 
        },
      },
      counterSignatureModuleScreen: {
        title: "MISSING TRANSLATION",
        saveButton: "MISSING TRANSLATION",
        warnings: {
          exit: 'MISSING TRANSLATION',
          okButton: 'MISSING TRANSLATION',
          cancelButton: 'MISSING TRANSLATION',
          save: 'MISSING TRANSLATION',
        },
      },
      createArchiveModal: {
        creationFailed: "MISSING TRANSLATION",
        descriptionLevel: "MISSING TRANSLATION",
        submitBtn: "MISSING TRANSLATION",
        submitting: "MISSING TRANSLATION",
        title: "MISSING TRANSLATION",
      },
      editReportScreen: {
        "alerts": {
          duplicateClosedReport: {
            success: "MISSING TRANSLATION",
            failure: "MISSING TRANSLATION",
            warningReportNotClosed: "MISSING TRANSLATION",
          }
        },
        "alterations": {
          "mediasSectionTitle": "MISSING TRANSLATION",
          "globalAlterationSectionTitle": "MISSING TRANSLATION",
          "createAlterationForm": {
            "createAlterationButtonTitle": "MISSING TRANSLATION",
            "alterationTypeLabel": "MISSING TRANSLATION",
            "precisionLabel": "MISSING TRANSLATION"
          },
          "accordionPanelTitle": "MISSING TRANSLATION",
          "tabTitle": "MISSING TRANSLATION",
          "viewMenu": {
            "alterationTypeView": "MISSING TRANSLATION",
            "imageView": "MISSING TRANSLATION",
            "titleView": "MISSING TRANSLATION"
          }
        },
        observations: {
          "tabTitle": "MISSING TRANSLATION",
          "accordionPanelTitle": "MISSING TRANSLATION",
          "commentsFieldLabel": "MISSING TRANSLATION",
          "countersignature": "MISSING TRANSLATION",
          "interventionToSchedule": "MISSING TRANSLATION",
          "interventionToSchedulePlaceholder": "MISSING TRANSLATION",
          "interventionToSchedulePrecision": "MISSING TRANSLATION",
          "stateOfConservation": "MISSING TRANSLATION",
          "stateOfConservationPlaceholder": "MISSING TRANSLATION",
          "signature": "MISSING TRANSLATION",
          "typeOfStateOfConservation": "MISSING TRANSLATION",
          "treatmentPriority": "MISSING TRANSLATION",
          "treatmentPriorityPlaceholder": "MISSING TRANSLATION"
        },
        "reportTitlePrefix": "MISSING TRANSLATION",
        "reportStatusInProgress": "MISSING TRANSLATION",
        "reportIdentifiers": {
          "accordionPanelTitle": "MISSING TRANSLATION",
          "referenceNumber": "MISSING TRANSLATION",
          "numberingInformation": "MISSING TRANSLATION",
          "otherIdentifiers": "MISSING TRANSLATION",
          "reportReason": "MISSING TRANSLATION",
          "precision": "MISSING TRANSLATION",
          "reportType": "MISSING TRANSLATION",
          "reportTypePlaceholder": "MISSING TRANSLATION",
          "tabTitle": "MISSING TRANSLATION"
        },
        "reportContext": {
          "accordionPanelTitle": "MISSING TRANSLATION",
          "reportDate": "MISSING TRANSLATION",
          "reportDoneInThePresenceOf": "MISSING TRANSLATION",
          "andOf": "MISSING TRANSLATION",
          "name": "MISSING TRANSLATION",
          "role": "MISSING TRANSLATION",
          "coordinates": "MISSING TRANSLATION",
          "email": "MISSING TRANSLATION",
          "signer": "MISSING TRANSLATION",
          "reportPlace": "MISSING TRANSLATION",
          "customer": "MISSING TRANSLATION",
          "precisions": "MISSING TRANSLATION",
          "linkedProject": "MISSING TRANSLATION",
          "linkedMovement": "MISSING TRANSLATION",
          "technicsAndMaterials": "MISSING TRANSLATION",
          "comments": "MISSING TRANSLATION",
          "signerComponent": {
            "name": "Undertecknare",
            "date": "Datum för underskrift",
            "positionOfSignatory": "Position för firmatecknare",
            "title": "Undertecknare",
          },
          counterSignatureComponent: {
            comment: "MISSING TRANSLATION",
            location: "MISSING TRANSLATION",
            reason: "MISSING TRANSLATION",
            date: "MISSING TRANSLATION",
          },
          counterSignaturesComponent: {
            title: "MISSING TRANSLATION",
          },
          "counterSignerComponent": {
            "name": "Efternamn/Förnamn",
            "function": "Funktion",
            signature: 'Underskrift',
          },
          counterSignersComponent: {
            title: "MISSING TRANSLATION",
          },
        },
        pdf: {
          counterSignaturePDF: {
            startGenerating: "MISSING TRANSLATION",
            success: "MISSING TRANSLATION",
            failure: "MISSING TRANSLATION",
          }
        },
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Distribuerad den",
          "checkForUpdate": {
            "help": "MISSING TRANSLATION",
            "title": "MISSING TRANSLATION"
          },
          "clearCache": {
            "help": "MISSING TRANSLATION",
            "title": "MISSING TRANSLATION"
          },
          "overrideLocale": {
            "help": "MISSING TRANSLATION",
            "title": "MISSING TRANSLATION"
          },
          "resetLocaleOverride": {
            "help": "MISSING TRANSLATION",
            "title": "MISSING TRANSLATION"
          },
          "serviceWorker": {
            help: "Visas uppdateringsbannern kontinuerligt? Klicka här!",
            title: "Stäng uppdateringsbannern",
          },
          "title": "Skin-REPORTER",
          "version": "version",
        },
        "logout": "MISSING TRANSLATION"
      },
      pdfDocument: {
        archiveSection: {
          sectionTitle: "MISSING TRANSLATION",
          archiveType: "MISSING TRANSLATION",
          conditioning: "MISSING TRANSLATION",
          cote: "MISSING TRANSLATION",
          descriptionLevel: "MISSING TRANSLATION",
          location: "MISSING TRANSLATION",
          materialImportance: "MISSING TRANSLATION",
          parentArchive: "MISSING TRANSLATION",
          productors: "MISSING TRANSLATION",
          productionDate: "MISSING TRANSLATION",
          proprietaryInstitution: "MISSING TRANSLATION",
          supportType: "MISSING TRANSLATION",
          title: "MISSING TRANSLATION",
        },
        conditioningSection: {
          crateNumber: "Nummer för kassaregister:",
          sectionTitle: "Förpackning",
          transportAccessories: "Tillbehör för transport:",
          typeOfPackaging: "Typ av förpackning:",
        },
        contextSection: {
          editors: "Redaktörer:",
          signers: "Undertecknare:",
        },
        "objectSection": {
          "sectionTitle": "MISSING TRANSLATION",
          "inventoryNumber": "MISSING TRANSLATION",
          "title": "MISSING TRANSLATION",
          "author": "MISSING TRANSLATION",
          "creationDate": "MISSING TRANSLATION",
          "typology": "MISSING TRANSLATION",
          "denomination": "MISSING TRANSLATION",
          "materialsAndTechniques": "MISSING TRANSLATION",
          "dimensions": "MISSING TRANSLATION",
          "institution": "MISSING TRANSLATION",
          conditioning: "Förpackning:",
          descriptions: "Beskrivning(ar):",
          domains: "Domän:",
          identification: "Identifiering:",
          location: "Läge:",
          materials: "Material:",
          ownerInstitutions: "Ägande institution(er):",
          techniques: "Tekniker:",
        },
        detailedViewsSection: {
          sectionTitle: "MISSING TRANSLATION",
        },
      },
      "searchFeaturedCard": {
        "consultLastReport": "SE DEN SENAST AVSLUTADE RAPPORTEN",
        "createNewReport": "MISSING TRANSLATION",
        "createNewReportFromLast": "MISSING TRANSLATION",
        "institutionLabel": "MISSING TRANSLATION",
        "lastReportLabel": "MISSING TRANSLATION",
        "materialsAndTechniques": "MISSING TRANSLATION",
        "measurements": "MISSING TRANSLATION",
        "noLinkedItem": "MISSING TRANSLATION"
      },
      selectItemErrorDialog: {
        cancel: "MISSING TRANSLATION",
        cancelAll: "MISSING TRANSLATION",
        description: "MISSING TRANSLATION",
        retry: "MISSING TRANSLATION",
        retryAll: "MISSING TRANSLATION",
        title: "MISSING TRANSLATION",
      },
      "serviceWorker": {
        "updateAvailable": "MISSING TRANSLATION",
        forceServiceWorkerUpdate: {
          modalTitle: "MISSING TRANSLATION",
          versionCorrect: "Stämmer informationen nedan överens med versionen och datumet som tillhandahållits av SKINsoft efter den senaste uppdateringen?",
          yes: "MISSING TRANSLATION",
          no: "MISSING TRANSLATION",
        },
      },
      "signatureModuleScreen": {
        "cardTitle": "MISSING TRANSLATION",
        "eraseSignature": "MISSING TRANSLATION",
        "missingSignature": "MISSING TRANSLATION",
        "nameLabel": "Undertecknare",
        "positionOfSignatory": "Position för firmatecknare",
        "presentSignature": "MISSING TRANSLATION",
        "saveSignature": "MISSING TRANSLATION",
        "signatureStatus": "MISSING TRANSLATION",
        "title": "MISSING TRANSLATION"
      },
      "thesaurusTermTree": {
        "creationTabTitle": "MISSING TRANSLATION",
        errors: {
          searchError: "Sökningen var resultatlös",
          fetchError: "Det gick inte att hämta thesaurus-termer"
        },
        "modalSearchInputPlaceholder": "MISSING TRANSLATION",
        "selectionTabTitle": "MISSING TRANSLATION",
        "thesaurusTermSelectorModalTitle": "MISSING TRANSLATION",
        "validate": "MISSING TRANSLATION"
      },
      uploadImageFailureDialog: {
        cancel: "MISSING TRANSLATION",
        cancelAll: "MISSING TRANSLATION",
        description: "MISSING TRANSLATION",
        imageAndNumber: "MISSING TRANSLATION",
        retry: "MISSING TRANSLATION",
        retryAll: "MISSING TRANSLATION",
        title: "MISSING TRANSLATION",
      },
      "SpecimenSearchScreen": {
        "createNewSpecimen": "MISSING TRANSLATION"
      },
    },
}

export const dateTimeFormats = {
  en: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  "en-us": {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  fr: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  "fr-ca": {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  nl: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  es: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  it: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  no: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  de: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  se: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
}
